"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("../..");
const blamelog_1 = require("../../blamelog");
const cases_1 = require("../../cases");
const cases_2 = require("../../cases");
const collectors_1 = require("../../collectors");
const connections_1 = require("../../connect/connections");
const mappings_1 = require("../../connect/mappings");
const products_1 = require("../../connect/products");
const court_1 = require("../../court");
const auto_submit_1 = require("../../court/auto-submit");
const creditor_1 = require("../../creditor");
const customers_1 = require("../../customers");
const debt_register_1 = require("../../debt-register");
const documents_1 = require("../../documents");
const economy_1 = require("../../economy");
const organize_1 = require("../../economy/billing/organize");
const billing_appendix_setups_1 = require("../../economy/billing-appendix-setups");
const case_vouchers_1 = require("../../economy/case-vouchers");
const payment_plans_1 = require("../../economy/payment-plans");
const payouts_1 = require("../../economy/payouts");
const vouchers_1 = require("../../economy/vouchers");
const embeds_1 = require("../../embeds");
const types_1 = require("../../imports/types");
const aggregations_1 = require("../../insights/aggregations");
const bulk_actions_1 = require("../../insights/bulk-actions");
const intents_1 = require("../../intents");
const interactions_1 = require("../../interactions");
const performed_by_1 = require("../../performed-by");
const procedures_1 = require("../../procedures");
const templates_1 = require("../../templates");
const tenants_1 = require("../../tenants");
const types_2 = require("../../tribunal/cases/types");
const types_3 = require("../../tribunal/jobs/types");
const updates_1 = require("../../updates");
const voucher_applications_1 = require("../../voucher-applications");
const workflows_1 = require("../../workflows");
const insights_1 = require("../../insights");
exports.default = {
    is: {
        currently: 'en',
    },
    langs: {
        en: 'English',
        da: 'Danish',
        sv: 'Swedish',
        no: 'Norwegian',
        fi: 'Finnish',
        nl: 'Dutch',
        de: 'German',
        fr: 'French',
        es: 'Spanish',
        cs: 'Czech',
        el: 'Greek',
    },
    changelogs: {
        bookDemo: 'Get an online demo',
        close: 'Close',
        changelog: 'Changelog',
    },
    tribunalCaseTypes: {
        [types_2.TribunalCaseType.DKBetalingspaakrav]: '🇩🇰 Bailiff claim form (Betalingspåkrav)',
        [types_2.TribunalCaseType.DKFogedrekvisition]: '🇩🇰 Bailiff court request (fogedrekvisition)',
        [types_2.TribunalCaseType.GLStaevning]: '🇬🇱 Stævning',
        [types_2.TribunalCaseType.GLFogedBegaering]: '🇬🇱 Fogedbegæring',
    },
    tribunalCaseStatuses: {
        [types_2.TribunalCaseStatus.Created]: 'Created',
        [types_2.TribunalCaseStatus.Awaiting1Paategning]: 'Awaiting "1.-påtegning"',
        [types_2.TribunalCaseStatus.ClosedBecauseOfObjection]: 'Closed - opposition',
        [types_2.TribunalCaseStatus.Closed]: 'Ended',
        [types_2.TribunalCaseStatus.Awaiting2Paategning]: 'Awaiting "2.-påtegning"',
        [types_2.TribunalCaseStatus.AwaitingBailiffMeeting]: 'Awaiting meeting',
        [types_2.TribunalCaseStatus.AwaitingNoticeForBailiffMeeting]: 'Awaiting meeting notice',
        [types_2.TribunalCaseStatus.AwaitingVerdict]: 'Awaiting verdict',
        [types_2.TribunalCaseStatus.AwaitingNoticeForFogedmoede]: 'Awaiting invitation',
        [types_2.TribunalCaseStatus.AwaitingFogedmoede]: 'Awaiting meeting',
    },
    tribunalJobTypes: {
        [types_3.TribunalJobType.CreateBetalingspaakrav]: 'Create bailiffs court case',
        [types_3.TribunalJobType.ResendBetalingspaakrav]: 'Resending of bailiffs court case',
        [types_3.TribunalJobType.Register1Paategning]: 'Registering "1.-påtegning"',
        [types_3.TribunalJobType.ClosedObjection]: 'Closed after 1.-påtegning due to opposition',
        [types_3.TribunalJobType.Register2Paategning]: 'Registering "2.-påtegning"',
        [types_3.TribunalJobType.CreateFogedrekvisition]: 'Create "fogedrekvisition"',
        [types_3.TribunalJobType.RegisterInsolvency]: 'Register insolvency',
        [types_3.TribunalJobType.RegisterPolicePresentation]: 'Register police presentation',
        [types_3.TribunalJobType.CreateStaevning]: 'Create stævning',
        [types_3.TribunalJobType.RegisterVerdict]: 'Verdict registered',
        [types_3.TribunalJobType.ResendStaevning]: 'Resending of stævning',
        [types_3.TribunalJobType.CreateFogedbegaering]: 'Create fogedbegæring',
        [types_3.TribunalJobType.ResendFogedbegaering]: 'Resending of fogedbegæring',
        [types_3.TribunalJobType.RegisterInsolvens]: 'Register insolvency',
        [types_3.TribunalJobType.CourtMeeting]: 'Court meeting',
        [types_3.TribunalJobType.Distraint]: 'Distraint',
    },
    distraintType: {
        [types_3.DistraintType.Property]: 'Real estate',
        [types_3.DistraintType.Vehicle]: 'Vehicle',
        [types_3.DistraintType.RentDepositum]: 'Deposit in rental property',
        [types_3.DistraintType.CooperativeHousing]: 'Cooporative housing',
        [types_3.DistraintType.Diverse]: 'Diverse',
        [types_3.DistraintType.MorgageDeed]: 'Morgage deed',
        [types_3.DistraintType.WithheldTax]: 'Withheld tax',
    },
    tenantStatus: {
        [tenants_1.TenantStatus.Active]: 'Active',
        [tenants_1.TenantStatus.Demo]: 'Demo',
        [tenants_1.TenantStatus.Disabled]: 'Disabled',
        [tenants_1.TenantStatus.GettingStarted]: 'Awaiting go live',
        [tenants_1.TenantStatus.Sandbox]: 'Sandbox',
    },
    tenantStatusPlural: {
        [tenants_1.TenantStatus.Active]: 'Active',
        [tenants_1.TenantStatus.Demo]: 'Demos',
        [tenants_1.TenantStatus.Disabled]: 'Disabled',
        [tenants_1.TenantStatus.GettingStarted]: 'Awaiting go live',
        [tenants_1.TenantStatus.Sandbox]: 'Sandboxes',
    },
    tenantBillingUnits: {
        "Concatenated SMS'": "Concatenated SMS'",
        'Min.': 'Min.',
        'Pcs.': 'Pcs.',
    },
    tenantBilling: {
        invoices: 'Invoices',
        invoice: 'Invoice',
        noInvoicesYet: 'No invoices to show',
        backToTenantBilling: 'Back to billing',
    },
    tenantSKU: {
        [tenants_1.SKU.DomesticSMS]: 'SMS domestic',
        [tenants_1.SKU.InternationalSMS]: 'SMS international',
        [tenants_1.SKU.DomesticAutoCall]: 'Automatic call domestic',
        [tenants_1.SKU.InternationalAutoCall]: 'Automatic call international',
        [tenants_1.SKU.DomesticLetter]: 'Letter domestic',
        [tenants_1.SKU.InternationalLetter]: 'Letter international',
        [tenants_1.SKU.ReturnLetter]: 'Return letter',
        [tenants_1.SKU.DigitalSignature]: 'Digital signature',
        [tenants_1.SKU.PhoneLookup]: 'Phone number lookup',
        [tenants_1.SKU.EmailLookup]: 'Email lookup',
        [tenants_1.SKU.CaseCreation]: 'Case creation',
        [tenants_1.SKU.MigratedCaseCreation]: 'Migrated case creation',
        [tenants_1.SKU.MonthlyBaseFee]: 'Monthly license fee',
        [tenants_1.SKU.EBoks]: 'e-Boks message',
        [tenants_1.SKU.NemId]: 'NemId validation',
        [tenants_1.SKU.MitID]: 'MitID validation',
        [tenants_1.SKU.FreezingSystemSignOn]: 'Freezing system sign on',
        [tenants_1.SKU.FreezingSystemSignOff]: 'Freezing system sign off',
        [tenants_1.SKU.Consultancy]: 'Consultancy',
    },
    economyCategories: {
        [vouchers_1.VoucherCategory.DISBURSEMENT]: 'Disbursement',
        [vouchers_1.VoucherCategory.FEE]: 'Fee',
        [vouchers_1.VoucherCategory.COLLECTIONCOMMISSION]: 'Collection commission',
        [vouchers_1.VoucherCategory.OVERPAYMENT]: 'Overpayment',
        [vouchers_1.VoucherCategory.PAYOUT]: 'Payout',
        [vouchers_1.VoucherCategory.VAT]: 'Vat',
        [vouchers_1.VoucherCategory.TRANSACTION]: 'Transaction',
        [vouchers_1.VoucherCategory.COST]: 'Cost',
        [vouchers_1.VoucherCategory.COURTCOST]: 'Court cost',
        [vouchers_1.VoucherCategory.INTEREST]: 'Interest',
        [vouchers_1.VoucherCategory.PRINCIPAL]: 'Principal',
    },
    pluralEconomyVoucherTypeLabels: {
        [vouchers_1.VoucherTypeIds.PRINCIPAL]: 'Principals',
        [vouchers_1.VoucherTypeIds.INVOICE]: 'Invoices',
        [vouchers_1.VoucherTypeIds.ONACCOUNTINVOICE]: 'On account invoices',
        [vouchers_1.VoucherTypeIds.DOM]: 'Verdict',
        [vouchers_1.VoucherTypeIds.FINALINVOICE]: 'Final settlements',
        [vouchers_1.VoucherTypeIds.CONTROLFEE]: 'Control fees',
        [vouchers_1.VoucherTypeIds.ADMINISTRATIONCOST]: 'Administration costs',
        [vouchers_1.VoucherTypeIds.CREDITNOTE]: 'Credit notes',
        [vouchers_1.VoucherTypeIds.YEARLYINTEREST]: 'Yearly interests',
        [vouchers_1.VoucherTypeIds.PROCESSINTEREST]: 'Interests',
        [vouchers_1.VoucherTypeIds.GLPROCESSINTEREST]: 'Interests (GL)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Compound interests (daily capitalization)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Compound interests (monthly capitalization)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Compound interests (quarterly capitalization)',
        [vouchers_1.VoucherTypeIds.REMINDERFEE]: 'Reminder fees',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOST]: 'Collection costs',
        [vouchers_1.VoucherTypeIds.COLLECTIONFEE]: 'Collection fees',
        [vouchers_1.VoucherTypeIds.BAILIFFSFEE]: 'Bailiffs Fees',
        [vouchers_1.VoucherTypeIds.WRITFEE]: 'Writ fees',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Court claim costs without civil court',
        [vouchers_1.VoucherTypeIds.COURTCLAIMSALARY]: 'Court claim salaries',
        [vouchers_1.VoucherTypeIds.BAILIFSSALARY]: 'Bailiffs salaries',
        [vouchers_1.VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Bailiff requisition fees',
        [vouchers_1.VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Police presentation fees',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Court claim costs with bailiffs court',
        [vouchers_1.VoucherTypeIds.WRITSALARY]: 'Writ salaries',
        [vouchers_1.VoucherTypeIds.COMPENSATIONCOST]: 'Compensation costs',
        [vouchers_1.VoucherTypeIds.Folkeregisteropslag]: 'Population register lookup',
        [vouchers_1.VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Intellectual property cases',
        [vouchers_1.VoucherTypeIds.CIVILCOURTCOST]: 'Civil court costs',
        [vouchers_1.VoucherTypeIds.DEPOSIT]: 'Deposits',
        [vouchers_1.VoucherTypeIds.WITHDRAWAL]: 'Withdrawals',
        [vouchers_1.VoucherTypeIds.OVERPAYMENT]: 'Overpayments',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSION]: 'Collection commissions',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Collection commissions (surveillance)',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Collection commissions (creditor deposit)',
        [vouchers_1.VoucherTypeIds.JURIDISKBISTAND]: 'Legal counsels',
        [vouchers_1.VoucherTypeIds.ENDCASEFEE]: 'End of case fees',
        [vouchers_1.VoucherTypeIds.STARTCASEFEE]: 'Start of case fees',
        [vouchers_1.VoucherTypeIds.BPKFEE]: 'BPK fees',
        [vouchers_1.VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisitions fees',
        [vouchers_1.VoucherTypeIds.RKIREGISTRATIONFEE]: 'RKI-registration fees',
        [vouchers_1.VoucherTypeIds.BPKDISBURSEMENT]: 'Writ disbursements',
        [vouchers_1.VoucherTypeIds.POLICEDISBURSEMENT]: 'Police presentation disbursements',
        [vouchers_1.VoucherTypeIds.FOGEDDISBURSEMENT]: 'Bailiff requisition disbursements',
        [vouchers_1.VoucherTypeIds.VAT]: 'VAT',
        [vouchers_1.VoucherTypeIds.GAELDSBREV]: 'Loan',
        [vouchers_1.VoucherTypeIds.SETTLEMENT]: 'Settlements',
        [vouchers_1.VoucherTypeIds.FIXEDINTEREST]: 'Fast rente',
        [vouchers_1.VoucherTypeIds.UDTRAEKSGEBYR]: 'Udtræksgebyrer',
        [vouchers_1.VoucherTypeIds.DEPOSITPAYOUT]: 'Payouts of deposit',
        [vouchers_1.VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkeregisteropslag',
        [vouchers_1.VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmeldelse af krav',
        [vouchers_1.VoucherTypeIds.MeetingFee]: 'Meeting fees',
        [vouchers_1.VoucherTypeIds.STAEVNINGSGEBYR]: 'Writ fee',
        [vouchers_1.VoucherTypeIds.BERAMMELSESAFGIFT]: 'Appointment fee',
        [vouchers_1.VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Aflysning af udlæg',
        [vouchers_1.VoucherTypeIds.LOCKSMITHFEE]: 'Locksmith fee',
        [vouchers_1.VoucherTypeIds.DRIVINGFEE]: 'Driving costs',
        [vouchers_1.VoucherTypeIds.OTHERFEE]: 'Other costs',
        [vouchers_1.VoucherTypeIds.REFUND]: 'Refunds',
    },
    economyVoucherTypeLabels: {
        [vouchers_1.VoucherTypeIds.PRINCIPAL]: 'Principal',
        [vouchers_1.VoucherTypeIds.INVOICE]: 'Invoice',
        [vouchers_1.VoucherTypeIds.ONACCOUNTINVOICE]: 'On account invoice',
        [vouchers_1.VoucherTypeIds.DOM]: 'Verdict',
        [vouchers_1.VoucherTypeIds.FINALINVOICE]: 'Final settlement',
        [vouchers_1.VoucherTypeIds.CONTROLFEE]: 'Control fee',
        [vouchers_1.VoucherTypeIds.ADMINISTRATIONCOST]: 'Administration cost',
        [vouchers_1.VoucherTypeIds.CREDITNOTE]: 'Credit note',
        [vouchers_1.VoucherTypeIds.YEARLYINTEREST]: 'Yearly interest',
        [vouchers_1.VoucherTypeIds.PROCESSINTEREST]: 'Interest',
        [vouchers_1.VoucherTypeIds.GLPROCESSINTEREST]: 'Interest (GL)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Compound interest (daily compounding)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Compound interest (monthly compounding)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Compound interest (quarterly compounding)',
        [vouchers_1.VoucherTypeIds.REMINDERFEE]: 'Reminder fee',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOST]: 'Collection cost',
        [vouchers_1.VoucherTypeIds.COLLECTIONFEE]: 'Collection fee',
        [vouchers_1.VoucherTypeIds.COMPENSATIONCOST]: 'Compensation cost',
        [vouchers_1.VoucherTypeIds.Folkeregisteropslag]: 'Population register lookup',
        [vouchers_1.VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Intellectual property cases',
        [vouchers_1.VoucherTypeIds.DEPOSIT]: 'Deposit',
        [vouchers_1.VoucherTypeIds.WITHDRAWAL]: 'Withdrawal',
        [vouchers_1.VoucherTypeIds.OVERPAYMENT]: 'Overpayment',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSION]: 'Collection commission',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Collection commission (surveillance)',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Collection commission (creditor deposit)',
        [vouchers_1.VoucherTypeIds.JURIDISKBISTAND]: 'Legal counsel',
        [vouchers_1.VoucherTypeIds.ENDCASEFEE]: 'End of case fee',
        [vouchers_1.VoucherTypeIds.STARTCASEFEE]: 'Start of case fee',
        [vouchers_1.VoucherTypeIds.BPKFEE]: 'BPK fee',
        [vouchers_1.VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisitions fee',
        [vouchers_1.VoucherTypeIds.RKIREGISTRATIONFEE]: 'RKI-registration fee',
        [vouchers_1.VoucherTypeIds.BPKDISBURSEMENT]: 'Writ disbursement',
        [vouchers_1.VoucherTypeIds.POLICEDISBURSEMENT]: 'Police presentation disbursement',
        [vouchers_1.VoucherTypeIds.FOGEDDISBURSEMENT]: 'Bailiff requisition disbursement',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Court claim cost without civil court',
        [vouchers_1.VoucherTypeIds.COURTCLAIMSALARY]: 'Court claim salary',
        [vouchers_1.VoucherTypeIds.VAT]: 'VAT',
        [vouchers_1.VoucherTypeIds.BAILIFFSFEE]: 'Bailiffs fee',
        [vouchers_1.VoucherTypeIds.BAILIFSSALARY]: 'Bailiffs salary',
        [vouchers_1.VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Police presentation fee',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Retsgebyr med fogedretten',
        [vouchers_1.VoucherTypeIds.CIVILCOURTCOST]: 'Omkostning til civilretten',
        [vouchers_1.VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Bailiff requisition fee',
        [vouchers_1.VoucherTypeIds.WRITFEE]: 'Writ fee',
        [vouchers_1.VoucherTypeIds.WRITSALARY]: 'Writ salary',
        [vouchers_1.VoucherTypeIds.GAELDSBREV]: 'Loan',
        [vouchers_1.VoucherTypeIds.SETTLEMENT]: 'Settlement',
        [vouchers_1.VoucherTypeIds.FIXEDINTEREST]: 'Fast rente',
        [vouchers_1.VoucherTypeIds.UDTRAEKSGEBYR]: 'Udtræksgebyr',
        [vouchers_1.VoucherTypeIds.DEPOSITPAYOUT]: 'Payout of deposit',
        [vouchers_1.VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkeregisteropslag',
        [vouchers_1.VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmeldelse af krav',
        [vouchers_1.VoucherTypeIds.MeetingFee]: 'Meeting fee',
        [vouchers_1.VoucherTypeIds.STAEVNINGSGEBYR]: 'Writ fee',
        [vouchers_1.VoucherTypeIds.BERAMMELSESAFGIFT]: 'Appointment fee',
        [vouchers_1.VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Aflysning af udlæg',
        [vouchers_1.VoucherTypeIds.LOCKSMITHFEE]: 'Lock smith fee',
        [vouchers_1.VoucherTypeIds.DRIVINGFEE]: 'Driving costs',
        [vouchers_1.VoucherTypeIds.OTHERFEE]: 'Other fee',
        [vouchers_1.VoucherTypeIds.REFUND]: 'Refunds',
    },
    connectionReasons: {
        someoneAddedTheFollowingVouchers: 'added the following voucher(s)',
        addedTheFollowingVouchers: 'The following voucher(s) was added',
        someoneDeletedTheFollowingVouchers: 'deleted the following voucher(s)',
        deletedTheFollowingVouchers: 'The following voucher(s) was deleted',
        thatResultedIn: 'That resulted in this billing',
    },
    economyDownloadPostings: {
        postingReference: 'Appendix id',
        creditorReference: 'Creditor reference',
        transactionId: 'Transaction ID',
        type: 'Type',
        ofVoucher: 'Of voucher',
        date: 'Date',
        currency: 'Currency',
        amount: 'Amount',
        accountType: 'Account type',
        account: 'Account',
    },
    systemTankHandles: {
        DEPOSITS: 'Deposits',
    },
    billingModels: {
        name: 'Name',
        preventNegativeCreditorBalance: 'Prevent negative creditor balance',
        selectVouchersGroup: 'Select vouchers',
        systemConnector: 'System billing model',
        tenantConnector: 'Created billing model',
        voucherCategory: 'Voucher category',
        voucherType: 'Voucher type',
        allVouchers: 'All vouchers',
        categoriesOrTypesFilter: 'Select vouchers to be billed',
        caseTagFilter: 'Filter cases',
        caseTagSurveillanceFilter: 'Surveillance only',
        caseTagCompanyFilter: 'Company cases only',
        caseTagPrivateFilter: 'Private cases only',
        voucherTagFilter: 'Bill by imposed by',
        imposedByCollector: 'Imposed by collector',
        imposedByCreditor: 'Imposed by creditor',
        feeFraction: 'Bill a fraction of the voucher',
        feeFractionPlaceholder: 'Fraction of the voucher',
        addShare: 'Add another billing filter',
        byVoucherCategory: 'By voucher category',
        byVoucherType: 'By voucher type',
        createBillingModel: 'Create billing model',
        simulateBilling: 'Simulate billing',
        simulateCompany: 'Simulate a company',
        simulateSurveillance: 'Simulate surveillance',
        simulateAmount: 'Amount of deposit',
        previewBillingModel: 'Preview billing model',
        selectBillingModel: 'Select billing model',
    },
    billingAppendixSetups: {
        tenantBillingAppendixSetup: 'System setup',
        systemBillingAppendixSetup: 'Created setup',
        name: 'Name',
        billingAppendixSetups: 'Billing appendix setups',
        noBillingAppendixSetupsToShow: 'No setups to show',
        newBillingAppendixSetup: 'New billing appendix setup',
        addBillingAppendixSetup: 'Create billing appendix setup',
        billing: 'Bill',
        createNew: 'Create setup',
        addNewSetup: 'Add setup',
        appendixHandle: 'Appendix name',
        selectBillingAppendixSetup: 'Select billing appendix setup',
        previewBillingAppendixSetup: 'Preview billing appendix setup',
    },
    billingAppendixSetupTimings: {
        [billing_appendix_setups_1.Timing.Manual]: 'Manual billing',
        [billing_appendix_setups_1.Timing.ASAP]: 'Daily',
        [billing_appendix_setups_1.Timing.OnCaseEnd]: 'After case end',
        [billing_appendix_setups_1.Timing.Weekly]: 'Weekly',
        [billing_appendix_setups_1.Timing.Monthly]: 'Monthly',
        [billing_appendix_setups_1.Timing.Quarterly]: 'Quarterly',
    },
    caseVoucherStates: {
        [case_vouchers_1.State.Unmapped]: 'Unmapped',
        [case_vouchers_1.State.Unknown]: 'Unknown',
        [case_vouchers_1.State.Archived]: 'Archived',
        [case_vouchers_1.State.Overpayment]: 'Overpayment',
        [case_vouchers_1.State.FullPayment]: 'Full payment',
        [case_vouchers_1.State.PartialPayment]: 'Partial payment',
        [case_vouchers_1.State.PaymentPlanEntryPayment]: 'Installment payment',
        [case_vouchers_1.State.UnkownPaymentPlanPayment]: 'Unknown payment plan',
        [case_vouchers_1.State.AccordPayment]: 'Accord payment',
        [case_vouchers_1.State.PrincipalPayment]: 'Principal payment',
        [case_vouchers_1.State.Pending]: 'Pending',
    },
    caseVoucherSources: {
        [case_vouchers_1.CaseVoucherSource.Collector]: 'Collector',
        [case_vouchers_1.CaseVoucherSource.Creditor]: 'Creditor',
    },
    depositShareType: {
        [organize_1.DepositShareType.AdjustmentCredit]: 'Adjustment - credit',
        [organize_1.DepositShareType.AdjustmentDebit]: 'Adjustment - debit',
        [organize_1.DepositShareType.Deposit]: 'Deposit',
    },
    voucherTypeSettings: {
        voucherType: 'Voucher type',
        category: 'Category',
        vat: 'Vat',
        setting: 'Setting',
        caseVoucherType: 'Case voucher type',
        caseVoucherTypeDesc: 'Name of case voucher type, category and setting.',
        label: 'Name',
        noSetting: 'None',
        interstDays: 'Interest days',
        interstDaysDesc: 'Days per year',
        interestRounding: 'Rounding',
        interestRoundingDesc: 'When to rent to be rounded off.',
        interestRoundingContent: 'Rounded to the nearest penny daily.',
        interestCompoundingPeriod: 'Interest attribution',
        interestCompoundingPeriodDesc: 'How often must the interest be attributed to the principal. Also called the capitalization period.',
        interestFrequency: 'Calculation frequency',
        interestFrequencyDesc: 'How often the interest is calculated.',
        interestTable: 'Rentesatstabel',
        interestTableDesc: 'Interest rate table',
        interestTableFromDate: 'From date',
        interestTableRate: 'Interest rate',
        billingVoucherType: 'Billing voucher type',
        billingVoucherTypeDesc: 'Name of billing voucher type and category.',
    },
    voucherTypeSetting: {
        [vouchers_1.VoucherTypeSetting.AmountFromTable]: 'Amount from table',
        [vouchers_1.VoucherTypeSetting.InterestFromTable]: 'Interest from table',
        [vouchers_1.VoucherTypeSetting.CompoundInterest]: 'Compound interest',
        [vouchers_1.VoucherTypeSetting.YearlyInterest]: 'Yearly interest',
        [vouchers_1.VoucherTypeSetting.TextAsLabel]: 'Text as label',
    },
    compoundingPeriod: {
        [vouchers_1.CompoundingPeriod.Daily]: 'Daily',
        [vouchers_1.CompoundingPeriod.Monthly]: 'Monthly',
        [vouchers_1.CompoundingPeriod.Quarterly]: 'Quarterly',
    },
    imposeInterestFrequency: {
        [vouchers_1.ImposeInterestFrequency.Daily]: 'Daily',
    },
    economy: {
        groupPostings: 'Group vouchers in export',
        generalBillingSettings: 'Billing settings',
        sendingBillingByEmail: 'Sending billing appendices by email',
        doNotAttachBillingAppendicesInEmails: 'Do not attach billing appendices in emails',
        billingModels: 'Billing models',
        tenantBillingModels: 'Your billing models',
        defaultBillingModels: 'Standard billing models',
        noBillingModelsToShow: 'No billing models to show',
        newBillingModel: 'Billing model',
        addBillingModel: 'Add billing model',
        billingAppendixSetup: 'Billing appendix setup',
        sureYouWantToRemoveVouchersFromTanks: 'Are you sure you want to remove the vouchers from the appendices?',
        removeVouchersFromTanks: 'Remove vouchers from appendices',
        depositInTheseTanks: 'Deposit is in the following appendices',
        allVouchers: 'All vouchers',
        standardPrice: 'standard price:',
        regNumber: 'Reg. nr.',
        accountNumber: 'Account number',
        addNewPipeFilter: 'Add new filter',
        pipeFilterSave: 'Save',
        pipeFilterHandle: 'Filter handle',
        pipeFilterEndOfMonth: 'End of month',
        pipeFilterSelectVoucherTypes: 'Select voucher types',
        pipeSettings: 'Settings',
        added: 'Added ',
        newVouchers: ' new vouchers',
        newVouchersModal: 'New vouchers',
        map: 'Please map',
        deposits: 'deposits',
        uploadDeposits: 'Upload deposits',
        depositFile: 'Deposit file',
        noText: 'No text',
        sureYouWantToDelTank: 'Are you sure you want to delete the export?',
        sureYouWantToDelTankContent: 'Are you sure you want to delete this part of the export?',
        caseEconomy: 'Case Economy',
        voucherAlreadyExists: 'already exist on case',
        histItemHeader: 'Economy',
        addVoucher: 'Add voucher',
        sum: 'Sum',
        voucherType: 'Voucher type',
        account: 'Account',
        contraaccount: 'Contra account',
        referenceId: 'Reference ID',
        text: 'Description',
        amount: 'Amount',
        originalAmount: 'Original amount',
        date: 'Date',
        addAppendix: 'Add appendix',
        referenceVoucher: 'Reference voucher to base interest on',
        selectReferenceVoucher: 'Select reference voucher',
        referenceVoucherCreditnote: 'Reference voucher to link credit note to',
        interestRate: 'Interest rate',
        interestAmount: 'Interest amount',
        interest: 'Interest',
        dueDate: 'Due date',
        expirationDate: 'Expiration date',
        expirationFromDate: 'Special start date for expiration',
        expirationManualSet: 'Expiration date manually set',
        interestStartDate: 'Interest start date',
        interestStartDays: 'Days before interest starts',
        interestEndDate: 'Interst end date',
        imposedByCreditor: 'Imposed by creditor',
        debtIrrecoverable: 'Irrecoverable',
        debtExpied: 'Expired',
        markExpired: 'Expire and end case',
        markSomeExpired: 'Expire',
        markSomeExpiredPostings: 'vouchers',
        markIrrecoverable: 'Mark irrecoverable',
        sureYouWantToMarkIrrecoverable: 'Are you sure that you want to mark this case irrecoverable?',
        sureYouWantToMarkExpired: 'Are you sure that you want to mark vouchers expired?',
        voucherCreationNotSupported: 'Vouchertype not currently supported.',
        voucherCreationCreate: 'Create',
        voucherCreationErrorMessage: 'An error occured',
        voucherCreationIncludeInterest: 'Add interest',
        voucherCreationCreditorDeposit: 'Deposit to creditor',
        caseVoucherInfoType: 'Type',
        caseVoucherInfoTypeSeeDetails: 'See details about case voucher type',
        caseVoucherInfoCreatedAt: 'Created at',
        voucherInfoId: 'Voucher id',
        voucherInfoCreatedBy: 'Created by',
        caseVoucherInfoCategory: 'Category',
        caseVoucherInfoState: 'State',
        caseVoucherInfoHeaderTheVoucher: 'Case voucher',
        caseVoucherInfoHeaderMeta: 'Information',
        caseVoucherInfoHeaderInterest: 'Interest',
        voucherInfoText: 'Text',
        voucherInfoAmount: 'Amount',
        voucherInfoCardtype: 'Card type',
        voucherInfoCardexpires: 'Card expires',
        voucherInfoMaskedcard: 'Masked Card',
        voucherInfoTextOnStmt: 'Text on statement',
        voucherInfoCasePreview: 'Case',
        voucherInfoCreditorName: 'Creditor',
        voucherInfoAppendix: 'Appendix',
        voucherInfoRefVoucher: 'Reference Voucher',
        voucherInfoInterestHis: 'Interest history',
        voucherInfoIfrom: 'From',
        voucherInfoITo: 'To',
        voucherInfoIInterval: 'Interval',
        voucherInfoIRVA: 'Ref. Voucher Amount',
        voucherInfoICompoundedAmount: 'Compounded amount',
        voucherInfoIDays: 'days',
        voucherInfoDeleteVoucher: 'Delete voucher',
        deleteVoucherWichIsInTank: 'The deposit is in the above appendices and can therefore not be deleted. Remove the deposit from the appendices and then delete this deposit.',
        voucherInfovoucherContraAccountName: 'Contra account',
        voucherInfoMarkVoucherExpired: 'Expired',
        voucherInfoMarkVoucherIrrecoverable: 'Irrecoverable',
        imposedBySelectorMessage: 'Select voucher imposer',
        noVouchers: 'No vouchers to show',
        billingHeader: 'Billing',
        billingButtonText: 'Bill all creditors',
        billingHeaderHistory: 'Appendices',
        currency: 'Currency',
        billingModel: 'Billing model',
        billingModelStart: 'From',
        billingModelEnd: 'To',
        ongoing: 'Ongoing work',
        bill: 'Bill',
        aggregation: 'Aggregation',
        postings: 'Postings',
        sendBillings: 'Send bills to creditors',
        billingsSent: 'Bills sent',
        bookkeepingMapping: 'Map bookkeeping accounts',
        bookkeepingMappingBase: 'General',
        bookkeepingMappingFees: 'Fees',
        bookkeepingMappingDisbursements: 'Disbursements',
        bookkeepingMappingAccount: 'Account',
        bookkeepingMappingAccountType: 'Account type',
        bookkeepingMappingReverse: 'Reverse amounts',
        bookkeepingMappingExclude: 'Exclude',
        bookkeepingMappingIncludeVat: 'Include vat',
        bookkeepingMappingContraAccountOn: 'Contra voucher',
        bookkeepingMappingContraAccount: 'Contra account',
        bookkeepingMappingContraAccountType: 'Contra account type',
        bookkeepingMappingCreditorReferenceId: 'Creditor reference id',
        bookkeepingMappingBankOrPSP: 'Bank or acquirer',
        bankAccountsDesc: 'You can add, remove or rename your bank accounts here.',
        bankAccountsPlaceholder: 'Name of your new bank account',
        bankAccountsNewAccountName: 'Add bank account',
        acquiresDesc: 'Get an overview and rename your acquires here.',
        nothingToShow: 'Nothing to show yet.',
        accountName: 'Update account name',
        sureYouWantToDeleteAccount: 'Are you sure you want to delete',
        selectInterestType: 'Select interest type',
        selectInterestRate: 'Select interest rate',
        selectInterestStart: 'Select interest start date',
    },
    economyAppendixHeaders: {
        type: 'Type',
        date: 'Date',
        voucherId: 'Voucher Id',
        voucherType: 'Voucher Type',
        text: 'Text',
        amount: 'Amount',
        currency: 'Currency',
    },
    caseVoucherTags: {
        [economy_1.CaseVoucherTags.IMPOSEDBYCOLLECTOR]: 'Imposed by collector',
        [economy_1.CaseVoucherTags.IMPOSEDBYCREDITOR]: 'Imposed by creditor',
        [economy_1.CaseVoucherTags.CREDITORTRANSACTION]: 'Creditor transaction',
        [economy_1.CaseVoucherTags.ECONOMIC_IMPORT]: 'E-conomic import',
        [economy_1.CaseVoucherTags.EXPIRED]: 'Expired',
        [economy_1.CaseVoucherTags.IRRECOVERABLE]: 'Irrecoverable',
    },
    caseTags: {
        [cases_2.CaseTag.SURVEILLANCE]: 'Surveillance',
    },
    transactionImports: {
        transactionImportsHeader: 'Transaction imports',
        selectType: 'Select payment type',
    },
    caseVouchers: {
        source: 'Source',
        irrecoverableDate: 'Irrecoverable date',
        expirationDate: 'Expiration date',
        expired: 'Expired',
        case: 'Case',
        map: 'Map',
        mapHeader: 'Map case voucher to case',
        deleteWarning: 'Are you sure that you want to delete this voucher? This action cannot be reversed.',
        exportFileName: 'case-vouchers',
        voucherId: 'Voucher-id',
        voucherReferenceId: 'Voucher reference',
        caseId: 'Casenumber',
        creditor: 'Creditor',
        creditorReference: 'Creditor reference',
        customerReference: 'Customer reference',
        account: 'Account',
        accountId: 'Account-id',
    },
    payouts: {
        caseSeqId: 'Case id',
        caseReferenceId: 'Case reference',
        billingId: 'Billing id',
        type: 'Type',
        account: 'Account',
        creditorReference: 'Creditor reference',
        text: 'Text',
        state: 'State',
        amount: 'Amount',
        currency: 'Currency',
        createdAt: 'Created',
        updatedAt: 'Updated',
        complete: 'Completed',
        completeOnExport: 'Mark completed on export',
        exportFileName: 'payouts',
    },
    payoutState: {
        [payouts_1.PayoutState.Completed]: 'Completed',
        [payouts_1.PayoutState.Created]: 'Created',
        [payouts_1.PayoutState.DataUpdated]: 'Data updated',
        [payouts_1.PayoutState.Failed]: 'Failed',
        [payouts_1.PayoutState.Initiated]: 'Initiated',
    },
    payoutType: {
        [payouts_1.PayoutType.CourtFee]: 'Court fee',
        [payouts_1.PayoutType.CreditorReceivables]: 'Creditor receivables',
        [payouts_1.PayoutType.Overpayment]: 'Overpayment',
    },
    clientBilling: {
        clientBilling: 'Creditor billing',
        isAdjustment: 'Adjustment',
        billings: 'Billings',
        seeDetails: 'See creditor billing details',
        fetchingUpdatedEconomy: 'Fetching updated information',
        deposits: 'Deposits',
        fees: 'Fees',
        disbursements: 'Disbursements',
        showPerDeposit: 'Show per deposit',
        voucherType: 'Voucher type',
        original: 'Original',
        paid: 'Paid',
        residue: 'Residue',
        collector: 'Collector',
        creditor: 'Creditor',
        text: 'Text',
        addVoucher: 'Add voucher',
        otherPayments: 'of other deposits.',
        noVouchers: 'No vouchers',
        hoursOf: 'hours at',
        hourOf: 'hour at',
        hourlyRateOn: 'Charge hourly rate',
        hourlyRate: 'Hourly rate',
        hourlyRateHours: 'Hours',
        hourlyRateMinutes: 'Minutes',
    },
    search: {
        migratedId: 'Migrated j.no.',
        noResults: 'No results',
        voucherReferenceId: 'Voucher id',
        cvr: 'CVR',
        cpr: 'CPR',
        phone: 'Phone',
    },
    deposits: {
        pickPaymentType: 'Pick payment type',
        unknownDeposit: 'Unknown deposits',
        unknownDepositSubHeader: 'Could not identify deposit',
        archive: 'Archive',
        exportDesc: 'Export of deposits from bank or PSP (credit/debit cards etc.)',
        unknownDesc: 'Here is a list of unknown deposits.',
        transactionLookUpDesc: 'Here you can lookup deposits by transaction id.',
        transactionLookUpPlaceholder: 'Type transaction id (for example: 12341234)',
        transactionLookUpNotFound: 'Transaction not found.',
        transactionLookUpNotDeposit: 'Transaction is not a deposit.',
        transactionLookUpButton: 'Lookup',
        transactionLookUpDeposit: 'Deposit',
        downloadSample: 'Download sample',
        downloadSampleQuantity: 'Quantity deposits in sample',
        linkBank: 'Link bank account',
        selectBankAccount: 'Select bank account',
        dropHere: 'Drop here',
        upload: 'Register deposits',
        deposits: 'Deposits',
        map: 'Register deposits',
        handleTransaction: 'Handle deposit',
        addSingleDepositHeader: 'Add single deposit',
        addSingleDepositPaymentType: 'Payment type',
        addSingleDepositDate: 'Date',
        addSingleDepositText: 'Text',
        addSingleDepositAmount: 'Amount',
        addSingleDepositAddAndClose: 'Add and close',
        addSingleDepositAddAndClear: 'Add and clear',
    },
    depositsPaymentTypes: {
        [case_vouchers_1.PaymentType.Mastercard]: 'MasterCard',
        [case_vouchers_1.PaymentType.Swish]: 'Swish',
        [case_vouchers_1.PaymentType.Vipps]: 'Vipps',
        [case_vouchers_1.PaymentType.Visa]: 'Visa',
        [case_vouchers_1.PaymentType.Dankort]: 'Dankort',
        [case_vouchers_1.PaymentType.MobilePay]: 'MobilePay',
        [case_vouchers_1.PaymentType.Betalingsservice]: 'Betalingsservice',
        [case_vouchers_1.PaymentType.Leverandørservice]: 'Leverandørservice',
        [case_vouchers_1.PaymentType.BankTransfer]: 'Bank transaction',
        [case_vouchers_1.PaymentType.FIK]: 'FIK',
        [case_vouchers_1.PaymentType.IBAN]: 'IBAN',
        [case_vouchers_1.PaymentType.Creditor]: 'Creditor',
        [case_vouchers_1.PaymentType.PayPal]: 'PayPal',
        [case_vouchers_1.PaymentType.ApplePay]: 'Apple Pay',
        [case_vouchers_1.PaymentType.GooglePay]: 'Google Pay',
    },
    billingReasons: {
        caseVoucherInlineDeleted: 'Voucher (later deleted)',
        caseVoucherPatchedCaseId: 'was mapped to the case',
        caseVoucherPatched: 'was edited',
        caseVoucherCreated: 'added to the case',
        caseVoucherDeleted: 'deleted from the case',
        billingModelChanged: 'Billing model changed',
        billingStartDateChanged: 'Start date for billing changed',
    },
    billing: {
        ongoingWork: 'Ongoing work',
        bills: 'Bills',
        billingSequentialId: 'Id',
        case: 'Case',
        date: 'Date',
        type: 'Type',
        text: 'Text',
        customerReferenceId: 'Customer ref.',
        revenue: 'Fees',
        vat: 'Vat',
        payout: 'Payout',
        disbursements: 'Disbursements',
        overpayments: 'Overpayments',
        balance: 'Balance',
        amount: 'Amount',
        deposits: 'Deposits',
        deposit: 'Deposit',
        bill: 'Bill',
        delete: 'Remove',
        deleteApproval: 'Are you sure you want to delete the vouchers from the billing? The action cannot be undone.',
        adjustments: 'Adjustments',
        billingPrevented: 'Postponed billings',
        billingStartDate: 'Start billing from',
        appendix: 'Appendix',
        readyForBilling: 'Ready for billing',
        awaitingCaseEnd: 'Awaiting case end',
        appendixMissing: 'Appendix missing',
        billSelected: 'Bill selected',
        addBillingVoucher: 'Add voucher',
        recipient: 'Recipient',
        billingSent: 'Sent',
        sendBilling: 'Send',
        information: 'Information',
        addedToPayouts: 'Added to payouts',
        addToPayouts: 'Add to payouts',
        invoiceNo: 'Invoice no.',
        specifiedByBankTransfer: 'should be stated on the bank transfer',
        paymentTerms: 'Payment terms: Netto',
        daysAndBillingDate: 'days - Payment date',
        billingAlreadySentAlert: 'The appendix has already been sent. Are you sure you want to send it again?',
        amountWillBeWithdrawnToAccount: 'is withdrawn to account',
        amountShouldBePaidToAccount: 'is paid to account',
        preview: 'Preview',
        PDFPreview: 'PDF',
        ExcelPreview: 'Excel',
        forPayout: 'For payout',
        collectionCommission: 'Collection commission',
        fees: 'Fees',
        otherVat: 'Other vat',
        subtotal: 'Subtotal',
        total: 'Total',
        billingCollectionBillingSequentialId: 'Id',
        billingCollectionBillingDate: 'Date',
        billingCollectionBillingAddedToPayouts: 'Added to payouts',
        billingCollectionBillingSent: 'Sent',
        billingCollectionBillingBalance: 'Balance',
        billingsAppendix: 'Appendix',
        billingsType: 'Type',
        billingsCreditor: 'Creditor',
        billingsCases: 'Cases',
        billingsCurrency: 'Currency',
        generateAppendix: 'Generate appendix',
        awaitingGeneration: 'Appendices ready to be generated',
        warnThisWillAffectBilling: 'This action will affect already billed deposits. Are you sure you want to continue?',
    },
    creditorBilling: {
        newBillingFrom: 'New billing from',
        dear: 'Dear',
        herebyForwarded: 'Hereby forwarded:',
        seeAttached: 'Please see the attached.',
    },
    bookkeeping: {
        settleAll: 'Settle all creditors',
        preview: 'Preview',
        type: 'Type',
        date: 'Date',
        text: 'Text',
        amount: 'Amount',
        account: 'Acccount',
        contraAccount: 'Contra account',
        debtorVoucher: 'Debtor voucher',
        showMoreVouchers: 'Show more vouchers',
        showing: 'Showing',
        of: 'of',
        vouchers: 'vouchers',
        exportNdownload: 'Export and download',
        history: 'History',
        noHistorical: 'No historical entries yet',
    },
    sites: {
        caseworkerWeb: 'Caseworker Web',
        clientWeb: 'Creditor Web',
        detiorWeb: 'Debtor Web',
    },
    blameLogs: {
        overview: 'Overview',
        userVisits: 'User visits',
        debtorUpdates: 'Debtor changes',
        economy: 'Economy',
        interactions: 'Interactions',
        noEntries: 'No entries',
        blameLog: 'Action log',
        logged: 'Action',
        ago: 'ago',
        type: 'Type',
        content: 'Content',
        subject: 'Subject',
        stepTitle: 'Step title',
        chainTitle: 'Workflow title',
        viewLetter: 'View letter',
        phoneNumber: 'Phone number',
        label: 'Label',
        workflow: 'Workflow',
        noLogs: 'No logs yet',
        settings: 'Settings',
        toggled: 'Toggled to',
        trueActivated: 'activated',
        falseActivated: 'deactivated',
        key: 'Key',
        code: 'Code',
        username: 'Username',
        password: 'Password',
        trueChanged: 'Changed',
        falseChanged: 'Unchanged',
        experianClientId: 'Experian client ID',
        to: 'to',
        when: 'When',
        procedure: 'Shortcut',
        removed: 'Removed',
        other: 'Other actions',
        description: 'Description',
        note: 'Note',
        createdAt: 'Created',
        trueYes: 'Yes',
        falseNo: 'No',
        dunning: 'Dunning',
        connectorBillingModel: 'Billing model',
    },
    blameLogSimplfiedType: {
        [blamelog_1.BlameLogType.CaseVisit]: 'Case visit',
        [blamelog_1.BlameLogType.CaseVoucherDelete]: 'Voucher deleted',
        [blamelog_1.BlameLogType.UnknownCaseVoucherMapped]: 'Unknown deposit mapped to case',
        [blamelog_1.BlameLogType.CaseVoucherPatch]: 'Voucher updated',
        [blamelog_1.BlameLogType.UserOnCustomerVisit]: 'Customer visit',
        [blamelog_1.BlameLogType.CreditorVisit]: 'Creditor visit',
        [blamelog_1.BlameLogType.VisitedBy]: 'Visit',
        [blamelog_1.BlameLogType.CaseVoucherIrrecoverable]: 'Voucher irrecoverable',
        [blamelog_1.BlameLogType.CaseVoucherExpired]: 'Voucher expired',
        [blamelog_1.BlameLogType.InteractionDelete]: 'Interaction deleted',
        [blamelog_1.BlameLogType.InteractionRollback]: 'Interaction rollback',
        [blamelog_1.BlameLogType.WorkflowRollback]: 'Workflow rollback',
        [blamelog_1.BlameLogType.InteractionHideFromClient]: 'Interaction hide from creditor',
        [blamelog_1.BlameLogType.DebtorWebLoginEId]: 'Debitorweb login with e-ID',
        [blamelog_1.BlameLogType.DebtorUpdateName]: 'Name changed',
        [blamelog_1.BlameLogType.DebtorUpdatePhone]: 'Phone changed',
        [blamelog_1.BlameLogType.DebtorUpdateAddress]: 'Address changed',
        [blamelog_1.BlameLogType.DebtorUpdateEmail]: 'Email changed',
        [blamelog_1.BlameLogType.DebtorUpdateCarRegistrationNumber]: 'Registration number changed',
        [blamelog_1.BlameLogType.DebtorUpdateCourt]: 'Jurisdiction changed',
        [blamelog_1.BlameLogType.DebtorUpdateBirthdate]: 'Birthdate changed',
        [blamelog_1.BlameLogType.DebtorUpdateCVR]: 'CVR changed',
        [blamelog_1.BlameLogType.DebtorUpdateCPR]: 'CPR changed',
        [blamelog_1.BlameLogType.AKSConfiguration]: 'AKS configuration',
        [blamelog_1.BlameLogType.RKIAuto]: 'Automatic RKI',
        [blamelog_1.BlameLogType.RKIIgnoreOppositions]: 'Ignore RKI oppositions',
        [blamelog_1.BlameLogType.RKIDeleteOnCaseEnd]: 'Delete RKI registration automatically on case end',
        [blamelog_1.BlameLogType.RKIOpen]: 'Open RKI',
        [blamelog_1.BlameLogType.AKSClientID]: 'Experian client id',
        [blamelog_1.BlameLogType.RKIOveride]: 'Override auto RKI',
        [blamelog_1.BlameLogType.AKSActivated]: 'AKS activated',
        [blamelog_1.BlameLogType.PriceList]: 'Price list',
        [blamelog_1.BlameLogType.UserPasswordUpdate]: 'User password changed',
        [blamelog_1.BlameLogType.TriggerShortcut]: 'Trigger change',
        [blamelog_1.BlameLogType.WorkflowChange]: 'Workflow change',
        [blamelog_1.BlameLogType.DeleteUpdate]: 'Task deleted',
        [blamelog_1.BlameLogType.ConnectorBillingUpdate]: 'Billing model changed',
        [blamelog_1.BlameLogType.CreditorSettingsUpdate]: 'Creditor settings changed',
    },
    caseTypes: {
        [cases_1.CaseType.CLIENT]: 'Creditor case',
        [cases_1.CaseType.TENANT]: 'Tenant case',
    },
    cases: {
        case: 'Case',
        customerReferenceId: 'Referenceno.',
        creditor: 'Creditor',
        debt: 'Original',
        deposits: 'Deposits',
        balance: 'Debt',
        status: 'Case status',
        caseVoucher: 'Case voucher',
        amount: 'Amount',
        workflow: 'Workflow',
        responsible: 'Responsible',
        showAll: 'Show all',
        caseInfo: 'Case Info',
        cases: 'Cases',
        createNewCase: 'Create new case',
        caseOverview: 'All cases',
        casesLeft: 'Cases left',
        caseIsPaused: 'Case is paused',
        casePaused: 'Case paused',
        dueDateIsIn: 'Due date is in',
        days: 'days',
        pressCommandOrCtrlToContinue: 'Press command or control to also continue the case.',
        source: 'Source',
        sourceClient: 'The case originates from this case',
        referenceId: 'Creditor reference id',
        createdAt: 'Creation date',
        caseState: {
            [cases_1.CaseState.ALL]: 'All cases',
            [cases_1.CaseState.ACTIVE]: 'Active cases',
            [cases_1.CaseState.CLOSED]: 'Closed cases',
        },
        caseStatus: {
            [cases_1.CaseStatus.VERIFIED]: 'Verified',
            [cases_1.CaseStatus.PENDING]: 'Pending',
            [cases_1.CaseStatus.ENDED]: 'Ended',
        },
        VERIFIED: 'Verified',
        PENDING: 'Pending',
        ENDED: 'Ended',
        dunning: 'Dunning',
        debtCollection: 'Debt collection',
        verify: 'Verify',
        end: 'End',
        reVerify: 'Re-Verify',
        endCase: 'End case',
        choosEndReason: 'Choose end reason',
        caseGroup: 'Case Group',
        pause: 'Pause',
        pauseCase: 'Pause case',
        pauseReason: 'Pause reason',
        pauseComment: 'Comment',
        blameLog: 'Action log',
        logged: 'Action',
        ago: 'ago',
        newCase: 'Create new case',
        caseReferenceId: 'Creditors reference id',
        invoiceId: 'Invoice ID',
        file: 'Invoice pdf',
        debtorName: 'Name',
        address: 'Address',
        phone: 'Phone number',
        email: 'Email',
        cpr: 'CPR',
        cvr: 'CVR',
        debtorHaveObjections: 'Debtor has opposed',
        isCompany: 'Debtor is a company',
        theDetails: 'Info',
        theDebt: 'The debt',
        theDebtor: 'Debtor',
        manual: 'Manually',
        fromFile: 'From file',
        dropFile: 'Drop invoice here',
        clickHereToUpload: 'Or upload',
        addDebt: 'New invoice',
        issueDate: 'Invoice issue date',
        dueDate: 'Invoice due date',
        sendNoteToCollector: 'Send message to collector',
        sendNoteToCollectorButton: 'Send',
        note: 'Note',
        caseHasBeenDeleted: 'Case has been deleted',
        missingCreateAccess: 'The agreement has been ceased and therefore no new cases can be created. Contact us for more information',
        newCaseCreate: 'Case info',
        newCaseEconomy: 'Economy',
        newCaseDone: 'Done',
        noDebts: 'No debts',
        noDebtsExplainer: "Add debt using the '+' button",
        newCaseCreateExplainer: 'You are currently creating a new case. You can insert the custumer number from your system here. If the case is in another currency than Danish, you can also choose this here.',
        newCaseEconomyExplainer: 'Your case is now created, and below the economy of the case should be added. If you have created the case but need to undo it, we recommend that you contact us for deletion of the case.',
        newCaseCreationWarning: 'When you click further, the case will be created in the system. If you do not have all the information to create the case, it is recommended that you do not continue until you have all the information about the debt and debtor',
        deleteCase: 'Delete case',
        sureYouWantToDeleteCase: 'Are you sure you want to delete this case?',
    },
    mergeCases: {
        header: 'Merge this case with another',
        explanation: 'Merge this case with another case selected below. Vouchers will automatically be transferred to the target case and this case will be ended with end reason "Case is merged"',
        searchPlaceholder: 'Search for target case on same creditor',
        mergeBtn: 'Merge cases',
        undoCaseMerge: 'Undo case merge',
    },
    customers: {
        addParty: 'Add party',
        contact: 'Contact person',
        selectType: 'Select type',
        errorEmailValidation: 'Invalid email',
        errorCPRValidation: 'Invalid CPR',
        errorCVRValidation: 'Invalid CVR',
        noContactSelected: 'No contact person selected',
        noContact: 'No contact',
        noRelatedCases: 'No related cases',
        customer: 'Customer',
        createdAt: 'Created',
        casesOnCreditor: 'Cases on customer',
        thatIsRelatedTo: 'that is related to customer reference',
        casesRelatedToCustomerDescription: 'Cases matched on email, CPR, CVR or via external sources.',
        information: 'Information',
        casesOnCustomer: 'Cases on customer',
        relatedCases: 'Related cases',
        caseStatus: 'Status',
        relationType: 'Relation',
        creditor: 'Creditor',
        case: 'Case',
        parties: 'Parties',
        customerReferenceId: 'Customer reference id',
        private: 'Private person',
        company: 'Company',
        existingCustomer: 'Existing customer',
        backToCase: 'Back to case',
        referenceId: 'Reference id',
        alternativeContactReferenceId: 'Alternative contact reference id',
        secondaryEntityDisabled: 'Inactive',
        addSecondaryEmails: 'Add one or more secondary emails',
        note: 'Optional note',
        addSecondaryEmail: 'Add secondary email',
        addSecondaryPhones: 'Add one or more secondary phone numbers',
        addSecondaryPhone: 'Add secondary phone number',
        enabled: 'Active',
        save: 'Save',
    },
    customerCaseRelationType: {
        [customers_1.RelationType.CPR]: 'CPR',
        [customers_1.RelationType.CVR]: 'CVR',
        [customers_1.RelationType.CarRegistrationNumber]: 'Reg.no.',
        [customers_1.RelationType.Cosmo]: 'External',
        [customers_1.RelationType.CustomerReferenceId]: 'Customer ref.',
        [customers_1.RelationType.Email]: 'Email',
        [customers_1.RelationType.NameAddress]: 'Name/addr.',
    },
    debtors: {
        private: 'Private',
        company: 'Company',
        addAlternativeContact: 'Add alternative contact',
        debtor: 'Debtor',
        alternativeContact: 'Alternative contact person',
        ownsCompany: 'Owns company',
        movedAbroad: 'Moved abroad',
        ownsCompanies: 'Owns companies',
        rkiRegistrations: 'RKI registrations',
        companyStatus: 'Company status',
        otherCasesOnDebtorTooltip: 'Debtor is associated with multiple cases',
        otherCasesOnDebtor: 'Other case',
        otherCasesOnDebtorPlural: 'other cases',
        movedTo: 'Moved to',
        debtors: 'Debtors',
        aksFailed: 'AKS Failed',
        cprStatus: 'CPR-status',
        status: {
            [customers_1.PrivateStarCycle.Active]: 'Active',
            [customers_1.PrivateStarCycle.Dead]: 'Dead',
            [customers_1.PrivateStarCycle.Disappeared]: 'Disappeared',
            [customers_1.PrivateStarCycle.Homeless]: 'Homeless',
            [customers_1.PrivateStarCycle.GoneAway]: 'Moved abroad',
            [customers_1.PrivateStarCycle.ForTaxReason]: 'Personal tax number',
            [customers_1.PrivateStarCycle.NotVerified]: 'Unverified',
            [customers_1.CompanyStarCycle.Inactive]: 'Inactive',
            [customers_1.CompanyStarCycle.OperationsCeased]: 'Operations ceased',
            [customers_1.CompanyStarCycle.ShelfCompany]: 'Shelf company',
        },
        dissolvedStatus: {
            [customers_1.DissolvedStatus.UnderLiquidation]: 'Under liquidation',
            [customers_1.DissolvedStatus.DissolvedAfterLiquidation]: 'Dissolved after liquidation',
            [customers_1.DissolvedStatus.InvoluntaryDissolution]: 'Involuntary dissolutiuon',
            [customers_1.DissolvedStatus.Dissolved]: 'Dissolved',
        },
        dissolutionStatus: 'Dissolution status',
        addressProtection: 'Address and name protection',
        addressProtectionShort: 'Protected',
        addDebtor: 'Add debtor',
        guardian: 'Guardian',
    },
    emailValidations: {
        risk: 'Risk',
        emailRisk: 'Email risk',
        didYouMean: 'Did you mean',
        isDisposableAddress: 'Is disposable email',
        isRoleAddress: 'Is role email',
        high: 'High',
        medium: 'Medium',
        low: 'low',
        unknown: 'Unknown',
        no_mx: 'No MX records',
        unknown_provider: 'Unknown email provider',
        high_risk_domain: 'High risk domain',
        subdomain_mailer: 'Subdomain mailer',
        immature_domain: 'Immature domain',
        tld_risk: 'The domain is registered high risk',
        mailbox_does_not_exist: 'Email does not exist',
        mailbox_is_disposable_address: 'Email is disposable',
        mailbox_is_role_address: 'Mailbox is role email',
        catch_all: 'Catch all',
        long_term_disposable: 'Long term disposable email',
    },
    phoneValidation: {
        mobile: 'Mobile',
        landline: 'Landline',
        landline_premium: 'Landline',
        landline_tollfree: 'Landline',
        virtual: 'Virtual',
        unknown: 'Unknown',
        pager: 'Pager',
        roaming: 'Roaming',
    },
    debtorInfo: {
        debtorInfo: 'Debtor info',
        debtorCreatedAt: 'Debtor Created At',
        company: 'Company',
        male: 'Male',
        female: 'Female',
        private: 'Private',
        activated: 'activated',
        subscribed: 'subscribed',
        failed: 'failed',
        movedTo: 'Moved to',
        description: 'Description',
        addDescription: 'Add description',
        name: 'Name',
        email: 'Email',
        noEmailAddr: 'No email address',
        phone: 'Phone',
        noAddr: 'No address',
        address: 'Address',
        cpr: 'CPR',
        cvr: 'CVR',
        addressProtection: 'Address and name protection',
        addressProtectionShort: 'Protected',
        jurisdiction: 'Jurisdiction',
        noJurisdiction: 'No jurisdiction',
        chooseJurisdiction: 'Choose jurisdiction',
        status: {
            [customers_1.PrivateStarCycle.Active]: 'Active',
            [customers_1.PrivateStarCycle.Dead]: 'Dead',
            [customers_1.PrivateStarCycle.Disappeared]: 'Disappeared',
            [customers_1.PrivateStarCycle.Homeless]: 'Homeless',
            [customers_1.PrivateStarCycle.GoneAway]: 'Moved abroad',
            [customers_1.PrivateStarCycle.ForTaxReason]: 'Personal tax number',
            [customers_1.PrivateStarCycle.NotVerified]: 'Unverified',
            [customers_1.CompanyStarCycle.Inactive]: 'Inactive',
            [customers_1.CompanyStarCycle.OperationsCeased]: 'Operations ceased',
            [customers_1.CompanyStarCycle.ShelfCompany]: 'Shelf company',
        },
        dissolvedStatus: {
            [customers_1.DissolvedStatus.UnderLiquidation]: 'Under liquidation',
            [customers_1.DissolvedStatus.DissolvedAfterLiquidation]: 'Dissolved after liquidation',
            [customers_1.DissolvedStatus.InvoluntaryDissolution]: 'Involuntary dissolutiuon',
            [customers_1.DissolvedStatus.Dissolved]: 'Dissolved',
        },
        dissolutionStatus: 'Dissolution status',
        save: 'Save',
        remove: 'Remove',
        birthdate: 'Birthdate',
        noBirthdate: 'No birthdate',
        yearsOld: 'years old',
        companyForm: 'Company form',
        industry: 'Industry',
        employees: 'Employees',
        companyStatus: 'Company status',
        website: 'Website',
        dateOfFoundation: 'Date of foundation',
        quantifyOfPUnits: 'Quantity of P-Units',
        powerToBind: 'Power to bind',
        adProtected: 'Advertisement protected',
        cars: 'Cars',
        from: 'From',
        liabilities: 'Liabilities',
        priority: 'Priority',
        interest: 'Interest',
        properties: 'Properties',
        toilet: 'Toilet',
        roof: 'Roof',
        bath: 'Bath',
        built: 'Built',
        rkiRegis: 'RKI registrations',
        administrator: 'Administrator',
        disclosureDate: 'Disclosure date',
        deleted: 'deleted',
        toBedeleted: 'deleted',
        companyRelations: 'Company Relations',
        roles: 'Roles',
        accountableParticipant: 'Accountable participant',
        director: 'Director',
        executiveBoard: 'Executive board',
        beneficialOwner: 'Beneficial owner',
        founder: 'Founder',
        owner: 'owner',
        stakeholder: 'Stakeholder',
        chairperson: 'Chairperson',
        managingDirector: 'Managing director',
        boardMember: 'Board member',
        equityTier: 'Equity tier',
        viceChairperson: 'Vice chairperson',
        rightToVote: 'Right to vote',
        audit: 'Audit',
        specialOwnership: 'Special ownership',
        previous: 'Previous',
        noPreviousToShow: 'No previous to show',
        backTo: 'Back to',
        casesOnThisDebtor: 'Cases on this debtor',
        guardianName: 'Guardian name',
        guardianAddress: 'Guardian address',
        guardianStartDate: 'Guardian start date',
    },
    debtorWebHome: {
        dear: 'Dear',
        representative: 'We have registered that you have entered as a representative of debtor.',
        you: 'You',
        debtor: 'Debtor',
        owe: 'owe',
        to: 'to',
        youCanDoThisHere: 'You can pay on this page, signup for a payment plan or update your contact information. You are also welcome to send us a message if you have any questions.',
        yourInfo: 'Your information',
        name: 'Name',
        informName: 'Inform name',
        email: 'Email',
        informEmail: 'Inform email',
        phone: 'Phone',
        informPhone: 'Inform phone',
        address: 'Address',
        cpr: 'CPR',
        cvr: 'CVR',
        informAddress: 'Inform address',
        confirmation: 'I confirm that my information is correct.',
        updateButton: 'Update information',
        confirm: 'Confirm',
        faq: 'Frequently asked questions',
        contactUs: 'Contact us',
        contactUsText: 'Feel free to send us an email, call us or send a message through the textarea below.',
        yourMessage: 'Your message',
        enterEmail: 'Enter email to send a message',
        send: 'Send',
        logout: 'Log out',
        privacyPolicy: 'Privacy policy',
        businessTerms: 'Business terms',
        paymentMethods: 'Payment methods',
        payWithFI: 'Pay with FI number',
        paySafeWithFI: 'Pay safely with the following FI number:',
        payWithIBAN: 'Pay with IBAN',
        paySafeWithIBAN: 'Pay safely with IBAN from your bank:',
        payWithSWIFT: 'Pay with SWIFT',
        paySafeWithSWIFT: 'Pay safely with SWIFT from your bank:',
        payWithBankTransfer: 'Pay with bank transfer',
        registrationNumber: 'Registration no.',
        accountNumber: 'Account no.',
        payWithBankTransferText: 'Make a deposit to our account:',
        payWithBankTransferInfo: 'Remember to refer to j.no.',
        or: 'Or',
        iApprove: 'I accept the',
        theBusinessTerms: 'business terms',
        payWithCardButton: 'Pay with card',
        createAPaymentPlan: 'Create a payment plan',
        fullPayment: 'Full payment',
        partialPayment: 'Partial payment',
    },
    debtorWebPaymentPlans: {
        backToCase: 'Back to case',
        paymentPlanOn: 'Payment plan on case',
        selectPlan: 'Select payment plan',
        sign: 'Sign agreement',
        gatherInfo: 'Enter information',
        paymentMethod: 'Select payment method',
        approval: 'Confirmation',
        info: 'Info',
        paymentPlan: 'Payment plan',
        firstPayment: 'First payment',
        entry: 'entry',
        lastPayment: 'Last payment',
        signedDoc: 'Signed document',
        needHelp: 'Need help?',
        orPay: 'Or pay the entire debt',
        pay: 'Pay the entire debt',
        months: 'Months',
        month: 'month',
        total: 'Total payment',
        select: 'Select',
        noOptions: 'Unfortunately, it is not possible to set up a payment plan.',
        signTextOne: 'In order to sign up for a payment plan with',
        signTextTwoAlternativeContact: 'debtor have to sign the following agreement.',
        signTextTwoDebtor: 'you have to sign the following agreement.',
        signTextThree: 'Before you can sign the agreement, you must enter your information.',
        agreement: 'Sign agreement',
        approvalText: 'Congratulations. You have entered into a payment plan.',
        paymentMethodText: 'We will take care of your card information and make it easy for you to sign up for automatic payment.',
        connectCard: 'Connect payment method',
        automaticPaymentMethod: 'Automatic payment method',
        deleteCardToChange: 'You can change/delete the selected card by clicking the delete card button.',
        deleteCard: 'Delete card',
        paymentPlanEntries: 'Payment plan entries',
        amount: 'Amount',
        date: 'Date',
        status: 'Status',
        statusCode: {
            [payment_plans_1.PaymentPlanEntryStatus.SETTLED]: 'Paid',
            [payment_plans_1.PaymentPlanEntryStatus.CANCELED]: 'Defaulted',
            [payment_plans_1.PaymentPlanEntryStatus.PENDING]: 'Future',
            [payment_plans_1.PaymentPlanEntryStatus.REMINDED]: 'Reminded',
            [payment_plans_1.PaymentPlanEntryStatus.AWAITING]: 'Awaiting',
            [payment_plans_1.PaymentPlanEntryStatus.OVERDUE]: 'Overdue',
            [payment_plans_1.PaymentPlanEntryStatus.ERRORSETTLED]: 'Error settle',
        },
    },
    paymentPlanEntryStatuses: {
        [payment_plans_1.PaymentPlanEntryStatus.SETTLED]: 'Paid',
        [payment_plans_1.PaymentPlanEntryStatus.CANCELED]: 'Defaulted',
        [payment_plans_1.PaymentPlanEntryStatus.PENDING]: 'Future',
        [payment_plans_1.PaymentPlanEntryStatus.REMINDED]: 'Reminded',
        [payment_plans_1.PaymentPlanEntryStatus.AWAITING]: 'Awaiting',
        [payment_plans_1.PaymentPlanEntryStatus.OVERDUE]: 'Overdue',
        [payment_plans_1.PaymentPlanEntryStatus.ERRORSETTLED]: 'Error settle',
    },
    chains: {
        nextStep: 'Next step',
    },
    chainGroups: {
        dunningChain: 'Dunning workflow',
        chain: 'Workflow',
        add: 'Add',
        delete: 'Delete',
        configure: 'Configure workflows for case groups',
        caseGroup: 'Case group',
    },
    migration: {
        migrateData: 'Migrate data',
        modalHeader: 'Migrate data',
        uploadErrorMessage: 'An error occured, check the file is correct and try again',
    },
    creditorStateDescriptions: {
        [creditor_1.CreditorState.Lead]: 'Creditors which is being set up, but have not yet got access to the creditor web.',
        [creditor_1.CreditorState.SignedOn]: 'Creditors which is not yet active customers, but wants a demo of the creditor web.',
        [creditor_1.CreditorState.Active]: 'Active creditors that uploads new cases and have full access to the creditor web.',
        [creditor_1.CreditorState.Ceased]: 'Creditors which is cancelled, but still have active cases to follow.',
        [creditor_1.CreditorState.Cancelled]: 'Creditors which is cancelled and should not anymore have access to the creditor web.',
    },
    creditors: {
        creditor: 'Creditor',
        creditors: 'Creditors',
        creditorInfo: 'Creditor Information',
        allCreditors: 'All creditors',
        newCreditorInfo: 'Creditor Info',
        newCreditorEconomy: 'Economy',
        newCreditorChains: 'Workflows',
        newCreditorUsers: 'Users',
        newCreditorDone: 'Done',
        states: {
            [creditor_1.CreditorState.Active]: 'Active',
            [creditor_1.CreditorState.Lead]: 'Lead',
            [creditor_1.CreditorState.SignedOn]: 'Signed on',
            [creditor_1.CreditorState.Cancelled]: 'Cancelled',
            [creditor_1.CreditorState.Ceased]: 'Ceased',
        },
        downloadOverview: 'Download overview',
        newCreditor: 'New creditor',
        defaultBillingModelDescription: 'Select billing model that new cases should be initialized with. All cases can have its own billing model. When creating a new case it will be created with the creditors standard billing model.',
        tenantInheritedBillingModelDescription: "If you do not select a default billing model cases will be created with the tenants' default billing model",
        tenantInheritedDunningConnectorDescription: "If you do not select a default billing model cases will be created with the tenants' default dunning billing model",
        chainsHeader: 'Select default workflows',
        chainsDescription: 'Select which workflow new cases should be created with. All cases can have its own workflow. When creating a new case it will be created with the creditors standard workflow.',
        usersNewHeader: 'Create login for creditors',
        usersCreditorHeader: 'Choose responsible users',
        next: 'Next',
        previous: 'Previous',
        setCreditorState: 'Set creditor state',
        cvr: 'CVR',
        company: 'Company',
        person: 'Person',
        vatRegistered: 'VAT registered',
        notVatRegistered: 'Not VAT registered',
        acquisitionResponsible: 'Acquisition Responsible',
        selectAcquiRespon: 'Select Acquisition Responsible',
        contact: 'Contact',
        selectContact: 'Select Contact',
        caseworkerContact: 'Caseworker Contact',
        selectCaseworkerContact: 'Select Caseworker Contact',
        none: 'None',
        createCreditor: 'Create Creditor',
        reference: 'Reference',
        name: 'Name',
        selectDefaultCollector: 'Select Default Collector',
        status: 'Status',
        active: 'Active',
        lead: 'Lead',
        selectClientContact: 'Select creditor contact',
        isCompany: 'Is company',
        create: 'Create',
        createdAt: 'Creation date',
        quantityCases: 'Cases count',
        referenceId: 'No.',
        wincentAvgPrediction: 'Wincent avg. score',
        selectDefaultChain: 'Select default workflow',
        defaultChain: 'Workflow',
        selectDefaultClientChain: 'Select default workflow',
        defaultClientChain: 'Dunning workflow',
        mandates: 'Mandates',
        mandatesPlaceholder: 'Empty',
        experianClientId: 'Experian client id',
        updateExperianClientId: 'Update client id',
        requestClientIdExperian: 'Request Experian a client id',
        requestClientIdExperianSuccess: 'Experian has been requested and will automatically type in the client id.',
        erpLink: "Link to creditors' ERP system",
        updateErpLink: 'Update link',
        aksEnabled: 'AKS activated',
        advokatindestaaelse: 'Advokatindestaaelse for open RKI',
        bankAccountDetails: 'Bank account details',
        updateBankAccountDetails: 'Update account',
        autoRKI: 'Auto-RKI',
        automaticDebtRegister: 'Override automatic register in RKI',
        useAutomaticDebtRegister: 'Set automatic registration in RKI on creditor',
        useAutoRKIOpen: 'Set Open RKI on creditor',
        useAutoRKIIgnoreUnresolvedOppositions: 'Set ignore unresolved interactions (oppositions) on creditor',
        selfCollection: 'Self collection',
        useSelfCollectionOption: 'Set self collection on creditor',
        outboundCall: 'Outbound call',
        useOutboundCallOption: 'Set outbound call on creditor',
        autoVerify: 'Auto verify cases',
        useAutoVerifyOption: 'Set auto verify on creditor',
        paymentTerms: 'Payment terms',
        paymentDays: 'Payment days',
        billingRecipients: 'Billing recipients',
        billingRecipientsDescription: 'Set multiple emails like this',
        automaticExpireVouchers: 'Override automatic expiration of vouchers',
        useAutomaticExpireVouchers: 'Set automatic expiration of vouchers on creditor',
        configurationOptions: 'Configurations',
        experianConfig: 'Experian configurations',
        courtSubmitConfig: 'Configuration for automatical court submission',
        foundationExpiration: 'Expiration with foundation',
        normalExpiration: 'Expiration without foundation',
        interestExpiration: 'Interest expiration',
        debtorFAQ: 'Frequently asked questions (shown in debtor web)',
        faqHeader: 'Need help creating a new creditor?',
        faqText: 'We have made an article about how to do so. Click the botton below to read more.',
        newUserDisabled: 'New users cannot be created with current creditor state',
        cancelledError: 'Access has been cancelled',
        cancelledErrorMessage: 'Your access is cancelled. Contact us for more information.',
        eInvoice: {
            eInvoice: 'E-invoice',
            companyId: 'Company id',
            identification: 'Identification number',
            addChildCompany: 'Add as child company',
        },
    },
    collectorTypes: {
        [collectors_1.CollectorType.CREDITOR]: 'Creditor',
        [collectors_1.CollectorType.TENANT]: 'Collector',
    },
    collectors: {
        collector: 'Collector',
        updateEntity: 'Save',
        masterData: 'Information',
        layout: 'Layout',
        websites: 'Websites',
        legal: 'Legal',
        paymentOptions: 'Payment option',
        communicationChannels: 'Communication channels',
        namePlaceholder: 'Name',
        centralRegisterIdPlaceholder: 'Local company registration number',
        nicknamePlaceholder: 'Nickname',
        addressPlaceholder: 'Address',
        logoFileIdPlaceholder: 'Logo',
        letterFrontLogoFileIdPlaceholder: 'Logo used on first page of letters',
        websitePlaceholder: 'Website',
        clientWebBasePlaceholder: 'Creditor web base',
        debtorWebBasePlaceholder: 'Debtor web base',
        titlePlaceholder: 'Company title',
        privacyPolicyPlaceholder: 'Privacy policy',
        businessTermsPlaceholder: 'Business Terms',
        emailPlaceholder: 'Email',
        replyToPlaceholder: 'Reply-to email',
        phonePlaceholder: 'Phone',
        paymentOptionsPlaceholder: 'Payment options',
        themePlaceholder: 'Theme',
        hideEmail: 'Hide email',
    },
    paymentPlans: {
        cannotOfferPaymentPlan: 'Unfortunately, we cannot offer you any payment plans online. Please contact the debt collector.',
        paymentPlansDisabled: 'Payment plans disabled',
        paymentPlan: 'Payment plan',
        customFoundation: 'Foundation for payment plans',
        customFoundationDescription: 'Choose which template is to be used as a foundation of debt in the debtor web. If no template is selected, a default foundation is used.',
        skipTo: 'Skip to',
        collapsedEntries: 'collapsed entries',
        deletePaymentPlan: 'Delete payment plan',
        progress: 'Progress',
        selectPaymentPlan: 'Select payment plan',
        signPaymentPlan: 'Sign payment plan',
        selectPaymentMethod: 'Select payment method',
        confirmation: 'Confirmation',
        createNewPaymentPlan: 'Create new payment plan',
        months: 'months',
        month: 'month',
        totalPayment: 'Total repayment',
        createCustomPlan: 'Create Custom Payment Plan',
        createStandardPlan: 'Create Standard Payment Plan',
        byAmount: 'By amount',
        byDuration: 'By duration',
        monthly: 'Monthly',
        everyOtherMonth: 'Two months',
        quarterly: 'Quarterly',
        everyOtherWeek: 'Two weeks',
        weekly: 'Weekly',
        rest: 'Rest',
        generate: 'Generate',
        entries: 'Entries',
        entry: 'Entry',
        date: 'Date',
        reminder: 'Reminder',
        lastChanceOfPayment: 'Last chance of payment',
        addedInterests: 'Added interests',
        cancelled: 'Plan cancelled if no payment',
        amount: 'Amount',
        confirmationCheckbox: 'Send confirmation when payment plan is activated',
        activate: 'Activate',
        cancel: 'Cancel',
        agreement: 'Agreement',
        inputAmount: 'Type in the amount.',
        details: 'Details',
        createPaymentPlan: 'Create payment plan',
        activatePaymentPlanWithoutFoundation: 'Activate payment plan without foundation.',
        errorCaseEnded: "Can't create payment plan: case has ended",
        CREATED: 'Created',
        ACTIVE: 'Active',
        FINISHED: 'Finished',
        CANCELED: 'Canceled',
        DELETED: 'Deleted',
        errorInInput: 'Error in input',
        save: 'Save',
        calculationFoundation: 'Amount or duration',
        calculationFoundationDescription: "Select the payment plan's calculation basis. Either an amount or the number of entries.",
        calculateByAmount: 'Calculate based on an amount',
        calculateByDuration: 'Calculate based on a duration',
        startDate: 'Start date',
        startDateDescription: 'Payment date for the first entry.',
        upfrontPayment: 'Upfront payment',
        upfrontPaymentDescription: 'If an upfront payment that shows willingness to pay is needed, it can be switched on here.',
        upfrontPaymentDate: 'Date for upfront payment',
        interval: 'Interval',
        intervalDescription: 'Choose the timespan between payment plan entries.',
        interestFree: 'Interest free period',
        interestFreeDescription: 'If an interest free period is needed it can be selected here.',
        interestFreeFrom: 'From',
        interestFreeTo: 'To',
        moreSettings: 'More settings',
    },
    RKI: {
        registration: 'RKI registration',
        createNewRegistration: 'Create new registration',
        newRegistration: 'New RKI registration',
        chooseDebtor: 'Choose debtor',
        amount: 'Amount',
        withFoundation: 'With foundation',
        chooseFoundationType: 'Choose foundation type',
        dateFoundation: 'Date for foundation',
        foundationCode: {
            [customers_1.FoundationCode.betalingspåkrav1påtegning]: 'Betalingspåkrav 1. påtegning',
            [customers_1.FoundationCode.betalingspåkrav2påtegning]: 'Betalingspåkrav 2. påtegning',
            [customers_1.FoundationCode.stævning]: 'Stævning',
            [customers_1.FoundationCode.fogedsag]: 'Fogedsag',
            [customers_1.FoundationCode.dom]: 'Dom',
            [customers_1.FoundationCode.insolvens]: 'Insolvenserklæring i anden sag',
            [customers_1.FoundationCode.konkurs]: 'Konkurs',
            [customers_1.FoundationCode.tvangsakkord]: 'Tvangsakkord, indledt',
            [customers_1.FoundationCode.retsforlig]: 'Retsforlig',
            [customers_1.FoundationCode.fogedretsrekv]: 'Fogedretsrekv',
            [customers_1.FoundationCode.offentliginberetning]: 'Offentlig inberetning',
            [customers_1.FoundationCode.tvangsauktion]: 'Tvangsauktion-fordring opgjort',
            [customers_1.FoundationCode.tvangsauktionudlæg]: 'Tvangsauktion - udlæg',
            [customers_1.FoundationCode.gældssanering]: 'Gældssanering, indledt',
            [customers_1.FoundationCode.skylderklæring]: 'Skylderklæring',
            [customers_1.FoundationCode.forlig]: 'Frivilligt forlig',
            [customers_1.FoundationCode.speciel]: 'Speciel',
        },
        state: {
            [customers_1.RKIStates.REPORTED]: 'REPORTED',
            [customers_1.RKIStates.ERROR]: 'ERROR',
            [customers_1.RKIStates.PUBLISHED]: 'PUBLISHED',
            [customers_1.RKIStates.DELETED]: 'DELETED',
            [customers_1.RKIStates.CONCLUDED]: 'CONCLUDED',
        },
        registry: {
            [customers_1.RKIRegistries.OPEN]: 'OPEN',
            [customers_1.RKIRegistries.CLOSED]: 'CLOSED',
        },
        status: 'Status',
        remark: 'Remark',
        deleteReason: 'Deletion cause',
        deleteCode: 'Deletion code',
        latestReminderDate: 'Date for latest reminder',
        autoRKI: {
            errors: {
                [debt_register_1.RKIRegistrationError.AlreadyRegistered]: 'The debtor is already registered in RKI',
                [debt_register_1.RKIRegistrationError.MissingWarning]: 'Missing RKI warning',
                [debt_register_1.RKIRegistrationError.WrongCurrency]: 'Currency is not DKK',
                [debt_register_1.RKIRegistrationError.WarningLetterWasReturned]: 'RKI warning letter was returned',
                [debt_register_1.RKIRegistrationError.EmailWarningWasNeverDelivered]: 'RKI warning email was never delivered',
                [debt_register_1.RKIRegistrationError.WarningIsOlderThanOneYear]: 'RKI warning letter is older than one year',
                [debt_register_1.RKIRegistrationError.FoundationCouldNotBeMapped]: 'Foundation code could not be identified',
                [debt_register_1.RKIRegistrationError.FoundationDateCouldNotFound]: 'Foundation date could not be found',
                [debt_register_1.RKIRegistrationError.UnresolvedOpposition]: 'Unresolved interaction',
                [debt_register_1.RKIRegistrationError.OppositionFound]: 'Active opposition',
                [debt_register_1.RKIRegistrationError.NoRegistryFound]: 'Does not comply with requirements for any registry',
                [debt_register_1.RKIRegistrationError.FoundationAmountCouldNotBeFound]: 'Amount on foundation is missing',
                [debt_register_1.RKIRegistrationError.FoundationAmountTooSmall]: 'Amount on foundation is too small for open RKI',
                [debt_register_1.RKIRegistrationError.NameTooLong]: 'RKI tillader maksimalt 60 tegn i navnet ved registrering. Hvis det eksempelvis er en enkeltmandsvirksomhed, kan "v/" fjernes og alt efter "/v".',
            },
        },
        infobox: {
            herebyRegister: 'hereby registers',
            open: 'Open',
            closed: 'Closed',
            inExperian: "in Experian's",
            debtorNotPaid: 'RKI-register, since debtor has not paid the due amount of DKK',
            criteria: 'The case complies with the following criterias:',
            min18years: 'Debtor is minimun 18 years of age',
            min3messages: 'Debtor has recieved a minimun of 3 messages from creditor and/or collector regarding the debt',
            totalDebt: 'Total debt including rates and fees is of minimum DKK 1.000',
            hasFoundation: 'Has foundation',
            debtorWarning: 'Debtor has been warned for at least 15 days ago and at most 6 months ago',
            totalPrincipal: 'Total principal is minimum DKK 200',
            noDemurral: 'Debtor has not demurred',
            institutionsInfo: "Insurance companies, financial institutions and mortgage credit institutions are not allowed to register debtors in RKI without the case has been heard by civil court or bailiff's court",
            incoming: 'Interactions marked as oppositions and unresolved interactions',
            letterReturned: 'RKI warning letter returned',
            specialCreditors: "Insurance companies, financial institutions and mortgage credit institutions are not allowed to register debtors in RKI without the case has been heard by civil court or bailiff's court",
            closedRegister: 'Closed RKI',
            openRegister: 'Open RKI',
            foundationType: 'Registration with the correct foundation type',
            registerButton: 'Register in RKI',
            finePrint: {
                NB: "NB: Experian's system can last up to 10 minutes to process reporting and changes in the RKI-register. If the registration or the change is chosen for manual processing, it can last several weekdays to process.",
                letter: 'Debtor will receive a letter from Experian a few days after the registration has been published.',
                expiration: 'Registrations in the closed expires after 2 years. It can be extended up to 5 if it transfers to the open register. Registrations in the open exired after 5 years from the foundation date.',
                faultyData: 'If there is any problems with the data, then RKI Data Team can be contacted at dataservicerki.faellespostkasse@experian.com',
                newClient: 'To create a new client, contact klientoprettelse@experian.com',
            },
        },
    },
    financials: {
        debtExpiresWithinThreeMonths: 'Debt Expiring Within 3 months',
        debtExpired: 'Debt expired',
        principal: 'Principal',
        interests: 'Interests',
        costs: 'Costs',
        debt: 'Debt',
        deposit: 'Deposit',
        balance: 'Balance',
        revenue: 'Revenue',
        revenueBasedDepositOrder: 'Revenue based deposit order',
        interestBasedDepositOrder: 'Interest based deposit order',
        details: 'Details',
        invoiceId: 'Invoice ID',
        reminderFee: 'Reminder Fee',
        overpayment: 'Overpayment',
        repayment: 'Repayment',
        responsibleForRepayment: 'Responsible for repayment',
        sourceBankAccount: 'Source bank account',
        registrationNumber: 'Registration number',
        accountNumber: 'Account number',
        repaymentAmount: 'Repayment amount',
        sendRepaymentRequest: 'Send repayment request',
        currency: 'Currency',
        imposedByCollector: 'Debt imposed by collector',
        imposedByCreditor: 'Debt imposed by creditor',
    },
    navigation: {
        overview: 'Overview',
        home: 'Home',
        cases: 'Cases',
        transactions: 'Transactions',
        economy: 'Economy',
        economyCaseVouchers: 'Case vouchers',
        economyBookkeeping: 'Bookkeeping',
        economyImposedDebt: 'Imposed debt',
        economyDeposits: 'Deposits',
        economySetup: 'Settings',
        economyBilling: 'Billing',
        economyPayment: 'Payment',
        economyPayouts: 'Payouts',
        economyChartOfAccounts: 'Chart of accounts',
        economyUnknown: 'Unknown Transactions',
        bankAccounts: 'Accounts',
        export: 'Export',
        transactionLookup: 'Transaction lookup',
        economyIrrecoverableDebt: 'Irrecoverable debt',
        economyExpiredDebt: 'Expired debt',
        reports: 'Insights',
        communication: 'Channels',
        content: 'Content',
        customerCare: 'Customer Care',
        creditors: 'Creditors',
        creditorEconomy: 'Economy',
        creditorInvoicing: 'Billing',
        creditorCustomers: 'Customers',
        creditorCases: 'Cases',
        creditorCollector: 'Collector',
        creditorIrrecoverableDebt: 'Irrecoverable debt',
        creditorExpiredDebt: 'Expired debt',
        creditorEconomySetup: 'Setup',
        creditorSetup: 'Settings',
        creditorWorkflows: 'Workflows',
        creditorUsers: 'Users',
        creditorIntegrations: 'Integrations',
        journalizer: 'Journalizer',
        returnLetters: 'Return letters',
        outbox: 'Outbox',
        outboundCalls: 'Outbound calls',
        import: 'Import',
        support: 'Support',
        search: 'Search cases...',
        settings: 'Settings',
        settingsDesc: 'Settings for tenant',
        user: 'My account',
        userDesc: 'Your settings',
        homeOverview: 'Overview',
        settingsGeneral: 'General',
        settingsTemplates: 'Templates',
        settingsDevelopers: 'Developers',
        settingsDevelopersDesc: 'Access to API and more',
        settingsChangelogs: 'Changelogs',
        settingsChangelogsDesc: 'Changes in the systemet',
        settingsSwitchAccount: 'Switch account',
        settingsSwitchAccountDesc: 'Switch between accounts',
        settingsTenantBilling: 'Billing',
        settingsTenantBillingDesc: 'See all invoices',
        settingsProperties: 'Properties',
        settingsCaseGroups: 'Case groups',
        settingsCaseConfig: 'Case config',
        settingsWebhooks: 'Webhooks',
        settingsEmbed: 'Embed',
        settingsAPI: 'API',
        settingsCollectors: 'Collectors',
        settingsIntegrateCalendar: 'Synchronize tasks to calendar',
        settingsEconomy: 'Economy',
        settingsPriceList: 'Price list',
        settingsBookkeeping: 'Bookkeeping appendix',
        settingsBilling: 'Billing setup',
        settingsBankAccounts: 'Bank accounts',
        settingsCaseVoucherTypes: 'Case voucher types',
        settingsBillingVoucherTypes: 'Billing voucher types',
        settingsUsers: 'Users',
        settingsTribunal: 'Tribunal',
        settingsTeams: 'Teams',
        settingsTenant: 'Tenant',
        settingsUpdateTypes: 'Tasks',
        settingsProcedures: 'Shortcuts',
        settingsApplications: 'Applications',
        settingsCaseMergeRules: 'Case merge rules',
        settingsPaymentPlansConfig: 'Payment plans',
        settingsJournalizerConfig: 'Journalizer',
        reportsExorts: 'File Exports',
        reportsPaymentPlans: 'Payment plans',
        reportsSankey: 'Debbie flow chart',
        settingsWorkflows: 'Workflows',
        reportsPaymentDays: 'Payment days chart',
        myAccount: 'My account',
        integrations: 'Integrations',
    },
    timespanUnits: {
        [__1.TimespanUnit.Years]: 'Years',
        [__1.TimespanUnit.Quarters]: 'Quarters',
        [__1.TimespanUnit.Months]: 'Months',
        [__1.TimespanUnit.Weeks]: 'Weeks',
        [__1.TimespanUnit.Days]: 'Days',
        [__1.TimespanUnit.Hours]: 'Hours',
        [__1.TimespanUnit.Minutes]: 'Minutes',
        [__1.TimespanUnit.Seconds]: 'Seconds',
        [__1.TimespanUnit.MS]: 'Milliseconds',
    },
    paymentPlansConfig: {
        description: 'Setup what options the debtor should be offered when entering a payment plans by themselves.',
        minEntryAmountPlaceholder: 'Minimum amount per installment',
        durationPlaceholder: 'Months',
        addOption: 'Add',
        save: 'Save',
        override: 'Override config on creditor',
        disablePaymentPlans: 'Turn off payment plans so that neither debtors nor case workers can set up payment plans.',
        requireCentralRegisterId: 'Require CPR/CVR number before signature',
        activationDeadlineDays: 'Cancel unactivated payment plans after number of days',
    },
    referenceIdFinders: {
        referenceIdFinding: 'Reference id search',
        description: 'Journalize emails and match deposits based on reference numbers such as customer numbers or case voucher references (e.g., invoice number).',
        length: 'Number of digits in the reference number',
        min: 'Minimum possible reference number',
        max: 'Maximum possible reference number',
        createNew: 'Create new reference number search',
        add: 'Add',
        caseVoucherReference: 'Case voucher reference',
        caseVoucherReferenceDescription: 'Case voucher reference (e.g., invoice number)',
        customerReference: 'Customer reference',
        customerReferenceDescription: 'Customer reference (e.g. patient, client, or membership number)',
    },
    caseMergeRules: {
        description: 'Decide wether new vouchers regarding a customer should be added to existing cases or a new case should be created.',
        preventMerge: 'Prevent merge with cases',
        caseStatusVerified: 'Merge with verified cases',
        adjustVariableCaseVouchers: 'Adjust debt collection costs and fees',
        caseStatusPending: 'Merge with pending cases',
        hasFoundation: 'Merge with cases with foundation',
        caseVoucherConstraints: 'Case vouchers types with duplicate control',
        caseVoucherConstraintsDescription: 'Select which case voucher types should not appear on both cases if they are created within the specified number of days. The newest case vouchers will be removed.',
        caseVoucherConstraintsAllDays: 'Remove all',
        caseVoucherConstraintsDays: 'Days',
        addCaseVoucherConstraint: 'Add duplicate control',
        addCaseVoucherConstraintSelectVoucherType: 'Select case voucher type',
        addCaseVoucherConstraintUniqueInDays: 'Unique within number of days (leave empty if all should be removed)',
        addCaseVoucherConstraintAddButton: 'Add',
        doesNotHaveUpdateTypeIds: 'Do not merge with cases with these tasks',
        doesHaveUpdateTypeIds: 'Only merge with cases with these tasks',
        hasActivePaymentPlan: 'Merge cases with an active payment plan',
    },
    workflows: {
        workflows: 'Workflows',
        customWorkflows: 'Created workflows',
        standardWorkflow: 'Standard workflows',
        creditorStandardWorkflowDescription: 'Set up which workflow new cases are to be created in. If you change the workflow here, it will not change already created cases.',
        creditorInteraction: 'to creditor',
        removeVouchers: 'Remove',
        rollbackTask: 'Rollback task',
        rolledback: 'Rolled back',
        runTask: 'Move case to this task',
        sureYouWantToDeleteTask: 'Are you sure you want to delete the task?',
        addRequirement: 'Add requirement',
        searchUpdates: 'Search',
        noUpdatesToShow: 'No tasks to show',
        manualSelection: 'Manual selection',
        priority: 'Priority',
        priorityDescription: 'If a path cannot be automatically found the priority will be used. 1 is top priority.',
        timing: 'Timing',
        requirements: 'Requirements',
        amount: 'Amount',
        imposedByCreditor: 'Imposed by creditor',
        text: 'Text',
        addTodo: 'Add todo',
        selectTemplate: 'Choose template',
        includeVoucherAttachments: 'Attach voucher appendices (invoice for example).',
        selectEmailPDFAttachment: 'Choose template to be attached the email.',
        sendImmediatelyDeviateFromSettings: 'Skal omgående afsendelse afvige fra generelle indstillinger på din konto?',
        sendImmediately: 'Send med det samme',
        doNotSendImmediately: 'Send ikke med det samme',
        selectCollector: 'Choose collector',
        useCreditorCollector: 'Use creditors identity',
        creditorCollector: 'Creditors identity',
        setAsPrincipalReferenceCaseVoucher: 'Set as reference case voucher of principal',
        setMaxTotalAmount: 'Set max. amount',
        maxTotalAmount: 'Max. amount',
        selectCaseGroup: 'Choose case group',
        timespan: 'Timespan',
        timespanUnit: 'Timespan unit',
        timespanUnitQuantity: 'Timespan',
        timeOfDay: 'Time of day',
        moreThan: 'More than',
        thresholdAmount: 'Amount',
        caseGroup: 'Case group',
        percentageSplitFrom: 'Percentage split from',
        percentageSplitTo: 'Percentage split to',
        selectedCreditor: 'Creditor',
        onlySelectedVoucherCategories: 'Only selected voucher categories',
        title: 'Title',
        description: 'Description',
        newWorkflow: 'New workflow',
        createNewWorkflow: 'Create workflow',
        updateWorkflow: 'Update workflow',
        duplicateWorkflow: 'Duplicate workflow',
        endedCasesPercentage: 'ended cases',
        casesInTask: 'cases in status',
        task: 'Task',
        pause: 'Pause',
        pauseCase: 'Should the case be paused?',
        pauseUnlimited: 'Paus unlimited',
        remindNow: 'Remind now',
        stats: 'Statistics',
        endedCases: 'Ended cases',
        sum: 'Sum',
        totalCases: 'Total count of cases that have been in this status',
        currentCases: 'Cases rurrently in this status',
        incomingInteractionsStats: 'Incoming interactions',
        paymentPlansCreatedStats: 'Payment plans created',
        satisfactionStats: 'Reputation',
        alternativePaths: 'Alternative paths',
        alternativePath: 'Alternative path',
        addAlternativePath: 'Add alternative path',
        source: 'From task id',
        mergeCaseTodoDescription: 'The case will be tried merged with other cases on the customer based on the rules of merging. It is also possible to merge the case with related cases based on relation types selected below.',
        mergeWithRelatedCasesOfType: 'Possibility to merge with related cases with relation types',
        applyCustomMergeRules: 'Custom case merge rules',
        settings: {
            workflowSettings: 'Workflow settings',
            disableWorkflows: 'Disable workflows',
            disableWorkflowsWarning: 'Are you sure that you want to disable ALL workflows?',
            workflowsDisabled: 'Workflows are disabled',
            limitExecutionInterval: 'Limit the time interval where workflows can run',
        },
    },
    timingTypes: {
        [workflows_1.TimingType.Timespan]: 'Timespan',
        [workflows_1.TimingType.TimespanFromDueDate]: 'Timespan from newest due date',
    },
    updatesEditor: {
        update: 'Task',
        information: 'Information',
        informationDescription: 'Workflows that the task is added to.',
        standardSettings: 'General',
        standardSettingsDescription: 'General settings for this task.',
        label: 'Label',
        save: 'Save',
        updateTypeGroup: 'Task group',
        selectUpdateTypeGroup: 'Choose task group',
        important: 'Important',
        importantPlaceholder: 'This task is important and should be highlighted on the case.',
        pausing: 'Pausing',
        pausingPlaceholder: 'This task should be pausing the case',
        selectable: 'Selectable',
        selectablePlaceholder: 'This task can be selected on a case',
        procedure: 'Procedure',
        procedureDescription: 'The procedure that this task should execute. If turned on, the procedure defined will be executed if it is in a workflow.',
        procedureOn: 'Turn on procedure for this task',
        procedurePlaceholder: 'Turn on procedure',
        onCaseExit: 'On case exit',
        onCaseExitDescription: 'If a case is ended with this task, put on a self-chosen task.',
        onCaseExitContinueUpdates: 'Should tasks of this type be continued when a case is ended?',
        continueOnCaseExit: 'Continue on case end',
        onCaseExitPauseWith: 'On case exit put pause the case with this task',
        selectUpdateType: 'Update type',
        roles: 'Roles',
        rolesDescription: 'Choose responsible role',
        responsibleRole: 'Responsible role',
        hiddenForCreditors: 'Hidden for creditors',
        hiddenForCreditorsPlaceholder: 'Should this task be hidden for creditors?',
        introduction: 'Introduction',
        introductionDescription: 'Introduction to the update with text and possibly a picture. It is an advantage, if the creditor is responsible, to make a good introduction.',
        introductionHeaderImage: 'Hero image',
        introductionHeaderImageDropText: 'Drag and drop a hero image here',
        deleteButton: 'Delete task',
        deleteWarning: 'You both delete the update type but also all updates of the type. Do you want to continue?',
    },
    workflowTodoTypes: {
        [workflows_1.TodoType.AddVoucher]: 'Add voucher',
        [workflows_1.TodoType.AddBillingVoucher]: 'Add billing voucher',
        [workflows_1.TodoType.RemoveVoucher]: 'Remove voucher',
        [workflows_1.TodoType.CreateInteraction]: 'Create interaction',
        [workflows_1.TodoType.CreateCreditorInteraction]: 'Create interaction to creditor',
        [workflows_1.TodoType.SetCollector]: 'Set collector',
        [workflows_1.TodoType.SetCaseGroup]: 'Set case group',
        [workflows_1.TodoType.MoveToTenant]: 'Move case to tenant',
        [workflows_1.TodoType.ChangeCaseStatus]: 'Change case status',
        [workflows_1.TodoType.OutboundCall]: 'Outbound call',
        [workflows_1.TodoType.SetCaseTag]: 'Add case tag',
        [workflows_1.TodoType.DebtRegister]: 'Debt register',
        [workflows_1.TodoType.DebtRegisterSkip]: 'Ready to debt register?',
        [workflows_1.TodoType.SubmitToCourt]: 'Submit to court',
        [workflows_1.TodoType.ReadyToSubmitToCourt]: 'Ready to submit to court?',
        [workflows_1.TodoType.ConnectToDebtCollector]: 'Send to a connect partner',
        [workflows_1.TodoType.ReturnToConnectSource]: 'Return case to connect partner',
        [workflows_1.TodoType.SwitchWorkflow]: 'Switch workflow',
        [workflows_1.TodoType.SwitchBackToPreviousWorkflow]: 'Switch back to previous workflow',
        [workflows_1.TodoType.Bespoke]: 'Custom',
        [workflows_1.TodoType.MergeCase]: 'Merge case if possible',
        [workflows_1.TodoType.CreateProperties]: 'Create properties',
    },
    workflowPathWarnings: {
        [workflows_1.PathWarning.ReadyForEboksRequirementRecommended]: 'Requirement "Ready for e-Boks" recommended',
        [workflows_1.PathWarning.ValidEmailRequirementRecommended]: 'Requirement "Email valid" recommended',
        [workflows_1.PathWarning.ValidAddressRequirementRecommended]: 'Requirement "Address valid" recommended',
    },
    workflowRequirementTypes: {
        [workflows_1.RequirementType.DoesNotHaveUpdate]: 'Does not have selected update',
        [workflows_1.RequirementType.HasUpdate]: 'Does have selected update',
        [workflows_1.RequirementType.HasNoValidAddress]: 'Address invalid',
        [workflows_1.RequirementType.HasValidCentralRegisterId]: 'Has cvr / cpr',
        [workflows_1.RequirementType.HasNoValidCentralRegisterId]: 'Does not have cvr / cpr',
        [workflows_1.RequirementType.HasValidAddress]: 'Address valid',
        [workflows_1.RequirementType.HasValidEmail]: 'Email valid',
        [workflows_1.RequirementType.HasNoValidEmail]: 'Email invalid',
        [workflows_1.RequirementType.IsCompany]: 'Is company',
        [workflows_1.RequirementType.HasEAN]: 'Has valid EAN',
        [workflows_1.RequirementType.ReadyForEboks]: 'Ready for e-boks',
        [workflows_1.RequirementType.HasValidPhone]: 'Phone valid',
        [workflows_1.RequirementType.HasNoValidPhone]: 'Phone invalid',
        [workflows_1.RequirementType.IsPrivate]: 'Is private person',
        [workflows_1.RequirementType.AmountThreshold]: 'Amount threshold',
        [workflows_1.RequirementType.CaseGroup]: 'Is in case group',
        [workflows_1.RequirementType.PercentageSplit]: 'Percentage cases',
        [workflows_1.RequirementType.HasFoundation]: 'Has foundation',
        [workflows_1.RequirementType.DoesNotHaveFoundation]: 'Does not have foundation',
        [workflows_1.RequirementType.SpecificCreditor]: 'Specific creditor',
        [workflows_1.RequirementType.CustomerHasTag]: 'Customer has tag',
        [workflows_1.RequirementType.HasIncomingInteractions]: 'Has incoming interaction',
    },
    embeds: {
        embeds: 'Embed',
        embedTitle: 'Title of embed area',
        embedURL: 'URL to be called',
        embedHeight: 'Height of area in px',
        addEmbedArea: 'Add embed area',
        embedPlacement: 'Placement',
        embedToken: 'Validation token',
        embedCreatedAt: 'Created at',
        noAreasYet: 'No embed areas yet',
        couldNotLoad: 'Could not load',
        caseworkerNavMenuItemCategory: 'External',
        creditorNavMenuItemCategory: 'External',
    },
    embedPlacements: {
        [embeds_1.EmbedPlacement.CaseworkerWebCreditorPage]: 'Debbie Caseworker Web: Creditor page top right',
        [embeds_1.EmbedPlacement.CaseworkerWebCasePage]: 'Debbie Caseworker Web: Case page under the economy panel',
        [embeds_1.EmbedPlacement.CaseworkerWebMenuItem]: 'Debbie Caseworker Web: Full page with link in the menu to the right',
        [embeds_1.EmbedPlacement.CreditorWebCasePage]: 'Debbie Creditor Web: Case page under the economy panel',
        [embeds_1.EmbedPlacement.CreditorWebFrontPage]: 'Debbie Creditor Web: Front page to the right',
        [embeds_1.EmbedPlacement.CreditorWebMenuItem]: 'Debbie Creditor Web: Full page with link in the menu to the right',
    },
    webhookSettings: {
        noWebhooksYet: 'No webhooks yet',
    },
    apiSettings: {
        keys: 'API keys',
        noKeysYet: 'There is no keys yet',
        newKeyButton: 'Create new API key',
        newKey: 'New API key',
        newKeyCreatedInfo: 'That was it! Remember to store your key in a safe location. This is the first and last time you will be able to get it from Debbie.',
        closeModal: 'Understood',
        keyName: 'Name your API key',
        createNewKey: 'Create new API key',
    },
    updateTypeSettings: {
        label: 'Label',
        responsibleRole: 'Responsible role',
        isImportant: 'Important',
        tenantSpecific: 'Tenant specific',
        isTenantSpecific: 'Is tenant specific',
        referenceType: 'Reference type',
        onCaseExit: 'On case exit pause with',
        isPausing: 'Pausing',
        hiddenForRoles: 'Hidden for role',
        knowledgeBaseLink: 'Knowledge base',
    },
    overview: {
        todoList: 'Todo-list',
        noDescription: 'No description',
        noPauseStatus: 'No pause status',
        settlementTime: 'Settlement time in months',
        instalmentAgreement: 'Instalment agreement',
        statistics: 'Statistics',
        averageIntro: 'It takes an average of',
        averageOutro: 'days for a case to be settled.',
        quantityCases: 'Quantity of cases',
        quantifyCustomers: 'Quantity of customers',
        statusDistribution: 'Status distribution',
        chartStatuses: {
            Godkendt: 'Approved',
            'Afventer Godkendelse': 'Awaiting Approval',
            Afsluttet: 'Completed',
            Annuleret: 'Annulled',
            Afslutningsårsag: 'Completion cause',
        },
    },
    endReason: {
        [cases_1.SystemEndReason.ErrorCreditor]: 'Error from creditor',
        [cases_1.SystemEndReason.ErrorUs]: 'Wrong creation',
        [cases_1.SystemEndReason.Expiration]: 'The case is expired',
        [cases_1.SystemEndReason.Departed]: 'Debtor has departed (moved/left)',
        [cases_1.SystemEndReason.Unidentified]: 'Debtor can not be validated',
        [cases_1.SystemEndReason.AddressUnknown]: "Debtor's address is unknown",
        [cases_1.SystemEndReason.Paid]: 'Debtor has paid the entire debt',
        [cases_1.SystemEndReason.Transferred]: 'Case is transferred',
        [cases_1.SystemEndReason.Dead]: 'Debtor has passed away',
        [cases_1.SystemEndReason.Objection]: 'Closed because of objection',
        [cases_1.SystemEndReason.Withdrawn]: 'The creditor has withdrawn the case',
        [cases_1.SystemEndReason.OfferFromUs]: 'Paid according to composition offer from us',
        [cases_1.SystemEndReason.OfferFromDebtor]: 'Paid according to composition offer from debtor',
        [cases_1.SystemEndReason.DebtRelief]: 'Debtor has gained debt relief',
        [cases_1.SystemEndReason.Bankruptcy]: 'Debtor is bankrupt',
        [cases_1.SystemEndReason.ForcedDissolved]: 'Debtor has been forced to wind up',
        [cases_1.SystemEndReason.ConflictOfInterest]: 'Conflict of interest between debtor and us',
        [cases_1.SystemEndReason.NegativePayoff]: 'Negative payoff for the creditor',
        [cases_1.SystemEndReason.Overpayment]: 'Debtor has paid too much',
        [cases_1.SystemEndReason.Minor]: 'Debtor is a minor',
        [cases_1.SystemEndReason.Irrecoverable]: 'The case is irrecoverable',
        [cases_1.SystemEndReason.PartiallyPaid]: 'Partially paid',
        [cases_1.SystemEndReason.CreditorUnresponsive]: 'The creditor is unresponsive',
        [cases_1.SystemEndReason.Merged]: 'Case is merged',
        [cases_1.SystemEndReason.FireAndForget]: 'Fire & forget',
        [cases_1.SystemEndReason.SmallCaseNotWanted]: 'Small case not wanted',
        [cases_1.SystemEndReason.NoDebt]: 'No debt',
        [cases_1.SystemEndReason.Deleted]: 'Deleted',
        [cases_1.SystemEndReason.NoCourt]: 'The case is through the extrajudicial process',
        [cases_1.SystemEndReason.Other]: 'Other reason',
    },
    courtSubmitErrors: {
        [auto_submit_1.SubmitToCourtError.IsNotWarned]: 'Case not warned',
        [auto_submit_1.SubmitToCourtError.CurrencyNotDKK]: 'Currency not DKK',
        [auto_submit_1.SubmitToCourtError.WarningWasReturned]: 'Warning not delivered',
        [auto_submit_1.SubmitToCourtError.AlreadyHasFoundation]: 'A foundation has already been registered on this case',
        [auto_submit_1.SubmitToCourtError.MoreThanOneDebtor]: 'There is more than one debtor on this case',
        [auto_submit_1.SubmitToCourtError.HasAlternativeContact]: 'Case has alternative contact',
        [auto_submit_1.SubmitToCourtError.EconomyContactMissing]: 'A responsible for payment to court is missing',
        [auto_submit_1.SubmitToCourtError.CreditorNameMissing]: 'Creditor name missing',
        [auto_submit_1.SubmitToCourtError.CreditorAddressMissing]: 'Creditor address is missing',
        [auto_submit_1.SubmitToCourtError.CompanyFullResponsibleParticipantMissing]: '"Fuldt ansvarlig deltager" Is missing',
        [auto_submit_1.SubmitToCourtError.CompanyDirectorNameMissing]: 'Name of director is missing',
        [auto_submit_1.SubmitToCourtError.CompanyDirectorAddressMissing]: 'Address of director is missing',
        [auto_submit_1.SubmitToCourtError.JurisdictionMissing]: 'Could not find court',
        [auto_submit_1.SubmitToCourtError.EconomicalSubmitThreshold]: 'Case balance less than the threshold',
        [auto_submit_1.SubmitToCourtError.SagsfremstillingMissing]: 'Case presentation is missing',
        [auto_submit_1.SubmitToCourtError.CaseHasExceededMaxDebtRegistrationsThreshold]: 'Case has exceeded creditors max debt registrations threshold',
        [auto_submit_1.SubmitToCourtError.AlreadyInCourt]: 'Already registered in court',
        [auto_submit_1.SubmitToCourtError.AddressNotInDK]: 'Address not danish',
        [auto_submit_1.SubmitToCourtError.DebtorMovedAbroad]: 'Debtor has moved abroad',
        [auto_submit_1.SubmitToCourtError.CaseHasDeposits]: 'Case has deposits',
        [auto_submit_1.SubmitToCourtError.DebtorBankrupt]: 'Debtor is bankrupt',
        [auto_submit_1.SubmitToCourtError.DebtorCompanyCeased]: 'Debtor company ceased',
        [auto_submit_1.SubmitToCourtError.DebtorDead]: 'Debtor is dead',
        [auto_submit_1.SubmitToCourtError.DebtorHomeless]: 'Debtor is homeless',
        [auto_submit_1.SubmitToCourtError.ExcessiveReminderFeeImposed]: 'Too many reminder fees imposed',
        [auto_submit_1.SubmitToCourtError.ExcessiveCollectionFeeImposed]: 'Too many collection fees imposed',
        [auto_submit_1.SubmitToCourtError.ExcessiveCollectionCostImposed]: 'The collection costs do not match the calculated amount',
        [auto_submit_1.SubmitToCourtError.ExcessivePrincipal]: 'The principal is above the maximum allowed',
    },
    templateTags: {
        [templates_1.TemplateTag.BPKWarning]: 'Bailiff warning',
        [templates_1.TemplateTag.RKIWarning]: 'RKI warning',
    },
    templates: {
        allTemplates: 'All templates',
        customTemplates: 'Created templates',
        standardTemplates: 'Standard templates',
        confirmDelete: 'Are you sure you want to delete this template?',
        delete: 'Delete',
        updateTypesUsingThisTemplate: 'Tasks using this template',
        newTemplate: 'New template',
        selectType: 'Select type',
        letter: 'Letter',
        name: 'Name',
        create: 'Create',
        quantityTemplates: 'Quantity Templates',
        singleOwner: 'Select a single owner',
        standard: 'Standard',
        alternativeContact: 'Alternative contact',
        saveDraft: 'Save Draft',
        saveAndPublish: 'Save and publish',
        preview: 'Preview',
        versions: 'Versions',
        publish: 'Publish',
        copyOtherTemplate: 'Import from template',
        copy: 'Copy template',
        settings: 'Settings',
        lastChangedOn: 'Last changed on',
        by: 'by',
        WIP: 'Work in progress',
        versionPublished: 'This version is Published',
        selectTestCase: 'Please select a test case',
        collector: 'Collector',
        ifCollectorSelected: 'If selected this template will only be show on cases with the collector.',
        selectCollector: 'Select collector',
        creditor: 'Creditor',
        ifCreditorSelected: 'If selected this template will only be show on cases with the creditor.',
        selectCreditor: 'Select creditor',
        letterTheme: 'Letter theme',
        ifThemeSelected: 'This selects the design of the template.',
        selectTheme: 'Select template theme',
        fileName: 'File name',
        state: 'State',
        type: 'Type',
        savedAt: 'Saved at',
        firstName: 'First name',
        lastName: 'Last name',
        view: 'View',
        confirmDeleteItem: 'Are you sure you wish to delete this item?',
        confirmPublish: 'Changes are NOT saved. You are going to publish the last saved version of the template. Are you sure?',
        validations: {
            missing: 'Missing',
            invalidOrder: 'Invalid order',
            inSubject: 'in subject',
            inBody: 'in body',
        },
        addTag: 'Add tag',
        selectTag: 'Select tag',
    },
    templateTypes: {
        [templates_1.TemplateType.AUTOCALL]: 'Autocall',
        [templates_1.TemplateType.EBOKS]: 'e-Boks',
        [templates_1.TemplateType.EMAIL]: 'E-mail',
        [templates_1.TemplateType.LETTER]: 'Letter',
        [templates_1.TemplateType.SMS]: 'SMS',
    },
    integrations: {
        chooseCreditor: 'Choose the creditor for integration',
        active: 'Active',
        activeIntegrations: 'Active integrations',
        available: 'Integrations available for creditor',
        unavailable: 'Integrations unavailable for creditor',
        isAvailable: 'Give creditor access to setup or disable integration',
        connect: 'Connect',
        deactivate: 'Pause integration',
        reactivate: 'Reactivate',
        integrationOptions: 'integration options',
        importAllText: 'Import invoices before due date',
        updateCustomers: 'Update customer data, when changed in e-conomic',
        cutoffDateText: 'Cutoff date (Only import invoices after this date, imports all if not set)',
        runsOut: '',
        turnsDue: '',
        invoiceDate: 'Number of days after the invoice date the postings should be transferred',
        dueDate: 'Number of days after the invoice due date the postings should be transferred',
        notChangable: 'The options can not be changed again later.',
        all: 'All',
        recommended: 'Recommended',
        essential: 'Essential',
        additionalCustomers: 'additional customers',
    },
    eConomicTypeName: {
        creditNote: 'Credit note',
        invoice: 'Invoice',
        payment: 'Payment',
        reminder: 'Reminder',
    },
    integrationMapper: {
        voucherNumber: 'Voucher number',
        invoiceNumber: 'Invoice number',
        amountLeftToMap: 'Amount left to map',
        totalAmount: 'Voucher amount',
        noMoreEntries: 'There are no more entries to map',
        selectEntries: 'Select an entry to start mapping',
        customerId: 'Customer id',
        map: 'Map',
        notAvailable: 'E-conomic mapping not available yet, contact the Debbie support for help with mapping',
        selectedEntryLabel: 'Selected entry without mapping',
        potentialMatches: 'Potential matches',
    },
    createdBy: {
        createdBy: 'Created by',
        goToImport: 'Go to import',
    },
    createdByType: {
        [performed_by_1.PerformedByType.Connect]: 'connect',
        [performed_by_1.PerformedByType.Import]: 'import',
        [performed_by_1.PerformedByType.Integration]: 'integration',
        [performed_by_1.PerformedByType.Key]: 'API key',
        [performed_by_1.PerformedByType.User]: 'user',
        [performed_by_1.PerformedByType.Workflow]: 'workflow',
    },
    journalizer: {
        update: 'Update',
        deleteInteraction: 'Delete interaction',
        unknownEntityInteraction: 'Request journal number',
        recentlyJournalized: 'RECENTLY JOURNALIZED',
        unmap: 'UNMAP',
        suggested: 'SUGGESTED',
        noInteractions: 'There are currently no interactions',
        searchCreditors: 'Search creditors...',
        journalizeOnCase: 'Journalize on case',
        journalizeOnCreditor: 'Journalize on creditor',
    },
    returnLetter: {
        unknownAtAddress: 'Unknown recipient',
        addressNotAdequate: 'The address is inadequate',
        nameNotVisible: "The recipient's name is not visible on the mailbox",
        recipientMoved: 'The recipient moved and the new address is unknown or there are problems concerning moving',
        recipientNoExist: 'The recipient does not exist',
        letterCantBeDelivered: 'The letter can not be delivered',
        cantFindStreet: 'Street name/house number can not be found',
        mailboxIssue: 'Problems with the mailbox',
        emptyPlace: 'The residence is uninhabited/empty house/apartment',
        noHouseOrConstruction: 'There is no residence or it is under construction',
        otherIssues: 'Issues such as lack of snow removal or other issues that prevent access',
        deliveryRejected: 'Delivery rejected',
        recipientRejectsLetter: 'The recipient rejects the delivery and does not accept to receive the letter',
    },
    returnLetterReasons: {
        [interactions_1.ReturnReason.DENIED]: 'Denied',
        [interactions_1.ReturnReason.NOTDELIVERABLE]: 'Not deliverable ',
        [interactions_1.ReturnReason.UNKNOWNRECIPIENT]: 'Unknown recipient',
    },
    outbox: {
        verifyInteraction: 'Verify interaction',
        editTemplate: 'Edit template',
        deleteInteraction: 'Delete interaction',
        rollbackChain: 'Rollback workflow',
        goToCase: 'Go to case',
        envelope: 'Envelope',
        nextLetterSending: 'Next letter sending scheduled to',
        filters: 'Filters',
        includeInteractionsPaused: 'Include interactions on paused cases',
        filterOnInteractionType: 'Filter on types of interactions',
        filterOnCreditor: 'Filter on creditor',
        filterOnTemplate: 'Filter on template',
        autoSendModalHeader: 'Set up automatic sending',
        autoSendDescription: 'Specify how many manual sends must be made from the outbox for each template version before messages are sent automatically. If you set the value to 0, all messages will be sent automatically without requiring approval. This allows for flexibility between full automation and manual control—depending on your needs.',
        configureAutoSend: 'Set up automatic sending',
        autoSendOn: 'Once {{autoSendQuantity}} messages using this template version have been sent, all future messages will be sent automatically.',
    },
    inputs: {
        creditorSelect: 'Select creditor',
        from: 'From',
        to: 'To',
        phoneNumber: 'Phone number',
        phoneLocale: 'Locale',
        searchForCompany: 'Search companies',
        searchAddress: 'Search address',
        manual: 'Manual',
        address: 'Address',
        noAddress: 'No address',
        co: 'C/O',
        zipcode: 'Zipcode',
        city: 'City',
        country: 'Country',
        done: 'Done',
        removeAddress: 'Remove address',
        remove: 'Remove',
        save: 'Save',
        saved: 'Saved',
        dropToUpload: 'Drop to upload',
        uploadFailed: 'Upload failed',
        overrideDefault: 'Override default value',
        overrideTenantSetting: 'Override tenant setting',
    },
    paymentOptions: {
        addNew: 'Add new payment option',
        currencies: 'Valutaer',
        bankName: 'Bank name',
        registrationNumber: 'Registration number',
        accountNumber: 'Account number',
        fi: 'FI creditor number',
        fikSyntax: 'Brug hovedstolsposteringens referencenummer som id i stedet for sagsnummer',
        iban: 'IBAN creditor number',
        swift: 'SWIFT creditor number',
        reepayPrivateKey: 'Billwerk+ private API key',
        farpayPrivateKey: 'Farpay private API key',
        dankort: 'Dankort',
        visa: 'Visa',
        mastercard: 'Mastercard',
        currencySpecific: 'Only selected currencies',
        mobilepay: 'MobilePay',
        swish: 'Swish',
        vipps: 'Vipps',
        betalingsservice: 'Betalingsservice',
        leverandorservice: 'Leverandørservice',
        isActive: 'Active payment gateway',
        confirmChangeOfPaymentGateway: 'Are you sure you want to change your payment gateway?',
        mobilePeopleHmac: 'MobilePeople HMAC',
        mobilePeopleClientRef: 'MobilePeople Client Reference',
        url: 'Link to payment gateway',
        titleToDebtor: 'Debtorweb title',
        descriptionToDebtor: 'Debtorweb description',
        hideOnDebtorweb: 'Hide on debtor web',
    },
    paymentOptionTypes: {
        [collectors_1.PaymentOptionType.BANKTRANSFER]: 'Bank transfer',
        [collectors_1.PaymentOptionType.FI]: 'FIK line',
        [collectors_1.PaymentOptionType.IBAN]: 'IBAN',
        [collectors_1.PaymentOptionType.SWIFT]: 'SWIFT',
        [collectors_1.PaymentOptionType.REEPAY]: 'Billwerk+ Payment Gateway',
        [collectors_1.PaymentOptionType.FARPAY]: 'Farpay Payment Gateway',
        [collectors_1.PaymentOptionType.MOBILE_PEOPLE]: 'MobilePeople Payment Gateway',
        [collectors_1.PaymentOptionType.LINK_TO_OWN_PAYMENT]: 'Link to own payment gateway',
    },
    todoPanel: {
        searchTodos: 'Search',
    },
    support: {
        imgsrc: 'https://storage.googleapis.com/debbie-public-files/help-ad-en.svg',
        readMore: 'Read more',
    },
    home: {
        welcome: 'Welcome',
        todos: 'Todos',
        caseworkerTodo: 'Caseworker Todos',
        todoPlaceholder: 'Nothing to show',
        clientTodo: 'Creditor Todos',
        clientTodoPlaceholder: 'Nothing to show',
        noResponsibleTodo: 'Todos without any responsible',
        noResponsibleTodoPlaceholder: 'Nothing to show',
        pendingCases: 'Pending cases',
        pendingCasesPlaceholder: 'No pending cases to show',
        pendingDunningCases: 'New dunning cases',
        pendingDunningCasesPlaceholder: 'No new dunning cases to show',
        topCases: 'Top 150 cases by debt amount',
        topCasesPlaceholder: 'No case to show',
        unassigned: 'Unassigned',
        today: 'Today',
        yesterday: 'Yesterday',
        thisMonth: 'This month',
        lastMonth: 'Last month',
        deposits: 'Deposits',
        depositsSmall: 'deposits',
        depositsToClient: 'Deposits to creditor',
        depositsToCollector: 'Deposits to collector',
        depositCount: 'Deposit count',
        paymentPlans: 'Payment Plans',
        totalPlans: 'Total plans',
        totalActivePlans: 'Active plans',
        totalSettledAmount: 'Total settled amount',
        settledAmountLastMonth: 'Settled amount last month',
        settledAmountThisMonth: 'Settled amount this month',
        plannedAmountNextMonth: 'Planned amount next month',
        cases: 'Cases',
        interactions: 'Interactions',
        foundations: 'Foundations',
        totalFoundations: 'Total foundations',
    },
    autoCall: {
        called: 'Called',
        from: 'from',
        with: 'with',
        withVoice: "s' voice",
        call: 'Call',
        addAction: 'Add action',
        selectAction: 'Select action',
    },
    autoCallEvents: {
        started: 'Started',
        ringing: 'Ringing',
        answered: 'Answered',
        completed: 'Completed',
        inbound: 'Inbound',
        busy: 'Busy',
        timeout: 'Not answered',
        rejected: 'Rejected',
        machine: 'Voicemail',
    },
    interactionTypes: {
        [interactions_1.InteractionType.AutoCall]: 'Autocall',
        [interactions_1.InteractionType.ClientNote]: 'Creditor message',
        [interactions_1.InteractionType.DebtorNote]: 'Debtor message',
        [interactions_1.InteractionType.Eboks]: 'e-Boks',
        [interactions_1.InteractionType.Kivra]: 'Kivra',
        [interactions_1.InteractionType.Digipost]: 'Digipost',
        [interactions_1.InteractionType.Email]: 'Email',
        [interactions_1.InteractionType.Letter]: 'Letter',
        [interactions_1.InteractionType.Note]: 'Note',
        [interactions_1.InteractionType.Other]: 'Other',
        [interactions_1.InteractionType.Personal]: 'Personal',
        [interactions_1.InteractionType.Phone]: 'Call',
        [interactions_1.InteractionType.SMS]: 'SMS',
        [interactions_1.InteractionType.EInvoice]: 'E-Invoice',
    },
    interactions: {
        metadata: 'Metadata',
        removingPhoneNumberOnSubmit: 'When registering the phone call the phone number will be deleted from debtor.',
        events: 'Events',
        sendLetter: 'Send letter',
        addTemplate: 'Add from template',
        sendEBoks: 'Send',
        from: 'From',
        to: 'To',
        subject: 'Subject',
        sent: 'Sent',
        debtorInteraction: 'Message',
        newInteractions: 'New interactions',
        areYouSureProcedure: 'Are you sure you want to execute this shortcut?',
        procedures: 'Shortcuts',
        reminder: 'Reminder',
        unlikelyToReceive: 'Prior interactions using this channel failed',
        other: 'Other',
        OUTGOING: 'Outgoing',
        INCOMING: 'Incoming',
        UNMAPPED: 'Unmapped',
        MAPPED: 'Mapped',
        HANDLED: 'Handled',
        DELETED: 'Deleted',
        PENDING: 'Pending',
        CANCELLED: 'Cancelled',
        SENT: 'Sent',
        QUEUED: 'Queued',
        delete: 'Delete',
        verify: 'Verify',
        transacted: 'Sent',
        journalizedAt: 'Journalized at',
        at: 'at',
        rollback: 'Rollback',
        unmap: 'Unmap',
        editTemplate: 'Edit template',
        envelope: 'Envelope',
        readMore: 'Read More',
        readLess: 'Read Less',
        clicked: 'Link clicked',
        complained: 'Complained',
        delivered: 'Delivered',
        failed: 'Failed',
        opened: 'Opened',
        unsubscribed: 'Unsubscribed',
        downloadFailed: 'Download failed',
        downloadSuccessful: 'Preview PDF is downoladed',
        selectTemplate: 'Select template',
        contact: 'Contact',
        preview: 'Preview',
        mention: 'Merge field',
        explanation: 'Explanation',
        example: 'Example',
        addDebtorDocuments: 'Add debtor documents',
        addIntent: 'Add intent',
        sendEmail: 'Send Email',
        reply: 'Reply',
        replyingTo: 'Replying to',
        thread: 'View thread',
        emailThread: 'Email thread',
        note: 'Note',
        addNote: 'Add note',
        sendNoteToDebtor: 'Send note to debtor',
        sendNoteToClient: 'Send note to creditor',
        addFiles: 'Add files',
        remindingDescription: 'Reminding description',
        remindingDate: 'Reminding date',
        setReminder: 'Set reminder',
        download: 'Download',
        phoneNumber: 'Phone number',
        phoneNotes: 'Phone notes',
        registerPhoneCall: 'Register phone call',
        sendSMS: 'Send SMS',
        opposition: 'Opposition',
        notOpposition: 'Not-opposition',
        optionalNote: 'Optional note',
        visibilityCheckText: 'Visible to creditor',
        hideFromClient: 'Hide from creditor',
        hiddenFromClient: 'Hidden from creditor',
        showToClient: 'Show to creditor',
        printPDF: 'Print/download PDF',
        clone: 'Clone to other case',
        cloned: 'Interaction cloned',
        eInvoiceEvents: {
            created: 'Created',
            transmissionStarted: 'Transfer started',
            transmissionCompleted: 'Transfer completed',
            sent: 'Sent',
            received: 'Received',
            endpointNotFound: 'Error',
            error: 'Error',
        },
    },
    outboundPhone: {
        noCasesLeft: 'No cases to show',
        priority: 'Priority',
        nextCase: 'Next case',
    },
    outgoingPhoneCallTags: {
        [interactions_1.PhoneOutgoingTag.FullPayment]: 'Full payment',
        [interactions_1.PhoneOutgoingTag.IncorrectNumber]: 'Number does not exist',
        [interactions_1.PhoneOutgoingTag.NoAnswer]: 'No answer',
        [interactions_1.PhoneOutgoingTag.WrongNumber]: 'Wrong number',
        [interactions_1.PhoneOutgoingTag.Opposition]: 'Opposition',
        [interactions_1.PhoneOutgoingTag.Other]: 'Other reason',
        [interactions_1.PhoneOutgoingTag.OtherAgreement]: 'Other agreement',
        [interactions_1.PhoneOutgoingTag.PaymentPlan]: 'Payment plan',
    },
    incomingPhoneCallTags: {
        [interactions_1.PhoneIncomingTag.FullPayment]: 'Full payment',
        [interactions_1.PhoneIncomingTag.Opposition]: 'Opposition',
        [interactions_1.PhoneIncomingTag.Other]: 'Other reason',
        [interactions_1.PhoneIncomingTag.OtherAgreement]: 'Other agreement',
        [interactions_1.PhoneIncomingTag.PaymentPlan]: 'Payment plan',
        [interactions_1.PhoneIncomingTag.Billing]: 'Billing',
        [interactions_1.PhoneIncomingTag.Terms]: 'Terms',
        [interactions_1.PhoneIncomingTag.Caseworking]: 'Caseworking',
    },
    procedures: {
        procedure: 'Shortcut',
        customProcedures: 'Created shortcuts',
        standardProcedures: 'Standard shortcuts',
        general: 'General',
        generalDescription: 'General settings for this shortcut',
        showOnCase: 'Show on case',
        save: 'Save',
        selectedProcedure: 'Shortcuts',
        createProcedure: 'Create shortcut',
        title: 'Title',
        description: 'Description',
        triggers: 'Triggers',
        defaultToSystemStandard: 'If no trigger selected:',
        associatedWithCollector: 'Associated with collector',
        selectCollector: 'Select collector',
        associatedWithCreditor: 'Associated with creditor',
        selectCreditor: 'Select creditor',
        tasks: 'Tasks',
        tasksDescription: 'Tasks to be run.',
        automaticTask: 'Automatic tasks',
        selectUpdate: 'Select tasks',
        add: 'Add',
        economyProcedureTriggers: 'Economy',
        paymentPlansProcedureTriggers: 'Payment plans',
        debtExpiredProcedureTriggers: 'Debt expiration',
        CosmoProcedureTriggers: 'Debtor events',
        otherProcedureTriggers: 'Others',
    },
    procedureTypes: {
        [procedures_1.SystemProcedure.CreditorEndedCase]: 'When creditor ends a case',
        [procedures_1.SystemProcedure.EndCase]: 'On case end',
        [procedures_1.SystemProcedure.Overpayment]: 'On overpayment',
        [procedures_1.SystemProcedure.RemainderReminder]: 'On remainder reminder',
        [procedures_1.SystemProcedure.PrincipalPayment]: 'On remainder reminder matching principal',
        [procedures_1.SystemProcedure.PaymentOnCourtCase]: 'On payment on case in court',
        [procedures_1.SystemProcedure.EndCaseAccord]: 'On accord case end',
        [procedures_1.SystemProcedure.Update]: 'On case update',
        [procedures_1.SystemProcedure.InteractionSentToDebtor]: 'On manual interaction sent to debtor',
        [procedures_1.SystemProcedure.PaymentPlanInitial]: 'On activation of payment plan',
        [procedures_1.SystemProcedure.PaymentPlanDocumentSigned]: 'On signing of document when activating a payment plan',
        [procedures_1.SystemProcedure.PaymentPlanReminder]: 'On reminder of payment plan entry',
        [procedures_1.SystemProcedure.PaymentPlanPayment]: 'On payment plan entry payment',
        [procedures_1.SystemProcedure.PaymentPlanAutoPaymentFailure]: 'On payment plan entry payment failure',
        [procedures_1.SystemProcedure.PaymentPlanBSLSSubmitFailed]: 'On betalingsservice payment submit failure',
        [procedures_1.SystemProcedure.PaymentPlanBSLSRejected]: 'On betalingsservice payment rejected',
        [procedures_1.SystemProcedure.PaymentPlanBSLSAgreementCancelled]: 'On betalingsservice agreement cancelled',
        [procedures_1.SystemProcedure.PaymentPlanDeadline]: 'On payment plan entry deadline',
        [procedures_1.SystemProcedure.PaymentPlanCanceled]: 'On payment plan entry cancellation',
        [procedures_1.SystemProcedure.PaymentPlanTwoHourActivationReminder]: 'Two hours after payment plan has been selected but not activated',
        [procedures_1.SystemProcedure.PaymentPlanOneDayActivationReminder]: 'One day after payment plan has been selected but not activated',
        [procedures_1.SystemProcedure.PaymentPlanThreeDayActivationReminder]: 'Three days after payment plan has been selected but not activated',
        [procedures_1.SystemProcedure.CancelUnactivatedPaymentPlansAfterActivationDeadline]: 'Cancel unactivated payment plans after activation deadline',
        [procedures_1.SystemProcedure.PaymentPlanCreationByCaseworker]: 'When a caseworker creates a payment plan',
        [procedures_1.SystemProcedure.BankAccountDetailsApprovalRefund]: 'Approval after typing in bank account details for payout of overpayment',
        [procedures_1.SystemProcedure.DebtExpired]: 'When a voucher expires',
        [procedures_1.SystemProcedure.DebtExpiresWithinThreeMonths]: 'When a voucher expires within three monhts',
        [procedures_1.SystemProcedure.DebtExpiresWithinThreeMonthsWithFoundation]: 'When a voucher with foundation expires within three monhts',
        [procedures_1.SystemProcedure.DebtorCanBeRegisteredInDebtRegister]: 'When debtor can be registered in a debt register but is not yet registered',
        [procedures_1.SystemProcedure.DebtorIsUnderage]: 'On underage debitor',
        [procedures_1.SystemProcedure.Address]: 'On address change',
        [procedures_1.SystemProcedure.Active]: 'When a debtor becomes active',
        [procedures_1.SystemProcedure.Dead]: 'On death',
        [procedures_1.SystemProcedure.Disappeared]: 'On disappearance',
        [procedures_1.SystemProcedure.MovedAbroad]: 'When a debtor moves abroad',
        [procedures_1.SystemProcedure.Homeless]: 'When a debtor becomes homeless',
        [procedures_1.SystemProcedure.CompanyActive]: 'When a company becomes active',
        [procedures_1.SystemProcedure.Inactive]: 'When a company becomes inactive',
        [procedures_1.SystemProcedure.OperationsCeased]: 'When operation is ceased',
        [procedures_1.SystemProcedure.AddressProtection]: 'When address or name protection is registered',
        [procedures_1.SystemProcedure.NewRKIRegristration]: 'When new external RKI registration is registered',
        [procedures_1.SystemProcedure.DeletedRKIRegistration]: 'When external RKI registration is deleted',
        [procedures_1.SystemProcedure.DeletedRKIRegistrationWillingnessToPay]: 'When external RKI registration is deleted with indication of willingness to pay',
        [procedures_1.SystemProcedure.GuardianStatus]: 'On change of guardian status',
        [procedures_1.SystemProcedure.DissolutionStatus]: 'On dissolution status change',
        [procedures_1.SystemProcedure.AKSFailed]: 'When AKS fails to subscribe',
        [procedures_1.SystemProcedure.BOBEHANDLING]: 'On bankruptcy or death',
    },
    procedureTitles: {
        [procedures_1.SystemProcedure.CreditorEndedCase]: 'When creditor ends a case trough the API',
        [procedures_1.SystemProcedure.EndCase]: 'Fully paid case',
        [procedures_1.SystemProcedure.Overpayment]: 'Overpayment',
        [procedures_1.SystemProcedure.RemainderReminder]: 'Partial paid case',
        [procedures_1.SystemProcedure.PrincipalPayment]: 'Partial paid case',
        [procedures_1.SystemProcedure.PaymentOnCourtCase]: 'Payment on case in court',
        [procedures_1.SystemProcedure.EndCaseAccord]: 'Accord payment',
        [procedures_1.SystemProcedure.Update]: 'Case update',
        [procedures_1.SystemProcedure.InteractionSentToDebtor]: 'Manual interaction sent to debtor',
        [procedures_1.SystemProcedure.PaymentPlanInitial]: 'Payment Plan Initial',
        [procedures_1.SystemProcedure.PaymentPlanDocumentSigned]: 'On signing of document when activating a payment plan',
        [procedures_1.SystemProcedure.PaymentPlanReminder]: 'Payment Plan Reminder',
        [procedures_1.SystemProcedure.PaymentPlanPayment]: 'Payment Plan Settle Success',
        [procedures_1.SystemProcedure.PaymentPlanAutoPaymentFailure]: 'Payment Plan Settle Failure',
        [procedures_1.SystemProcedure.PaymentPlanBSLSSubmitFailed]: 'Payment Plan Submit Failure BS & LS',
        [procedures_1.SystemProcedure.PaymentPlanBSLSRejected]: 'Payment Plan rejected payment BS & LS',
        [procedures_1.SystemProcedure.PaymentPlanBSLSAgreementCancelled]: 'Payment Plan agreement cancelled BS & LS',
        [procedures_1.SystemProcedure.PaymentPlanDeadline]: 'Payment Plan Deadline',
        [procedures_1.SystemProcedure.PaymentPlanCanceled]: 'Payment Plan Canceled',
        [procedures_1.SystemProcedure.PaymentPlanTwoHourActivationReminder]: 'Payment Plan Two Hour Activation Reminder',
        [procedures_1.SystemProcedure.PaymentPlanOneDayActivationReminder]: 'Payment Plan One Day Activation Reminder',
        [procedures_1.SystemProcedure.PaymentPlanThreeDayActivationReminder]: 'Payment Plan Three Days Activation Reminder',
        [procedures_1.SystemProcedure.CancelUnactivatedPaymentPlansAfterActivationDeadline]: 'Cancel unactivated payment plans',
        [procedures_1.SystemProcedure.PaymentPlanCreationByCaseworker]: 'Manual Payment Plan Creation Send Offer',
        [procedures_1.SystemProcedure.BankAccountDetailsApprovalRefund]: 'Approval after typing in bank account details for payout of overpayment',
        [procedures_1.SystemProcedure.DebtExpired]: 'Debt expired',
        [procedures_1.SystemProcedure.DebtExpiresWithinThreeMonths]: 'Debt expires within 3 months',
        [procedures_1.SystemProcedure.DebtExpiresWithinThreeMonthsWithFoundation]: 'Debt expires within 3 months with foundation',
        [procedures_1.SystemProcedure.DebtorCanBeRegisteredInDebtRegister]: 'When debtor can be registered in debt register but is not yet registered',
        [procedures_1.SystemProcedure.DebtorIsUnderage]: 'Debtor is underage',
        [procedures_1.SystemProcedure.Address]: 'Address',
        [procedures_1.SystemProcedure.Active]: 'Active',
        [procedures_1.SystemProcedure.Dead]: 'Dead',
        [procedures_1.SystemProcedure.Disappeared]: 'Disappeared',
        [procedures_1.SystemProcedure.MovedAbroad]: 'Moved abroad',
        [procedures_1.SystemProcedure.Homeless]: 'Homeless',
        [procedures_1.SystemProcedure.CompanyActive]: 'Company active',
        [procedures_1.SystemProcedure.Inactive]: 'Inactive',
        [procedures_1.SystemProcedure.OperationsCeased]: 'Operations ceased',
        [procedures_1.SystemProcedure.AddressProtection]: 'Name/address protection',
        [procedures_1.SystemProcedure.NewRKIRegristration]: 'New RKI registration',
        [procedures_1.SystemProcedure.DeletedRKIRegistration]: 'Deleted RKI registration',
        [procedures_1.SystemProcedure.DeletedRKIRegistrationWillingnessToPay]: 'Deleted RKI registration with indication of willingness to pay',
        [procedures_1.SystemProcedure.GuardianStatus]: 'Guardian status',
        [procedures_1.SystemProcedure.DissolutionStatus]: 'Dissolution status',
        [procedures_1.SystemProcedure.AKSFailed]: 'AKS failed',
        [procedures_1.SystemProcedure.BOBEHANDLING]: 'Estate administration',
    },
    procedureDescriptions: {
        [procedures_1.SystemProcedure.CreditorEndedCase]: 'When creditor ends a case trough the API',
        [procedures_1.SystemProcedure.EndCase]: 'Close case and inform contact person.',
        [procedures_1.SystemProcedure.Overpayment]: 'More has been paid than has been charged.',
        [procedures_1.SystemProcedure.RemainderReminder]: 'Case partially paid. Inform contact person',
        [procedures_1.SystemProcedure.PrincipalPayment]: 'Case partially paid. Inform contact person',
        [procedures_1.SystemProcedure.PaymentOnCourtCase]: 'Payment on case in court. Inform court',
        [procedures_1.SystemProcedure.EndCaseAccord]: 'Close case with accord payment',
        [procedures_1.SystemProcedure.Update]: 'The case has been updated.',
        [procedures_1.SystemProcedure.InteractionSentToDebtor]: 'Manual interaction sent to debtor',
        [procedures_1.SystemProcedure.PaymentPlanInitial]: 'Confirmation send out when creating new plans',
        [procedures_1.SystemProcedure.PaymentPlanDocumentSigned]: 'On signing of document when activating a payment plan',
        [procedures_1.SystemProcedure.PaymentPlanReminder]: 'Reminder send out before the payment date',
        [procedures_1.SystemProcedure.PaymentPlanPayment]: 'When a payment plan is successfully settled',
        [procedures_1.SystemProcedure.PaymentPlanAutoPaymentFailure]: 'When a payment plan settlement is failed',
        [procedures_1.SystemProcedure.PaymentPlanBSLSSubmitFailed]: 'When a payment plan with BS or LS failed to schedule payment',
        [procedures_1.SystemProcedure.PaymentPlanBSLSRejected]: 'When a payment plan with BS or LS has a rejected payment after the first of the month',
        [procedures_1.SystemProcedure.PaymentPlanBSLSAgreementCancelled]: 'When a payment plan with BS or LS get the agreement cancelled',
        [procedures_1.SystemProcedure.PaymentPlanDeadline]: 'When a payment plan is not paid before deadline',
        [procedures_1.SystemProcedure.PaymentPlanCanceled]: 'When a payment plan is not paid after giving a second chance',
        [procedures_1.SystemProcedure.PaymentPlanTwoHourActivationReminder]: 'When a payment plan is created but not activated after two hours',
        [procedures_1.SystemProcedure.PaymentPlanOneDayActivationReminder]: 'When a payment plan is created but not activated after one day',
        [procedures_1.SystemProcedure.PaymentPlanThreeDayActivationReminder]: 'When a payment plan is created but not activated after three days',
        [procedures_1.SystemProcedure.CancelUnactivatedPaymentPlansAfterActivationDeadline]: 'Cancel unactivated payment plans after activation deadline',
        [procedures_1.SystemProcedure.PaymentPlanCreationByCaseworker]: 'Send Offer for Manual Payment Plan Created by a Caseworker',
        [procedures_1.SystemProcedure.BankAccountDetailsApprovalRefund]: 'Approval after typing in bank account details for payout of overpayment',
        [procedures_1.SystemProcedure.DebtExpired]: 'The debt is expired',
        [procedures_1.SystemProcedure.DebtExpiresWithinThreeMonths]: 'The debt expires wihtin 3 months',
        [procedures_1.SystemProcedure.DebtExpiresWithinThreeMonthsWithFoundation]: 'Debt with foundation expires within 3 months',
        [procedures_1.SystemProcedure.DebtorCanBeRegisteredInDebtRegister]: 'When debtor can be registered in debt register but is not yet registered',
        [procedures_1.SystemProcedure.DebtorIsUnderage]: 'On underage debitor',
        [procedures_1.SystemProcedure.Address]: 'On address change',
        [procedures_1.SystemProcedure.Active]: 'When a debtor becomes active',
        [procedures_1.SystemProcedure.Dead]: 'On death',
        [procedures_1.SystemProcedure.Disappeared]: 'On disappearance',
        [procedures_1.SystemProcedure.MovedAbroad]: 'When a debtor moves abroad',
        [procedures_1.SystemProcedure.Homeless]: 'When a debtor becomes homeless',
        [procedures_1.SystemProcedure.CompanyActive]: 'When a company becomes active',
        [procedures_1.SystemProcedure.Inactive]: 'When a company becomes inactive',
        [procedures_1.SystemProcedure.OperationsCeased]: 'When operation is ceased',
        [procedures_1.SystemProcedure.AddressProtection]: 'When address or name protection is registered',
        [procedures_1.SystemProcedure.NewRKIRegristration]: 'When new external RKI registration is registered',
        [procedures_1.SystemProcedure.DeletedRKIRegistration]: 'When external RKI registration is deleted',
        [procedures_1.SystemProcedure.DeletedRKIRegistrationWillingnessToPay]: 'When external RKI registration is deleted with indication of willingness to pay',
        [procedures_1.SystemProcedure.GuardianStatus]: 'On change of guardian status',
        [procedures_1.SystemProcedure.DissolutionStatus]: 'On dissolution status change',
        [procedures_1.SystemProcedure.AKSFailed]: 'When AKS fails to subscribe',
        [procedures_1.SystemProcedure.BOBEHANDLING]: 'On bankruptcy or death',
    },
    panels: {
        filters: 'Filters',
        selectAll: 'Select all',
        totalDebt: 'Total debt',
        clickToQueueText: 'Click to queue selected cases',
        queue: 'Queue',
    },
    misc: {
        notChosen: 'Not chosen',
        copiedToClipboard: 'Copied to clipboard!',
        cosmoActivated: 'Activated',
        searchForAccount: 'Search for account',
        approve: 'Approve',
        cancel: 'Cancel',
        okay: 'Okay',
        create: 'Create',
        createdAt: 'Created',
        updatedAt: 'Updated',
        submit: 'Submit',
        save: 'Save',
        saved: 'Saved',
        edit: 'Edit',
        update: 'Update',
        errorUpdating: 'Error updating',
        language: 'Language',
        chooseFile: 'Choose file',
        yes: 'Yes',
        no: 'No',
        all: 'All',
        add: 'Add',
        enabled: 'Enabled',
        search: 'Search',
        contactSupport: 'Contact our support',
        error: 'Error',
        errorOccured: 'An error occured',
        days: 'Days',
        date: 'Date',
        loadingError: 'Could not load data',
        export: 'Export',
        exported: 'Exported',
        goToCase: 'Go to case',
        after: 'after',
        skip: 'Skip',
        value: 'Value',
        delete: 'Delete',
        id: 'id',
        type: 'Type',
        text: 'Text',
        state: 'State',
    },
    table: {
        next: 'Next',
        previous: 'Previous',
        first: 'First',
        last: 'Last',
        showing: 'Showing',
        outOf: 'out of',
        loadMore: 'Load more',
        from: 'From',
        to: 'To',
        search: 'Search',
        noData: 'No data',
    },
    history: {
        history: 'History',
        searchHistory: 'Search history',
        filterHistory: 'Filter history',
        filterEconomy: 'Economy',
        filterBilling: 'Billing',
        filterUpdates: 'Updates',
        filterInteractions: 'Interactions',
        filterDebts: 'Debts',
        filterDebtorTransactions: 'Debtor Transactions',
        filterNotifications: 'Notifications',
        filterCaseStatus: 'Case Status',
        filterNotes: 'Notes',
        caseCreated: 'Case created',
        creditorDisbursement: 'Creditor disbursement',
        creditorVat: 'Creditor VAT',
        creditorFee: 'Creditor fee',
        deposit: 'Billing of deposit',
    },
    connect: {
        fromConnectPartner: 'From a connect partner',
        connection: 'Connection',
        product: 'Product',
        updates: 'Updates',
        mappedCases: 'Connected cases',
        updatedBy: 'Updated by ',
        partner: 'connect partner',
        us: 'this tenant',
        thirdParty: 'a third party',
        sendsToConn: 'Connection sends cases to',
        sendsFromConn: 'Connection receives cases from',
        histItemHeader: 'Connect -',
        histItemExported: 'Sent to partner',
        histItemRetracted: 'Withdrawn',
        histItemCompleted: 'Task completed',
        histItemDataUpdated: 'Data updated',
        completedWithReason: 'Completed with reason',
        createdDocuments: 'Created documents',
        createdSatisfaction: 'Created satisfaction',
        goToConnection: 'Go to connection',
        goToCreditorWeb: 'Go to creditor web',
        goToCreditor: 'Go to receiving creditor',
        goToProduct: 'Go to product',
        goToCase: 'Go to case',
        creditorWebLinkError: 'Error getting link for creditor web',
        case: 'Case',
        state: 'State',
        exportedDate: 'Exported date',
        completedDate: 'Completed date',
        connectStateCompleted: 'Completed',
        connectStateInProgress: 'In progress',
    },
    connectConnectionUpdate: {
        [connections_1.ConnectConnectionStatus.Active]: 'Active',
        [connections_1.ConnectConnectionStatus.Paused]: 'Paused',
        [connections_1.ConnectConnectionStatus.Disabled]: 'Disabled',
    },
    connectCaseMappingUpdate: {
        [mappings_1.ConnectCaseMappingStatus.Exported]: 'Exported',
        [mappings_1.ConnectCaseMappingStatus.Retracted]: 'Retracted',
        [mappings_1.ConnectCaseMappingStatus.Completed]: 'Completed',
        [mappings_1.ConnectCaseMappingStatus.DataUpdated]: 'Data updated',
    },
    connectRetractionReason: {
        [mappings_1.RetractionReason.Collected]: 'Debt collected',
        [mappings_1.RetractionReason.ConnectionDisabled]: 'Connect connection disabled',
        [mappings_1.RetractionReason.Rollback]: 'Rolled back',
        [mappings_1.RetractionReason.Other]: 'Other',
    },
    product: {
        productHandles: 'Product provides',
    },
    productService: {
        [products_1.ProductService.Collection]: 'collection',
        [products_1.ProductService.CourtHandling]: 'court handling',
    },
    documents: {
        documents: 'Documents',
        noDocuments: 'No documents',
        deleteDocument: 'Delete document',
        saveDocument: 'Save document',
        autoRKIAddFoundation: 'Auto-RKI is enabled and will attempt to move the RKI registration to the open registry after this foundation is added',
        autoRKIUpdateFoundation: 'Auto-RKI is enabled and will attempt to move the RKI registration to the open registry after this foundation is updated',
        file: 'File',
        signedFile: 'Signed file',
        createdBy: 'Created by',
        docId: 'Doc ID',
        type: 'Type',
        signingLink: 'Signing link',
        generateSigningLink: 'Generate signing link',
        createdAt: 'Created',
        date: 'Date',
        signedAt: 'signed',
        addDocument: 'Add document',
        fromFile: 'From file',
        fromTemplate: 'From template',
        selectCourt: 'Court',
        documentSignedCheckbox: 'Is the document signed?',
        visibleForDebtor: 'Visible for debtor',
        uploadDocument: 'Upload document',
        createDocument: 'Create document',
        preview: 'Preview',
        sendToCourt: 'Send to court',
        paidCourtFee: 'Paid court fee',
        createDate: 'Creation date',
        interestDates: 'Interest dates',
        interestAmount: 'Interest amount',
        totalAmount: 'Total amount',
        amount: 'Amount',
        note: 'Note',
        procesinterest: 'Proces interest',
        interestFromSubmitOfBPK: 'Interest from submit of bailiff claim',
        caseinterest: 'Case interest rate',
        preventForkyndt: 'Ønsker du betalingspåkravet forkyndt, hvis skyldner har afgivet insolvenserklæring i fogedretten, eller er under rekonstruktion, konkurs eller gældssanering og derfor er beskyttet mod udlæg?',
        preventAutDistress: 'Ønsker du, at fogedretten automatisk skal iværksætte udlæg, hvis skyldner ikke kommer med indsigelser (protester) mod dit krav?',
        preventAutCivilCourt: 'Ønsker du, at retssag automatisk skal indledes i civilretten på grundlag af betalingspåkravet, hvis skyldner kommer med indsigelser (protester) mod dit krav?',
        selectBPKWarningDate: 'Select BPK warning date',
        selectType: 'Select type of document',
        sureYouWantToDelete: 'Sure you want to delete',
        sureYouWantToSave: 'Sure you want to save the changes?',
        documentSigned: 'Document signed',
        generateLinkForSigning: 'Generate link for signing',
        addCourtFeeToClientBilling: 'Add fee to creditor billing',
        addCourtDisbursementToClientBilling: 'Add disbursement to creditor billing',
        addCourtFeeToCase: 'Add cost to case',
        sendInfoAboutRequisitionToRes: 'Send information about requisition to the resposible',
        responsible: 'Responsible',
        isFoundation: 'Is foundation',
        [documents_1.DocumentTypes.COURT]: 'Court',
        [documents_1.DocumentTypes.FOUNDATION]: 'Foundation',
        [documents_1.DocumentTypes.OTHER]: 'Other',
    },
    documentTypes: {
        [documents_1.DocumentTypes.COURT]: 'Court',
        [documents_1.DocumentTypes.FOUNDATION]: 'Foundation',
        [documents_1.DocumentTypes.OTHER]: 'Other',
        [documents_1.DocumentTypes.SKYLDERKLAERING]: 'Guilt statement',
        [documents_1.DocumentTypes.COURTOPGJORTOGFREMLAGT]: 'Opgjort og fremlagt i fogedretten',
        [documents_1.DocumentTypes.FORLIG]: 'Settlement',
        [documents_1.DocumentTypes.DOM]: 'Verdict',
        [documents_1.DocumentTypes.GAELDSBREV]: 'Loan',
    },
    files: {
        fileName: 'Filename',
        downloadFailed: 'Download failed',
    },
    updates: {
        continueCase: 'Continue case',
        continueCaseRemove: 'Remove',
        setRemindedAt: 'Set reminding date',
        remindDate: 'Remind at',
        pauseNow: 'Pause now',
        remindNow: 'Remind now',
        pauseUntilReminding: 'Pause on',
        pauseContinueAt: 'Continue on',
        pausedUntil: 'Paused until',
        dateSelectorTooltip: 'Select the date to show the pause status',
        updateWillBeShownIn: 'Will pause in',
        paused: 'Paused',
        reminded: 'reminded',
        pausedAndReminded: 'Paused and reminded in',
        pausedAndRemindedPast: 'Paused and reminded',
        ago: 'ago',
        pausedPast: 'Paused',
        andReminded: 'and reminded in',
        andRemindedPast: 'and reminded',
        expedientAKSActivated: 'Experian AKS activated',
        chooseMoreThanTwoBulkActions: 'Please select two or more tasks to make a bulk processing.',
        bulkActions: 'Bulk action',
        selectAll: 'Select all',
    },
    integrateCalendar: {
        selectedUpdateTypes: 'Selected task types',
        selectUpdateTypes: 'Select task types',
        selectUpdateTypesDescription: 'Your calendar integration will live update only the selected task types.',
        orCopyLinkByClickingHere: 'Or click here to copy raw calendar subscription link',
        noSelectedYet: 'No selected yet.',
        connectTo: 'Connect to',
    },
    auth: {
        account: 'Account',
        logout: 'Log out',
    },
    rightNav: {
        creditors: 'Creditors',
    },
    login: {
        email: 'Email',
        password: 'Password',
        login: 'Login',
        twoFactorExplainer: 'We have sent a two factor code to your email, which needs to be entered below to login.',
        twoFactorPlaceholder: 'Code',
    },
    onboarding: {
        welcome: 'Welcome',
        passwordCreatorExplainer: 'To setup your account, please create a password.',
    },
    users: {
        userSettings: 'User settings',
        userCreated: 'User created',
        userUpdated: 'User updated',
        updateFailed: 'User update failed',
        createUser: 'Create user',
        inviteUser: 'Invite user',
        name: 'Name',
        role: 'Role',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email',
        phone: 'Phone',
        username: 'Username',
        password: 'Password',
        users: 'Users',
        noUsers: 'No users to show',
        search: 'Search users',
        newUser: 'New user',
        passwordConfirmation: 'Confirm password',
        creditors: 'Creditors',
        tenants: 'Tenants',
        todoNotifications: 'Receive an email when there is unseen todos or notifications',
        selectCreditors: 'Select creditors',
        selectTenants: 'Select tenants',
        selectRole: 'Select role',
        selectUser: 'Select user',
        passwordTooShort: 'Password is too short',
        passwordsDontMatch: "The passwords don't match",
        sendInvite: 'Send email invite',
        sureYouWantToDeleteUser: 'Are you sure you want to delete this user permanently?',
        deleteUser: 'Delete user',
        deleteUserPermanently: 'Delete user permanently',
        changeRole: 'Change users role',
        changeRoleNotAdmin: 'Change of roles can be done by an administrator',
        cantChangeClientRole: `Clients' role can't be changed`,
    },
    rolesDescription: {
        [__1.PermissionLevels.admin]: 'This role is for the company administrator/superuser who has access to all functions and can configure all available settings.',
        [__1.PermissionLevels.caseworker]: 'This role is for the employee who must have access to all necessary functions at the case level. There is also access to everything at the creditor level, and under settings the role has access to templates.',
    },
    teams: {
        team: 'Team',
        user: 'User',
        namePlaceholder: 'Team name',
        saveName: 'Save',
        searchNewTeamMember: 'Search for new team member',
        createTeam: 'Create new team',
        assignedTasks: 'Responsible for tasks',
        catchAll: 'Catch all',
        responsibleForUpdateTypes: 'Responsible for tasks',
        addUpdateType: 'Add task',
        selectTeam: 'Team',
        selectUser: 'User',
        responsibleForCase: 'Responsible for case',
    },
    invite: {
        subject: 'Invitation to join',
        body: `Hi \${firstName},

You have been invited to join \${platform}. Please use the link below to accept the invitation.
\${url}?nu_token=\${token}`,
        html: `<p>Hi \${firstName},</p><p>You have been invited to join \${platform}. Please use the link below to accept the invitation.</p>`,
        linkText: 'Log in',
        creditorWeb: 'the creditorweb from',
    },
    roles: {
        'super-admin': 'Super admin',
        admin: 'Admin',
        caseworker: 'Caseworker',
        client: 'Creditor',
        debtor: 'Debtor',
        'alternative-contact': 'Alternative contact',
        unauthorized: 'Unauthorized',
    },
    mentionsConditional: {
        if: 'If',
        endIf: 'End If',
    },
    mentions: {
        [templates_1.TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Generic subject',
        [templates_1.TemplateMention.FINANCIALS_PRICIPAL]: 'Principal',
        [templates_1.TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: 'Collection fees',
        [templates_1.TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: 'Administration costs',
        [templates_1.TemplateMention.FINANCIALS_COMPENSATION_FEES]: 'Compensation fees',
        [templates_1.TemplateMention.FINANCIALS_INTERESTS]: 'Interests',
        [templates_1.TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: 'Collection costs',
        [templates_1.TemplateMention.PRINCIPAL_REFERENECE_IDS]: 'Principals reference ids',
        [templates_1.TemplateMention.CURRENCY]: 'Currency',
        [templates_1.TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: 'Payment Plan First Amount',
        [templates_1.TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: 'Payment Plan First Deadline',
        [templates_1.TemplateMention.PAYMENT_PLAN_FIRST_DATE]: 'Payment Plan First Date',
        [templates_1.TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: 'Payment Plan Last Amount',
        [templates_1.TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: 'Payment Plan Last Deadline',
        [templates_1.TemplateMention.PAYMENT_PLAN_LAST_DATE]: 'Payment Plan Last Date',
        [templates_1.TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: 'Payment Plan Entry Amount',
        [templates_1.TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: 'Payment Plan Entry Deadline',
        [templates_1.TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: 'Payment Plan Entry Date',
        [templates_1.TemplateMention.PAYMENT_PLAN_CREATION_DATE]: 'Payment Plan Creation Date',
        [templates_1.TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: 'Payment plan length in days',
        [templates_1.TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: 'Yearly costs in percent',
        [templates_1.TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'If case has yearly interest',
        [templates_1.TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: 'Payment plan min. entry amount',
        [templates_1.TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: 'Payment plan max. entry amount',
        [templates_1.TemplateMention.TOTAL_DEBT]: 'Total Debt',
        [templates_1.TemplateMention.OVERPAYMENT]: 'Overpayment',
        [templates_1.TemplateMention.ACCORD_TEN_PERCENT]: 'Accord: 10 % off',
        [templates_1.TemplateMention.ACCORD_TWENTY_PERCENT]: 'Accord: 20 % off',
        [templates_1.TemplateMention.ACCORD_THIRTY_PERCENT]: 'Accord: 30 % off',
        [templates_1.TemplateMention.ACCORD_FORTY_PERCENT]: 'Accord: 40 % off',
        [templates_1.TemplateMention.ACCORD_FIFTY_PERCENT]: 'Accord: 50 % off',
        [templates_1.TemplateMention.ACCORD_SIXTY_PERCENT]: 'Accord: 60 % off',
        [templates_1.TemplateMention.ACCORD_SEVENTY_PERCENT]: 'Accord: 70 % off',
        [templates_1.TemplateMention.ACCORD_EIGHTY_PERCENT]: 'Accord: 80 % off',
        [templates_1.TemplateMention.ACCORD_NINETY_PERCENT]: 'Accord: 90 % off',
        [templates_1.TemplateMention.IF_IS_COMPANY]: 'If company',
        [templates_1.TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'If case has reminder fees',
        [templates_1.TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'If case has collection fees',
        [templates_1.TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'If case has collection costs',
        [templates_1.TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'If case has compensation costs',
        [templates_1.TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'If case has process interest',
        [templates_1.TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'If case has fixed interest',
        [templates_1.TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'If case has yearly interest in percent',
        [templates_1.TemplateMention.IF_CASE_HAS_DEPOSIT]: 'If case has deposit',
        [templates_1.TemplateMention.DOCUMENTATION]: 'Documentation',
        [templates_1.TemplateMention.DATE]: 'Date',
        [templates_1.TemplateMention.DATE_IN_THREE_DAYS]: 'Date in 3 days',
        [templates_1.TemplateMention.DATE_IN_SIX_DAYS]: 'Date in 6 days',
        [templates_1.TemplateMention.DATE_IN_TEN_DAYS]: 'Date in 10 days',
        [templates_1.TemplateMention.DATE_IN_ELEVEN_DAYS]: 'Date in 11 days',
        [templates_1.TemplateMention.DATE_IN_TWELVE_DAYS]: 'Date in 12 days',
        [templates_1.TemplateMention.DATE_IN_FOURTEEN_DAYS]: 'Date in 14 days',
        [templates_1.TemplateMention.DATE_IN_SEVENTEEN_DAYS]: 'Date in 17 days',
        [templates_1.TemplateMention.DATE_IN_THIRTY_DAYS]: 'Date in 30 days',
        [templates_1.TemplateMention.DEPOSIT]: 'Deposit',
        [templates_1.TemplateMention.DEPOSITS_TO_CREDITOR]: 'Deposited to creditor',
        [templates_1.TemplateMention.DEPOSITS_TO_COLLECTOR]: 'Deposited to collector',
        [templates_1.TemplateMention.PRINCIPALS_WITH_INTEREST]: 'Principals with interest',
        [templates_1.TemplateMention.CONTACT_NAME]: 'Contact Name',
        [templates_1.TemplateMention.DEBTOR_NAME]: 'Debtor Name',
        [templates_1.TemplateMention.DEBTOR_FIRST_NAME]: 'Debitor first name',
        [templates_1.TemplateMention.CONTACT_ADDRESS]: 'Contact Street',
        [templates_1.TemplateMention.CONTACT_COADDRESS]: 'Contact CoAddress',
        [templates_1.TemplateMention.CONTACT_ZIPCODE]: 'Contact Zipcode',
        [templates_1.TemplateMention.CONTACT_CITY]: 'Contact City',
        [templates_1.TemplateMention.CONTACT_COUNTRY]: 'Contact Country',
        [templates_1.TemplateMention.CREDITOR_IF_IS_COMPANY]: 'If creditor is a company',
        [templates_1.TemplateMention.USER_NAME]: 'User name',
        [templates_1.TemplateMention.USER_FIRST_NAME]: 'User first name',
        [templates_1.TemplateMention.IF_USER]: 'If user is available',
        [templates_1.TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'If creditor allows bank transfers',
        [templates_1.TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'If creditor allows FI payments',
        [templates_1.TemplateMention.DEBTOR_ADDRESS]: 'Debtor Street',
        [templates_1.TemplateMention.DEBTOR_COADDRESS]: 'Debtor CoAddress',
        [templates_1.TemplateMention.DEBTOR_ZIPCODE]: 'Debtor Zipcode',
        [templates_1.TemplateMention.DEBTOR_CITY]: 'Debtor City',
        [templates_1.TemplateMention.DEBTOR_COUNTRY]: 'Debtor Country',
        [templates_1.TemplateMention.DEBTOR_EMAIL]: 'Debtor email',
        [templates_1.TemplateMention.DEBTOR_PHONE]: 'Debtor phone number',
        [templates_1.TemplateMention.LAST_PAYMENT_DATE]: 'Last Payment Date',
        [templates_1.TemplateMention.LAST_PAYMENT_AMOUNT]: 'Last Payment Amount',
        [templates_1.TemplateMention.DEBTOR_SEQ_ID]: 'Debtor Seq ID',
        [templates_1.TemplateMention.DEBTOR_CVR_AND_OR_CPR]: 'Debtor CVR and/or CPR',
        [templates_1.TemplateMention.CREDITOR_NAME]: 'Creditor Name',
        [templates_1.TemplateMention.CASE_ID]: 'Case ID',
        [templates_1.TemplateMention.CASE_REFERENCE_ID]: 'Case reference ID',
        [templates_1.TemplateMention.CREDITOR_ADDRESS]: 'Creditor Address',
        [templates_1.TemplateMention.REMINDER_FEES]: 'Reminder Fees',
        [templates_1.TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Payment Options',
        [templates_1.TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: 'Collector Account Number',
        [templates_1.TemplateMention.COLLECTOR_REGISTER_NUMBER]: 'Collector Registration Number',
        [templates_1.TemplateMention.COLLECTOR_PHONE]: 'Collector Phone',
        [templates_1.TemplateMention.COLLECTOR_COURT_PHONE]: 'Collector Court Phone',
        [templates_1.TemplateMention.COLLECTOR_EMAIL]: 'Collector Email',
        [templates_1.TemplateMention.COLLECTOR_NICKNAME]: 'Collector Nickname',
        [templates_1.TemplateMention.COLLECTOR_NAME]: 'Collector Name',
        [templates_1.TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Collector address',
        [templates_1.TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Collector city',
        [templates_1.TemplateMention.COLLECTOR_ADDRESS_ZIP]: 'Collector zipcode',
        [templates_1.TemplateMention.COLLECTOR_CVR]: 'Collector CVR',
        [templates_1.TemplateMention.CREDITOR_ZIPCODE]: 'Creditor Zipcode',
        [templates_1.TemplateMention.CREDITOR_CITY]: 'Creditor City',
        [templates_1.TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: 'Creditor CVR',
        [templates_1.TemplateMention.PAYMENT_ID]: 'Payment ID',
        [templates_1.TemplateMention.JOURNAL_NUMBER]: 'Journal Number',
        [templates_1.TemplateMention.CIVIL_COURT_NAME]: 'Civil Court Name',
        [templates_1.TemplateMention.CIVIL_COURT_ADDRESS]: 'Civil Court Address',
        [templates_1.TemplateMention.CIVIL_COURT_CITY]: 'Civil Court City',
        [templates_1.TemplateMention.CIVIL_COURT_ZIP]: 'Civil Court Zip',
        [templates_1.TemplateMention.CIVIL_COURT_EMAIL]: 'Civil Court Email',
        [templates_1.TemplateMention.CIVIL_COURT_PHONE]: 'Civil Court Phone',
        [templates_1.TemplateMention.CIVIL_COURT_EAN]: 'Civil Court EAN',
        [templates_1.TemplateMention.CIVIL_REG_NO]: 'Civil Court Registration Number',
        [templates_1.TemplateMention.CIVIL_ACCOUNT_NO]: 'Civil Court Account Number',
        [templates_1.TemplateMention.PAYMENT_PLAN_HTML]: 'Payment Plan Installment Overview',
        [templates_1.TemplateMention.CONTACT_ADDRESS_INLINE]: 'Contact Address Inline',
        [templates_1.TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Contact Address Formatted',
        [templates_1.TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Alternative contact reference id',
        [templates_1.TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'If alternative contact has a reference id',
        [templates_1.TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Debtor Address Inline',
        [templates_1.TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Debtor Address Formatted',
        [templates_1.TemplateMention.DEBT_TABLE]: 'Debt Table',
        [templates_1.TemplateMention.DEBT_SPECIFICATION]: 'Debt Specification',
        [templates_1.TemplateMention.DEBT_OVERVIEW]: 'Categorized debt overview',
        [templates_1.TemplateMention.SIGN_FIELDS]: 'Sign Fields',
        [templates_1.TemplateMention.BPK]: 'Betalingspåkrav',
        [templates_1.TemplateMention.PAGE_BREAK]: 'Page Break',
        [templates_1.TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Payment Plan Entries',
        [templates_1.TemplateMention.SATISFACTION_BUTTONS]: 'Satisfaction Buttons',
        [templates_1.TemplateMention.PAYMENT_PLAN_LINK]: 'Link Payment Plan',
        [templates_1.TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'Link To Payment Plan',
        [templates_1.TemplateMention.OVERPAYMENT_LINK]: 'Link overpayment',
        [templates_1.TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'Link overpayment QR code',
        [templates_1.TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'Link to overpayment',
        [templates_1.TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'Link To Payment Plan QR code',
        [templates_1.TemplateMention.PAYMENT_LINK]: 'Link To Payment',
        [templates_1.TemplateMention.PAYMENT_LINK_A_TAG]: 'Link To Payment',
        [templates_1.TemplateMention.PAYMENT_LINK_QR_CODE]: 'Link To Payment QR code',
        [templates_1.TemplateMention.DEBTOR_WEB_LINK]: 'Link To Debtor Web',
        [templates_1.TemplateMention.DEBTOR_WEB_LONG_LINK]: 'Link To Debtor Web Long',
        [templates_1.TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'Link To Debtor Web',
        [templates_1.TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'Link To Debtor Web Long',
        [templates_1.TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'Link To Debtor Web QR-kode',
        [templates_1.TemplateMention.CONDITIONAL_ELSE]: 'Else',
        [templates_1.TemplateMention.CONDITIONAL_END_IF]: 'End If',
        [templates_1.TemplateMention.BANK_CREDITOR_NUMBER]: '',
        [templates_1.TemplateMention.SIGNATURE_TIRANA]: '',
        [templates_1.TemplateMention.SIGNATURE_MICHAEL_BRANDT]: '',
        [templates_1.TemplateMention.RKI_WARNING]: 'RKI warning',
        [templates_1.TemplateMention.FOUNDATION_TYPE]: 'Foundation type',
        [templates_1.TemplateMention.FOUNDATION_DATE]: 'Foundation date',
        [templates_1.TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'Latest FS no.',
    },
    mentionsExplanation: {
        [templates_1.TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Text for the subject field on email',
        [templates_1.TemplateMention.FINANCIALS_PRICIPAL]: 'The total principal of the case',
        [templates_1.TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: 'The total collection fee of the case',
        [templates_1.TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: 'The total administration cost of the case',
        [templates_1.TemplateMention.FINANCIALS_COMPENSATION_FEES]: 'The total compensation fee of the case',
        [templates_1.TemplateMention.FINANCIALS_INTERESTS]: 'The total interest of the case',
        [templates_1.TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: 'The total collection cost of the case',
        [templates_1.TemplateMention.PRINCIPAL_REFERENECE_IDS]: 'Principals reference ids',
        [templates_1.TemplateMention.CURRENCY]: 'Currency of the case economy',
        [templates_1.TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: 'The amount of the first payment',
        [templates_1.TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: 'Due date of the first payment',
        [templates_1.TemplateMention.PAYMENT_PLAN_FIRST_DATE]: 'Date of the first payment',
        [templates_1.TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: 'The amount of the last payment',
        [templates_1.TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: 'Due date of the last payment',
        [templates_1.TemplateMention.PAYMENT_PLAN_LAST_DATE]: 'Date of the last payment',
        [templates_1.TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: 'The amount of the latest payment',
        [templates_1.TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: 'Due date of the latest payment',
        [templates_1.TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: 'Date of the latest payment',
        [templates_1.TemplateMention.PAYMENT_PLAN_CREATION_DATE]: 'Creation date of the payment plan',
        [templates_1.TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: 'Number of days in the payment plan',
        [templates_1.TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: 'Yearly costs in percentage',
        [templates_1.TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'If case has yearly interest',
        [templates_1.TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: 'Payment plan min. entry amount',
        [templates_1.TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: 'Payment plan max. entry amount',
        [templates_1.TemplateMention.TOTAL_DEBT]: 'Amount of the total debt',
        [templates_1.TemplateMention.OVERPAYMENT]: 'Overpayment amount',
        [templates_1.TemplateMention.ACCORD_TEN_PERCENT]: 'Amount of the total debt 10 % off',
        [templates_1.TemplateMention.ACCORD_TWENTY_PERCENT]: 'Amount of the total debt 20 % off',
        [templates_1.TemplateMention.ACCORD_THIRTY_PERCENT]: 'Amount of the total debt 30 % off',
        [templates_1.TemplateMention.ACCORD_FORTY_PERCENT]: 'Amount of the total debt 40 % off',
        [templates_1.TemplateMention.ACCORD_FIFTY_PERCENT]: 'Amount of the total debt 50 % off',
        [templates_1.TemplateMention.ACCORD_SIXTY_PERCENT]: 'Amount of the total debt 60 % off',
        [templates_1.TemplateMention.ACCORD_SEVENTY_PERCENT]: 'Amount of the total debt 70 % off',
        [templates_1.TemplateMention.ACCORD_EIGHTY_PERCENT]: 'Amount of the total debt 80 % off',
        [templates_1.TemplateMention.ACCORD_NINETY_PERCENT]: 'Amount of the total debt 90 % off',
        [templates_1.TemplateMention.IF_IS_COMPANY]: 'If company',
        [templates_1.TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'If case has reminder fees',
        [templates_1.TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'If case has collection fees',
        [templates_1.TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'If case has collection costs',
        [templates_1.TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'If case has compensation costs',
        [templates_1.TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'If case has process interest',
        [templates_1.TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'If case has fixed interest',
        [templates_1.TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'If case has yearly interest in percent',
        [templates_1.TemplateMention.IF_CASE_HAS_DEPOSIT]: 'If case has deposit',
        [templates_1.TemplateMention.DOCUMENTATION]: 'Documentation',
        [templates_1.TemplateMention.DATE]: 'Todays date',
        [templates_1.TemplateMention.DATE_IN_THREE_DAYS]: 'Date in 3 days',
        [templates_1.TemplateMention.DATE_IN_SIX_DAYS]: 'Date in 6 days',
        [templates_1.TemplateMention.DATE_IN_TEN_DAYS]: 'Date in 10 days',
        [templates_1.TemplateMention.DATE_IN_ELEVEN_DAYS]: 'Date in 11 days',
        [templates_1.TemplateMention.DATE_IN_TWELVE_DAYS]: 'Date in 12 days',
        [templates_1.TemplateMention.DATE_IN_FOURTEEN_DAYS]: 'Date in 14 days',
        [templates_1.TemplateMention.DATE_IN_SEVENTEEN_DAYS]: 'Date in 17 days',
        [templates_1.TemplateMention.DATE_IN_THIRTY_DAYS]: 'Date in 30 days',
        [templates_1.TemplateMention.DEPOSIT]: 'Total amount of deposits',
        [templates_1.TemplateMention.DEPOSITS_TO_CREDITOR]: 'Amount deposited to creditor',
        [templates_1.TemplateMention.DEPOSITS_TO_COLLECTOR]: 'Amount deposited to collector',
        [templates_1.TemplateMention.PRINCIPALS_WITH_INTEREST]: 'A list all principals with associated interests and dates',
        [templates_1.TemplateMention.CONTACT_NAME]: "Contact person's name",
        [templates_1.TemplateMention.DEBTOR_NAME]: "Debtor's name",
        [templates_1.TemplateMention.DEBTOR_FIRST_NAME]: "Debitor' first name",
        [templates_1.TemplateMention.CONTACT_ADDRESS]: "Contact person's street",
        [templates_1.TemplateMention.CONTACT_COADDRESS]: "Contact person's c/o",
        [templates_1.TemplateMention.CONTACT_ZIPCODE]: "Contact person's zipcode",
        [templates_1.TemplateMention.CONTACT_CITY]: "Contact person's city",
        [templates_1.TemplateMention.CONTACT_COUNTRY]: "Contact person's country",
        [templates_1.TemplateMention.DEBTOR_ADDRESS]: "Debtor's street",
        [templates_1.TemplateMention.DEBTOR_COADDRESS]: "Debtor's c/o",
        [templates_1.TemplateMention.DEBTOR_ZIPCODE]: "Debtor's zipcode",
        [templates_1.TemplateMention.DEBTOR_CITY]: "Debtor's city",
        [templates_1.TemplateMention.DEBTOR_COUNTRY]: "Debtor's country",
        [templates_1.TemplateMention.DEBTOR_EMAIL]: "Debtor's email",
        [templates_1.TemplateMention.DEBTOR_PHONE]: "Debtor's phone number",
        [templates_1.TemplateMention.LAST_PAYMENT_DATE]: 'Date of last payment',
        [templates_1.TemplateMention.LAST_PAYMENT_AMOUNT]: 'Amount of last payment',
        [templates_1.TemplateMention.DEBTOR_SEQ_ID]: "Debitor's ID",
        [templates_1.TemplateMention.DEBTOR_CVR_AND_OR_CPR]: "Debtor's CVR and/or CPR",
        [templates_1.TemplateMention.CREDITOR_NAME]: "Creditor's name",
        [templates_1.TemplateMention.CASE_ID]: 'The case ID',
        [templates_1.TemplateMention.CASE_REFERENCE_ID]: 'Case reference ID',
        [templates_1.TemplateMention.CREDITOR_ADDRESS]: "Creditor's address",
        [templates_1.TemplateMention.CREDITOR_IF_IS_COMPANY]: 'If creditor is a company',
        [templates_1.TemplateMention.USER_NAME]: 'User name',
        [templates_1.TemplateMention.USER_FIRST_NAME]: 'User first name',
        [templates_1.TemplateMention.IF_USER]: 'If user is available',
        [templates_1.TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'If creditor allows bank transfers',
        [templates_1.TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'If creditor allows FI payments',
        [templates_1.TemplateMention.REMINDER_FEES]: 'The total reminder fee of the case',
        [templates_1.TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Payment Options',
        [templates_1.TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: "Collector's bank account number",
        [templates_1.TemplateMention.COLLECTOR_REGISTER_NUMBER]: "Collector's bank registration number",
        [templates_1.TemplateMention.COLLECTOR_PHONE]: "Collector's phone number",
        [templates_1.TemplateMention.COLLECTOR_COURT_PHONE]: "Collector's court phone number",
        [templates_1.TemplateMention.COLLECTOR_EMAIL]: "Collector's email",
        [templates_1.TemplateMention.COLLECTOR_NICKNAME]: "Collector's nickname",
        [templates_1.TemplateMention.COLLECTOR_NAME]: "Collector's name",
        [templates_1.TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: "Collector'd address",
        [templates_1.TemplateMention.COLLECTOR_ADDRESS_CITY]: "Collector's city",
        [templates_1.TemplateMention.COLLECTOR_ADDRESS_ZIP]: "Collector's zipcode",
        [templates_1.TemplateMention.COLLECTOR_CVR]: "Collector's CVR",
        [templates_1.TemplateMention.CREDITOR_ZIPCODE]: "Creditor's zipcode",
        [templates_1.TemplateMention.CREDITOR_CITY]: "Creditor's city",
        [templates_1.TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: "Creditor's CVR",
        [templates_1.TemplateMention.PAYMENT_ID]: 'Payment ID / FIK number',
        [templates_1.TemplateMention.JOURNAL_NUMBER]: 'Journal number',
        [templates_1.TemplateMention.CIVIL_COURT_NAME]: "Civil court's name",
        [templates_1.TemplateMention.CIVIL_COURT_ADDRESS]: 'Civil court Address',
        [templates_1.TemplateMention.CIVIL_COURT_CITY]: "Civil court's city",
        [templates_1.TemplateMention.CIVIL_COURT_ZIP]: "Civil court's zip",
        [templates_1.TemplateMention.CIVIL_COURT_EMAIL]: "Civil court's email",
        [templates_1.TemplateMention.CIVIL_COURT_PHONE]: "Civil court's phone",
        [templates_1.TemplateMention.CIVIL_COURT_EAN]: "Civil court's EAN",
        [templates_1.TemplateMention.CIVIL_REG_NO]: "Civil court's registration Number",
        [templates_1.TemplateMention.CIVIL_ACCOUNT_NO]: "Civil court's account Number",
        [templates_1.TemplateMention.PAYMENT_PLAN_HTML]: 'Overview of number of payments and amounts',
        [templates_1.TemplateMention.CONTACT_ADDRESS_INLINE]: "Contact person's full address on one line",
        [templates_1.TemplateMention.CONTACT_ADDRESS_FORMATTED]: "Contact person's full address on muliple lines",
        [templates_1.TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Alternative contact reference id',
        [templates_1.TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'If alternative contact has a reference id',
        [templates_1.TemplateMention.DEBTOR_ADDRESS_INLINE]: "Debtor's full address on one line",
        [templates_1.TemplateMention.DEBTOR_ADDRESS_FORMATTED]: "Debtor's full address on muliple lines",
        [templates_1.TemplateMention.DEBT_TABLE]: 'Table showing the case economy',
        [templates_1.TemplateMention.DEBT_SPECIFICATION]: 'Specification of each principal',
        [templates_1.TemplateMention.DEBT_OVERVIEW]: 'Table providing a categorized overview of the case economy',
        [templates_1.TemplateMention.SIGN_FIELDS]: 'Signing fields',
        [templates_1.TemplateMention.BPK]: 'PDF of Order for payment',
        [templates_1.TemplateMention.PAGE_BREAK]: 'Page Break',
        [templates_1.TemplateMention.PAYMENT_LINK]: 'Link to pay the full debt',
        [templates_1.TemplateMention.PAYMENT_PLAN_LINK]: 'Link to sign the guilt statement',
        [templates_1.TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'Link To Payment Plan (QR-kode)',
        [templates_1.TemplateMention.PAYMENT_LINK_QR_CODE]: 'Link To Payment (QR-kode)',
        [templates_1.TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'Link To Debtor Web (QR-kode)',
        [templates_1.TemplateMention.DEBTOR_WEB_LINK]: 'Link to debtor web',
        [templates_1.TemplateMention.DEBTOR_WEB_LONG_LINK]: 'Link to debtor web long',
        [templates_1.TemplateMention.PAYMENT_LINK_A_TAG]: 'Link to pay the full debt',
        [templates_1.TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Tabel showing payment, date and status',
        [templates_1.TemplateMention.SATISFACTION_BUTTONS]: 'Satisfaction Buttons',
        [templates_1.TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'Link to sign the guilt statement',
        [templates_1.TemplateMention.OVERPAYMENT_LINK]: 'Link overpayment',
        [templates_1.TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'Link overpayment QR code',
        [templates_1.TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'Link to overpayment',
        [templates_1.TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'Link to debtor web',
        [templates_1.TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'Link to debtor web long',
        [templates_1.TemplateMention.CONDITIONAL_ELSE]: 'Else',
        [templates_1.TemplateMention.CONDITIONAL_END_IF]: 'End If',
        [templates_1.TemplateMention.BANK_CREDITOR_NUMBER]: '',
        [templates_1.TemplateMention.SIGNATURE_TIRANA]: '',
        [templates_1.TemplateMention.SIGNATURE_MICHAEL_BRANDT]: '',
        [templates_1.TemplateMention.RKI_WARNING]: 'RKI warning',
        [templates_1.TemplateMention.FOUNDATION_TYPE]: 'Foundation type',
        [templates_1.TemplateMention.FOUNDATION_DATE]: 'Foundation date',
        [templates_1.TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'Latest FS no.',
    },
    mentionsExample: {
        [templates_1.TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Regarding your debt to Testkreditor ApS [j.nr.: 171001-171533]',
        [templates_1.TemplateMention.FINANCIALS_PRICIPAL]: '8.570,14 ',
        [templates_1.TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: '100,00',
        [templates_1.TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: '175,00',
        [templates_1.TemplateMention.FINANCIALS_COMPENSATION_FEES]: '310,00',
        [templates_1.TemplateMention.FINANCIALS_INTERESTS]: '26,70 ',
        [templates_1.TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: '700,00',
        [templates_1.TemplateMention.PRINCIPAL_REFERENECE_IDS]: '123, 124, and 125',
        [templates_1.TemplateMention.CURRENCY]: 'DKK',
        [templates_1.TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: '200,00',
        [templates_1.TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: '20. october 2021',
        [templates_1.TemplateMention.PAYMENT_PLAN_FIRST_DATE]: '15. october 2021',
        [templates_1.TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: '170,14',
        [templates_1.TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: '20. august 2024',
        [templates_1.TemplateMention.PAYMENT_PLAN_LAST_DATE]: '15. august 2024',
        [templates_1.TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: '200,00',
        [templates_1.TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: '20. november 2021',
        [templates_1.TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: '15. november 20211',
        [templates_1.TemplateMention.PAYMENT_PLAN_CREATION_DATE]: '17. september 2021',
        [templates_1.TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: '1035',
        [templates_1.TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: '* 1. year APRC: 1,33',
        [templates_1.TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'If case has interests',
        [templates_1.TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: '55,00',
        [templates_1.TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: '550,00',
        [templates_1.TemplateMention.TOTAL_DEBT]: '6.770,14',
        [templates_1.TemplateMention.OVERPAYMENT]: '123,23',
        [templates_1.TemplateMention.ACCORD_TEN_PERCENT]: '6.093,13',
        [templates_1.TemplateMention.ACCORD_TWENTY_PERCENT]: '5.416,11',
        [templates_1.TemplateMention.ACCORD_THIRTY_PERCENT]: '4.739,10',
        [templates_1.TemplateMention.ACCORD_FORTY_PERCENT]: '4.062,08',
        [templates_1.TemplateMention.ACCORD_FIFTY_PERCENT]: '3.385,07',
        [templates_1.TemplateMention.ACCORD_SIXTY_PERCENT]: '2.708,06',
        [templates_1.TemplateMention.ACCORD_SEVENTY_PERCENT]: '2.031,04',
        [templates_1.TemplateMention.ACCORD_EIGHTY_PERCENT]: '1.354,03',
        [templates_1.TemplateMention.ACCORD_NINETY_PERCENT]: '677,01',
        [templates_1.TemplateMention.IF_IS_COMPANY]: 'Condition if company',
        [templates_1.TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Condition if case has reminder fees',
        [templates_1.TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Condition if case has collection fees',
        [templates_1.TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Condition if case has collection costs',
        [templates_1.TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Condition if case has compensation costs',
        [templates_1.TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Condition if case has process interest',
        [templates_1.TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Condition if case has fixed interest',
        [templates_1.TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Condition if case has yearly interest',
        [templates_1.TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Condition if case has deposit',
        [templates_1.TemplateMention.DOCUMENTATION]: 'Documentation',
        [templates_1.TemplateMention.DATE]: '23. november 2021',
        [templates_1.TemplateMention.DATE_IN_THREE_DAYS]: '26. november 2021',
        [templates_1.TemplateMention.DATE_IN_SIX_DAYS]: '29. november 2021',
        [templates_1.TemplateMention.DATE_IN_TEN_DAYS]: '3. december 2021',
        [templates_1.TemplateMention.DATE_IN_ELEVEN_DAYS]: '4. december 2021',
        [templates_1.TemplateMention.DATE_IN_TWELVE_DAYS]: '5. december 2021',
        [templates_1.TemplateMention.DATE_IN_FOURTEEN_DAYS]: '7. december 2021',
        [templates_1.TemplateMention.DATE_IN_SEVENTEEN_DAYS]: '10. december 2021',
        [templates_1.TemplateMention.DATE_IN_THIRTY_DAYS]: '23. december 2021',
        [templates_1.TemplateMention.DEPOSIT]: '400,00',
        [templates_1.TemplateMention.DEPOSITS_TO_CREDITOR]: '200,00',
        [templates_1.TemplateMention.DEPOSITS_TO_COLLECTOR]: '200,00',
        [templates_1.TemplateMention.PRINCIPALS_WITH_INTEREST]: '31-01-2024 Invoice nr. 1234, kr. 300,00. Processinterest from 20-02-2023, amounting to kr. 1,31',
        [templates_1.TemplateMention.CONTACT_NAME]: 'Debbie Contactsen',
        [templates_1.TemplateMention.DEBTOR_NAME]: 'Debbie Debtorsen',
        [templates_1.TemplateMention.DEBTOR_FIRST_NAME]: 'Debbie',
        [templates_1.TemplateMention.CONTACT_ADDRESS]: 'Applebys Pl. 7',
        [templates_1.TemplateMention.CONTACT_COADDRESS]: 'Emil Brandt',
        [templates_1.TemplateMention.CONTACT_ZIPCODE]: '1411',
        [templates_1.TemplateMention.CONTACT_CITY]: 'Copenhagen',
        [templates_1.TemplateMention.CONTACT_COUNTRY]: 'Denmark',
        [templates_1.TemplateMention.DEBTOR_ADDRESS]: 'Applebys Pl. 7',
        [templates_1.TemplateMention.DEBTOR_COADDRESS]: 'Emil Brandt',
        [templates_1.TemplateMention.DEBTOR_ZIPCODE]: '1411',
        [templates_1.TemplateMention.DEBTOR_CITY]: 'Copenhagen',
        [templates_1.TemplateMention.DEBTOR_COUNTRY]: 'Denmark',
        [templates_1.TemplateMention.DEBTOR_EMAIL]: 'debtor@example.com',
        [templates_1.TemplateMention.DEBTOR_PHONE]: '88888888',
        [templates_1.TemplateMention.LAST_PAYMENT_DATE]: '12. october 2021',
        [templates_1.TemplateMention.LAST_PAYMENT_AMOUNT]: '200,00',
        [templates_1.TemplateMention.DEBTOR_SEQ_ID]: '111111',
        [templates_1.TemplateMention.DEBTOR_CVR_AND_OR_CPR]: '12345678',
        [templates_1.TemplateMention.CREDITOR_NAME]: 'Testkreditor A/S',
        [templates_1.TemplateMention.CASE_ID]: '12345678',
        [templates_1.TemplateMention.CASE_REFERENCE_ID]: '123456789',
        [templates_1.TemplateMention.CREDITOR_ADDRESS]: 'Applebys Pl. 7',
        [templates_1.TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Logic if creditor is a company',
        [templates_1.TemplateMention.USER_NAME]: 'Peter Petersen',
        [templates_1.TemplateMention.USER_FIRST_NAME]: 'Peter',
        [templates_1.TemplateMention.IF_USER]: 'Logic if user is available',
        [templates_1.TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Logic if creditor allows bank transfers',
        [templates_1.TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Logic if creditor allows FI payments',
        [templates_1.TemplateMention.REMINDER_FEES]: '300,00',
        [templates_1.TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Payment options',
        [templates_1.TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: '12345678',
        [templates_1.TemplateMention.COLLECTOR_REGISTER_NUMBER]: '1234',
        [templates_1.TemplateMention.COLLECTOR_PHONE]: '11223344',
        [templates_1.TemplateMention.COLLECTOR_COURT_PHONE]: '11223345',
        [templates_1.TemplateMention.COLLECTOR_EMAIL]: 'collector@debbie.dk',
        [templates_1.TemplateMention.COLLECTOR_NICKNAME]: 'Testcollector',
        [templates_1.TemplateMention.COLLECTOR_NAME]: 'Testcollector A/S',
        [templates_1.TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Applebys Pl. 7',
        [templates_1.TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Copenhagen',
        [templates_1.TemplateMention.COLLECTOR_ADDRESS_ZIP]: '1411',
        [templates_1.TemplateMention.COLLECTOR_CVR]: '88776655',
        [templates_1.TemplateMention.CREDITOR_ZIPCODE]: '1411',
        [templates_1.TemplateMention.CREDITOR_CITY]: 'Copenhagen',
        [templates_1.TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: '66554433',
        [templates_1.TemplateMention.PAYMENT_ID]: '+71<000000001111111 + 12345678<',
        [templates_1.TemplateMention.JOURNAL_NUMBER]: '12345678-111111',
        [templates_1.TemplateMention.CIVIL_COURT_NAME]: 'Københavns Byret',
        [templates_1.TemplateMention.CIVIL_COURT_ADDRESS]: 'Hestemøllestræde 6',
        [templates_1.TemplateMention.CIVIL_COURT_CITY]: 'København K',
        [templates_1.TemplateMention.CIVIL_COURT_ZIP]: '1464',
        [templates_1.TemplateMention.CIVIL_COURT_EMAIL]: 'foged.kbh@domstol.dk',
        [templates_1.TemplateMention.CIVIL_COURT_PHONE]: '99687000',
        [templates_1.TemplateMention.CIVIL_COURT_EAN]: '5798000161252',
        [templates_1.TemplateMention.CIVIL_REG_NO]: '0216',
        [templates_1.TemplateMention.CIVIL_ACCOUNT_NO]: '4069134793',
        [templates_1.TemplateMention.PAYMENT_PLAN_HTML]: '* 1. Deposit of DKK 200,00 before 15. october 2021',
        [templates_1.TemplateMention.CONTACT_ADDRESS_INLINE]: 'Applebys Plads 7, 1411 København K',
        [templates_1.TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Applebys Plads 7,\n 1411 København K',
        [templates_1.TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: '123-123',
        [templates_1.TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Logic if alternative contact reference id exists',
        [templates_1.TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Applebys Plads 7, 1411 København K',
        [templates_1.TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Applebys Plads 7,\n 1411 København K',
        [templates_1.TemplateMention.DEBT_TABLE]: 'Type|Date|Currency|Amount',
        [templates_1.TemplateMention.DEBT_SPECIFICATION]: 'Principal|Date|Due date|Amount',
        [templates_1.TemplateMention.DEBT_OVERVIEW]: 'Categorized Type|Date|Amount',
        [templates_1.TemplateMention.SIGN_FIELDS]: 'Date\n_______________________\nSignature',
        [templates_1.TemplateMention.BPK]: 'PDF',
        [templates_1.TemplateMention.PAGE_BREAK]: 'Page Break',
        [templates_1.TemplateMention.PAYMENT_LINK]: 'debtorweb.dk/r/fulldebt',
        [templates_1.TemplateMention.DEBTOR_WEB_LINK]: 'debtorweb.dk',
        [templates_1.TemplateMention.DEBTOR_WEB_LONG_LINK]: 'debtorweb.dk',
        [templates_1.TemplateMention.PAYMENT_PLAN_LINK]: 'debtorweb.dk/r/paymentplant',
        [templates_1.TemplateMention.OVERPAYMENT_LINK]: 'debtorweb.dk/r/overindbetaling',
        [templates_1.TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'QR code',
        [templates_1.TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'debtorweb.dk/r/overindbetaling',
        [templates_1.TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'QR-kode',
        [templates_1.TemplateMention.PAYMENT_LINK_QR_CODE]: 'QR-kode',
        [templates_1.TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'QR-kode',
        [templates_1.TemplateMention.PAYMENT_LINK_A_TAG]: 'debtorweb.dk/r/fulldebt',
        [templates_1.TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Amount | Date | Status',
        [templates_1.TemplateMention.SATISFACTION_BUTTONS]: '(:D) (:|) (:C)',
        [templates_1.TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'debtorweb.dk/r/paymentplant',
        [templates_1.TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'debtorweb.dk',
        [templates_1.TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'debtorweb.dk',
        [templates_1.TemplateMention.CONDITIONAL_ELSE]: 'Else',
        [templates_1.TemplateMention.CONDITIONAL_END_IF]: 'End if',
        [templates_1.TemplateMention.BANK_CREDITOR_NUMBER]: 'N/A',
        [templates_1.TemplateMention.SIGNATURE_TIRANA]: 'N/A',
        [templates_1.TemplateMention.SIGNATURE_MICHAEL_BRANDT]: 'N/A',
        [templates_1.TemplateMention.RKI_WARNING]: 'PDF',
        [templates_1.TemplateMention.FOUNDATION_TYPE]: 'Verdict',
        [templates_1.TemplateMention.FOUNDATION_DATE]: '23. november 2021',
        [templates_1.TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'FS 11-1111/1111',
    },
    import: {
        importedData: 'Imported data',
        downloadInvoiceExampleHeader: 'Invoice Debts',
        downloadInvoiceExampleText: 'Download import-sheet with examples of invoice cases.',
        downloadFinancialExampleHeader: 'Bank cases',
        downloadFinancialExampleText: 'Download import-sheet with example bank cases.',
        downloadAcontoExampleHeader: 'Aconto cases',
        downloadAcontoExampleText: 'Download import-sheet with aconto invoiced cases.',
        downloadMigrationExampleHeader: 'Migrate cases',
        downloadMigrationExampleText: 'Download migration sheet with migration data examples.',
        download: 'Download example',
        import: 'Import',
        backToImports: 'Back to imports',
        newImport: 'New import',
        noImports: 'No imports to show',
        casesCreated: 'Cases created',
        casesUpdated: 'Cases updated',
        companyStatuses: 'Company statuses',
        noStatus: 'No status',
        caseUpdates: 'Case updates',
        [types_1.ImportState.CANCELED]: 'Canceled',
        [types_1.ImportState.CREATED]: 'Created',
        [types_1.ImportState.DELETED]: 'Deleted',
        [types_1.ImportState.IMPORTED]: 'Imported',
        [types_1.ImportState.IMPORTING]: 'Importing',
        [types_1.ImportState.SHEETADDED]: 'Sheet added',
        create: 'Create',
        uploadFile: 'Upload file',
        uploadedAppendicies: 'Uploaded appendicies',
        mapColumns: 'Map columns',
        imported: 'Imported',
        dropFileHereOr: 'Drop file here or',
        dropAppendixHereOr: 'Drop appendix here or',
        uploadImport: 'Upload import sheet',
        uploadAppendix: 'Upload appendix',
        migration: 'Migration',
        appendixUploaded: 'Appendix uploaded',
        dropAnotherFileHereOr: 'Drop another file here or',
        uploadFileBtn: 'Upload file',
        deleteImport: 'Delete import',
        importFinished: 'Import finished',
        withRKIRegistrations: 'with RKI registrations',
        endAll: 'End all',
        approveAll: 'Approve all cases',
        createdCases: 'created cases.',
        startedEnding: 'Started ending',
        cases: 'cases.',
        found: 'Found',
        rows: 'rows',
        and: 'and',
        debtors: 'debtors',
        allCasesFinallySettled: 'All cases are finally settled',
        allCasesTerminated: 'The customer relationship has ended to all debtors',
        chain: 'Workflow',
        billingModel: 'Billing model',
        tenantStandard: 'Account standard',
        creditorStandard: 'Creditor standard',
        systemStandard: 'System standard',
        more: 'more.',
        showMore: 'Show more',
        importCases: 'Import cases',
        youWillreceiveAnEmailWhenItIsDone: 'You will receive an email when the import is ready.',
        importHasStarted: 'Import has started',
        see: 'See',
        seeMore: 'See more',
        here: 'here',
        file: "the file's",
        asWell: 'and',
        notMappedColumns: 'Following columns not mapped',
        errors: 'errors',
        error: 'Error',
        row: 'Row',
        column: 'Column',
        columnNotFound: 'Column not found',
        noErrorsFound: 'No errors found',
        rowsHeader: 'Rows',
        columnsHeader: 'Columns',
        failedRows: 'Failed rows',
        failedImportRows: 'Failed import rows',
        referenceId: 'Reference Id',
        creditorReferenceId: 'Creditor Reference Id',
        isCompany: 'Is company',
        caseCreatedAt: 'Case created at',
        caseStatus: 'Case status',
        endReason: 'Exit reason',
        caseGroup: 'Case Group',
        migratedId: 'Migrated journalnumber',
        name: 'Name',
        birthdate: 'Birthdate',
        cpr: 'CPR',
        cvr: 'CVR',
        email: 'Email',
        phone: 'Phone',
        lang: 'Language',
        address: 'Address',
        coAddress: 'C/O Address',
        zipcode: 'Zipcode',
        city: 'City',
        country: 'Country',
        fiPaymentIdRaw: 'FI Payment Id',
        caseTags: 'Case tags',
        economyBillingModelId: 'Billing model',
        debtReferenceId: 'Invoice id',
        fileName: 'Filename',
        issueDate: 'Date',
        dueDate: 'Due date',
        expirationFromDate: 'Expiration from date',
        currency: 'Currency',
        debtDescription: 'Voucher Description',
        principal: 'Principal',
        controlFee: 'Control fee',
        onAccount: 'On Account',
        finalSettlement: 'Final Settlement',
        deposit: 'Deposit',
        loan: 'Loan',
        settlement: 'Settlement',
        fixedInterest: 'Fixed Interest',
        udtraeksgebyr: 'Udtræksgebyr',
        administrationCost: 'Administration cost',
        reminderFee: 'Reminder Fees',
        reminderFeeCollector: 'Reminderfees from collector',
        refund: 'Refund',
        compensationCost: 'Compensationcosts',
        collectionCost: 'Collectioncosts',
        collectionFee: 'Collectionfee',
        writFee: 'Writt fee',
        writSalary: 'Writt salary',
        policePresentationFee: 'Police presentation fee',
        fogedRekvisitionsFee: 'Fogedrekvisitionsgebyr',
        bailifsSalary: 'Bailiffs salary',
        bailifsFee: 'Bailiffs fee',
        interestStartDate: 'Interest start date',
        interestRate: 'Interest rate',
        finalStatement: 'Final statement',
        customerTerminated: 'Customer terminated',
        rkiWarnedAt: 'RKI Warned At',
        bpkWarnedAt: 'BPK Warned At',
        errorWarning: 'Your file contains errors that are preventing the import.',
        faqHeader: 'Need help to import cases?',
        faqText: 'We have written an article about File import in our Help section. Here you will also find an explanation of typical errors when importing files.',
        newCase: 'New case',
    },
    updateTypesSettings: {
        addUpdateType: 'Create update type',
        title: 'Update type label',
        editUpdateType: 'Edit update type',
        createNewUpdateType: 'Create new update type',
        customUpdateTypes: 'Created update types',
        standardUpdateTypes: 'Standard update types',
    },
    updateTypes: {
        [updates_1.UpdateType.CreditorEndedCase]: 'Creditor ended case',
        [updates_1.UpdateType.AKSStatus]: 'AKS status',
        [updates_1.UpdateType.AKSFailed]: 'AKS enroll failed',
        [updates_1.UpdateType.EXITREQUEST]: 'Exit Request From Creditor',
        [updates_1.UpdateType.CASESTATUSMOVE]: 'Changed Case Status',
        [updates_1.UpdateType.SOP]: 'Final Statement',
        [updates_1.UpdateType.UPDATE]: 'Update',
        [updates_1.UpdateType.NOCONTACTINFORMATION]: 'Missing Contact Information',
        [updates_1.UpdateType.DEPOSIT]: 'Deposit',
        [updates_1.UpdateType.NEWDEBT]: 'New Debt',
        [updates_1.UpdateType.NEWINTERACTION]: 'New incoming e-mail',
        [updates_1.UpdateType.eBoksFailed]: 'e-Boks message could not be delivered',
        [updates_1.UpdateType.TECHNICALINVESTIGATION]: 'Investigated by a technician',
        [updates_1.UpdateType.TERMINATIONREQUEST]: 'Termination request sent to creditor',
        [updates_1.UpdateType.PENDINGTERMINATION]: 'Pending termination by caseworker',
        [updates_1.UpdateType.CANCELTERMINATION]: 'Canceled termination',
        [updates_1.UpdateType.CASECONTINUED]: 'Case Continued',
        [updates_1.UpdateType.POSTPONECASEWORKING]: 'Postpone Caseworking',
        [updates_1.UpdateType.RETURNLETTER]: 'Return Letter',
        [updates_1.UpdateType.BOBEHANDLING]: 'Estate Administration',
        [updates_1.UpdateType.BOBEHANDLET]: 'Estate Administered',
        [updates_1.UpdateType.NotSureCourtSubmit]: 'Awaiting Money-Claim form',
        [updates_1.UpdateType.YesCourtSubmit]: 'Ready to auto submit to court',
        [updates_1.UpdateType.NoCourtSubmit]: 'Not selected for automatic submission to the court',
        [updates_1.UpdateType.AWAITINGSTAEVNING]: 'Awaiting Writ',
        [updates_1.UpdateType.AFDRAGSORDNINGER]: 'Payment Plan',
        [updates_1.UpdateType.ApprovedByCreditor]: 'Approved By Creditor',
        [updates_1.UpdateType.ApprovedByDatahub]: 'Approved By Datahub',
        [updates_1.UpdateType.CancelApprovedByDatahub]: 'Cancel Approved By Datahub',
        [updates_1.UpdateType.REMOVEFROMRKI]: 'Remove from RKI',
        [updates_1.UpdateType.AUTOREMOVEFROMRKI]: 'Automatic deletion of RKI registration',
        [updates_1.UpdateType.CancelRejectedByDatahub]: 'Cancel Rejected By Datahub',
        [updates_1.UpdateType.CancelRequestedBecauseOfPaymentToCreditor]: 'Cancel Requested Because Of Payment To Creditor',
        [updates_1.UpdateType.RejectedByCreditor]: 'Rejected By Creditor',
        [updates_1.UpdateType.RejectedByDatahub]: 'Rejected By Datahub',
        [updates_1.UpdateType.PAYMENTPLANINITIAL]: 'New Payment Plan Created',
        [updates_1.UpdateType.NEWCLIENTINTERACTION]: 'New creditor interaction',
        [updates_1.UpdateType.NEWDEBTORINTERACTION]: 'New debtor interaction',
        [updates_1.UpdateType.DEBTORPERSONALDATAREQUEST]: 'Debtor info change request',
        [updates_1.UpdateType.AWAITINGCLIENTANSWER]: 'Awaiting Response From Creditor',
        [updates_1.UpdateType.DEFAULTEDPAYMENTPLAN]: 'Defaulted Payment Plan',
        [updates_1.UpdateType.OVERPAYPAYMENTPLAN]: 'Overpay Payment Plan',
        [updates_1.UpdateType.RKIApprovalRequest]: 'RKI-request For Case Worker',
        [updates_1.UpdateType.RKIREGISTRATION]: 'RKI Registration Required',
        [updates_1.UpdateType.DOCSIGNED]: 'Document Signed',
        [updates_1.UpdateType.COSMOSUBSCRIBED]: 'Subscribed to Cosmo',
        [updates_1.UpdateType.COSMOUNSUBSCRIBED]: 'Unsubscribed from Cosmo',
        [updates_1.UpdateType.AWAITINGFOGEDREKVISITION]: 'Awaiting Enforcement Application',
        [updates_1.UpdateType.ISINFOGEDRETTEN]: "In Bailiff's Court",
        [updates_1.UpdateType.ISINCIVILCOURT]: 'In Civil Court',
        [updates_1.UpdateType.PAYMENTONCASEINCOURT]: 'Payment on case in court',
        [updates_1.UpdateType.RECEIVEDCOURTFOUNDATION]: 'Received Sentence/Money-Claim form/Court Settlement awaits Enforcement',
        [updates_1.UpdateType.POLITIFREMSTILLING]: 'Arrest For Non-appearance',
        [updates_1.UpdateType.DECIDECOURT]: 'Decide Court Decision',
        [updates_1.UpdateType.RKISTATUS]: 'RKI status',
        [updates_1.UpdateType.AWAITINGPOWERTERMINATION]: 'Awaiting Power Termination',
        [updates_1.UpdateType.RKIAPPROVEDBYCLIENT]: 'RKI approved by creditor',
        [updates_1.UpdateType.REQUESTCLIENTRKI]: 'RKI-request For Creditor',
        [updates_1.UpdateType.TERMINATEDCUSTOMER]: 'Terminated Customer',
        [updates_1.UpdateType.FOGEDREVISITIONCLIENTREQUEST]: 'Enforcement Application Request For Creditor',
        [updates_1.UpdateType.TICKETRESOLVED]: 'Ticket resolved',
        [updates_1.UpdateType.MIGRATIONNOTE]: 'Migration Note',
        [updates_1.UpdateType.TILJURIDISKBEHANDLING]: 'To legal Processing',
        [updates_1.UpdateType.COURTEVENTS]: 'Court Events',
        [updates_1.UpdateType.AFTEROFFICEHOURS]: 'Postponed for After Office Hours',
        [updates_1.UpdateType.AWAITINGPAYMENTAFTERCONCILIATION]: 'Awaiting Payment After Conciliation',
        [updates_1.UpdateType.PHONEMEETING]: "Summoned for Telephonic Bailiff's Meeting",
        [updates_1.UpdateType.INSOLVENS]: 'Insolvency',
        [updates_1.UpdateType.DEBTEXPIRESWITHINTHREEMONTHS]: 'Debt Expires Within Three Months',
        [updates_1.UpdateType.DEBTEXPIRED]: 'Debt Expired',
        [updates_1.UpdateType.EMAILFAILED]: 'Email Failed',
        [updates_1.UpdateType.AWAITINGCIVILCOURT]: 'Awaiting Civil Court',
        [updates_1.UpdateType.AWAITINGFINALSTATEMENT]: 'Awaiting Final Statement',
        [updates_1.UpdateType.MIGRATEDJOURNALNUMBER]: 'Migrated Journal Number',
        [updates_1.UpdateType.RKIREGISTRATIONOPEN]: 'RKI Registration (Open)',
        [updates_1.UpdateType.RKIREGISTRATIONCLOSED]: 'RKI Registration (Closed)',
        [updates_1.UpdateType.AUTORKIREGISTRATIONOPEN]: 'Auto-RKI Registration (Open)',
        [updates_1.UpdateType.AUTORKIREGISTRATIONCLOSED]: 'Auto-RKI Registration (Closed)',
        [updates_1.UpdateType.RKIWARNED]: 'RKI warned',
        [updates_1.UpdateType.STAEVNINGREQUSTCLIENT]: 'Should Debtor get a Writ',
        [updates_1.UpdateType.UDLAEG]: 'Distress',
        [updates_1.UpdateType.UDLAEGCIVIL]: 'Distress',
        [updates_1.UpdateType.NEWCOURTINTERACTION]: 'New Court Interaction',
        [updates_1.UpdateType.REMINDER]: 'Reminder',
        [updates_1.UpdateType.OUTBOUNDCALL]: 'Outbound Call',
        [updates_1.UpdateType.UDLAEGAFLYSES]: 'Distress should be cancelled',
        [updates_1.UpdateType.OPPOSITION]: 'Opposition',
        [updates_1.UpdateType.NOTOPPOSITION]: 'Not-opposition',
        [updates_1.UpdateType.FSNUMMER]: 'FS-number',
        [updates_1.UpdateType.OVERDRAGESTILINKASSOPARTNER]: 'Handover case to external debt collection partner',
        [updates_1.UpdateType.AKSUpdateName]: 'AKS Updated: Name',
        [updates_1.UpdateType.AKSUpdateAddress]: 'AKS Updated: Address',
        [updates_1.UpdateType.AKSUpdateStatus]: 'AKS Updated: Status',
        [updates_1.UpdateType.AKSUpdateProtection]: 'AKS Updated: Name/Address Protection',
        [updates_1.UpdateType.AKSUpdateNewRKI]: 'AKS Updated: New RKI Registration',
        [updates_1.UpdateType.AKSUpdateDeletedRKI]: 'AKS Updated: Deleted RKI Registration',
        [updates_1.UpdateType.AKSUpdateCreditWarning]: 'AKS Updated: Credit Warning',
        [updates_1.UpdateType.AKSUpdateAdvertisementPreference]: 'AKS Updated: Advertisement Preference',
        [updates_1.UpdateType.AKSUpdateGuardianStatus]: 'AKS Updated: Guardian Status',
        [updates_1.UpdateType.AKSUpdateRKI]: 'AKS Updated: RKI Remark',
        [updates_1.UpdateType.COURTREMINDER]: 'Court reminder',
        [updates_1.UpdateType.DEPARTED]: 'Departed',
        [updates_1.UpdateType.DECIDECONTINUE]: 'Decide continuation',
        [updates_1.UpdateType.Dead]: 'Debtor has died',
        [updates_1.UpdateType.MovedAbroad]: 'Debtor has moved abroad',
        [updates_1.UpdateType.Disappeared]: 'Debtor has disappeared',
        [updates_1.UpdateType.Homeless]: 'Debtor has become homeless',
        [updates_1.UpdateType.Inactive]: 'Company is inactive',
        [updates_1.UpdateType.OperationsCeased]: 'Company has ceased operations',
        [updates_1.UpdateType.GuardianStatus]: 'Guardian-status updated',
        [updates_1.UpdateType.DeletedRKIRegistration]: 'RKI Registration Deleted',
        [updates_1.UpdateType.DeletedRKIRegistrationWillingnessToPay]: 'RKI registration deleted - indication of willingness to pay',
        [updates_1.UpdateType.NewRKIRegristration]: 'New RKI Registration',
        [updates_1.UpdateType.Address]: 'Address updated',
        [updates_1.UpdateType.AddressProtection]: 'Name/Address-Protection updated',
        [updates_1.UpdateType.RKIRemark]: 'RKI Remark updated',
        [updates_1.UpdateType.Active]: 'Debtor is now active',
        [updates_1.UpdateType.CompanyActive]: 'Company is now active',
        [updates_1.UpdateType.DissolutionStatus]: 'Dissolution status',
        [updates_1.UpdateType.PAYMENTPLANCANCLED]: 'Payment plan canceled',
        [updates_1.UpdateType.INTERNALREMARK]: 'Internal remark',
        [updates_1.UpdateType.MOVETOOPENRKI]: 'Move to open RKI',
        [updates_1.UpdateType.DebtorIsUnderage]: 'Debtor is under 18 years old',
        [updates_1.UpdateType.SentToConnectPartner]: 'Sent to connect partner',
        [updates_1.UpdateType.ReturnedToConnectPartner]: 'Returned to connect partner',
        [updates_1.UpdateType.DebtorCanBeRegisteredInDebtRegister]: 'Debtor can be registered in a debt register',
        [updates_1.UpdateType.PAYMENTREVOKED]: 'Payment revoked',
    },
    updateTypesClient: {
        [updates_1.UpdateType.AWAITINGCLIENTANSWER]: 'New message from collector',
    },
    caseFilter: {
        moreFilters: 'Filters',
        advancedFilters: 'Advanced filters',
        casesSelected: 'selected cases',
        aggregationSum: 'Sum',
        orderCaseOverview: 'Order case overview',
        creditorsGroup: 'Creditors',
        contactsGroup: 'Contact persons',
        maxRkiRegistrations: 'Max. RKI-registrations',
        maxRkiRegistrationsSub: 'Choose maximum RKI-registrations debtor can have.',
        maxRkiRegistrationsBadge: 'RKI max.',
        minRkiRegistrations: 'Min. RKI-registrations',
        minRkiRegistrationsSub: 'Choose minimum RKI-registrations debtor can have.',
        minRkiRegistrationsBadge: 'RKI min.',
        rkiRegisteredByCollector: 'Is RKI registered by collector',
        isRegisteredByCollector: 'Is registered',
        isNotRegisteredByCollector: 'Is not registered',
        contactHasEmail: 'Contact person has an email',
        contactHasEmailBadge: 'Has email',
        contactHasPhone: 'Contact person has phone number',
        contactHasPhoneBadge: 'Has phone',
        contactHasAddress: 'Contact person has an address',
        contactHasAddressBadge: 'Has address',
        contactPersonIs: 'Contact person is',
        debtor: 'Debtor',
        debtorBadge: 'Debtor is contact person',
        alternativeContact: 'Alternative contact person',
        alternativeContactBadge: 'Has alternative contact person',
        company: 'Company',
        companyBadge: 'Is company',
        person: 'Is person',
        personBadge: 'Is person',
        paymentMethod: 'Payment method',
        hasCard: 'Has payment card',
        doNotHaveCard: 'Does not have payment card',
        companyStatus: 'Company status',
        selectCompanyStatus: 'Select company status',
        companyTypes: 'Company types',
        selectCompanyTypes: 'Select company types',
        court: 'Court',
        courtBadge: 'Court selected',
        selectCourt: 'Select court',
        companyBranch: 'Company branch',
        selectCompanyBranch: 'Select branches',
        gender: 'Gender',
        [__1.Gender.MALE]: 'Male',
        [__1.Gender.FEMALE]: 'Female',
        [__1.Gender.BOTH]: 'Both',
        zipcode: 'Zipcode',
        selectZipcode: 'Select zipcode',
        satisfactions: 'Satisfactions',
        casesGroup: 'Cases',
        caseStatus: 'Case status',
        selectCaseStatus: 'Select case status',
        endReasons: 'Exit reason',
        selectEndReasons: 'Select exit reasons',
        caseGroup: 'Case group',
        selectCaseGroup: 'Select case group',
        caseImport: 'Case import',
        selectCaseImport: 'Select case import',
        caseCreatedAfter: 'Case created after',
        caseCreatedAfterPlaceholder: 'After',
        caseCreatedBefore: 'Case created before',
        caseCreatedBeforePlaceholder: 'Before',
        caseSeqIds: 'Case numbers',
        exceptCaseSeqIds: 'Except case numbers',
        caseSeqIdsDescription: 'Case numbers seperated by newline, semi colon, comma or space.',
        caseSeqIdFilterBadge: 'By case numbers',
        updatesGroup: 'Case statuses',
        caseIsCurrently: 'Cases which is',
        caseIsCurrentlyPaused: 'Paused',
        caseIsCurrentlyNotPaused: 'Not paused',
        paused: 'Paused',
        notPaused: 'Not paused',
        selectStatus: 'Select status',
        hasFollowingStatus: 'Has status',
        hasFollowingStatusSub: 'Have or have had one of the following statuses',
        hasFollowingStatusBadge: 'Has status',
        doNotHaveFollowingStatus: 'Do not have status',
        doNotHaveFollowingStatusSub: 'Do not have or have had one of the following statuses',
        doNotHaveFollowingStatusBadge: 'Do not have status',
        isPausedFollowingStatus: 'Is paused with status',
        isPausedFollowingStatusSub: 'Is paused with one of the following statuses right now',
        isPausedFollowingStatusBadge: 'Is paused with status',
        isNotPausedFollowingStatus: 'Not paused',
        isNotPausedFollowingStatusSub: 'Is not paused with one of the following statuses',
        isNotPausedFollowingStatusBadge: 'Is not paused with status',
        economyGroup: 'Economy',
        economyOnlyVoucherTypeIds: 'Only selected voucher types',
        economyMinAmount: 'Min.-balance',
        economyMaxAmount: 'Max.-balance',
        economyConnectors: 'Cases with billing model',
        billingModels: 'Billing models',
        economyMin: 'Min.',
        economyMax: 'Max.',
        economySelectedBillingModels: 'Selected billing models',
        economySelectedBillingAppendixSetups: 'Selected appendix setups',
        workflowsGroup: 'Workflows',
        inSelectedWorkflows: 'Selected workflows',
        isInWorkflows: 'Is in workflow',
        selectWorkflows: 'Selected workflows',
        selectNextTaskIds: 'Select tasks',
        nextTaskIds: 'Next task in workflow',
        selectCurrentTaskIds: 'Select tasks',
        currentTaskIds: 'Current task in workflow',
        noNextTask: 'No next task',
        documentsGroup: 'Documents',
        hasDocumentOfType: 'Has document of type',
        hasDocumentOfTypeBadge: 'Has document of type',
        selectDocumentTypes: 'Select document types',
        documentsIsSigned: 'Select only signed documents',
        paymentPlansGroup: 'Payment Plans',
        paymentPlanStatuses: 'payment plans with status',
        selectPaymentPlanStatus: 'Select status',
        paymentPlanIsNotHavingStatuses: 'Select payment plans without the above statuses',
        paymentPlanIsNotHavingStatusesBadge: 'Payment plans without statuses',
        interactionsGroup: 'Interactions',
        emailToContains: 'Email to contains',
        emailToContainsSub: 'Email to contains for example "@domstol.dk"',
        emailTo: 'Email',
        interactionType: 'Interaction type',
        selectInteractionType: 'Select interaction type',
        interactionState: 'Interactions state',
        selectInteractionState: 'Select interaction state',
        interactionDirection: 'Interaction direction',
        selectInteractionDirection: 'Select interaction direction',
        noneOfTheAboveBadge: 'None of selected interactions',
        noneOfTheAbove: 'Cases with interactions with none of the above',
        accountsGroups: 'Users',
        selectedCreditors: 'creditor(s) selected',
        caseVisitedBy: 'Case visted by',
        selectAccount: 'Select users',
        caseVisitedBefore: 'Case visited before',
        to: 'To',
        caseVisitedAfter: 'Case visited after',
        from: 'From',
        offset: 'Offset',
        offsetExplanation: 'Choose the number of cases to skip',
        limit: 'Limit',
        limitExplanation: 'Choose the number of cases to select',
        pagination: 'Pagination',
        properties: 'Properties',
        property: 'Property',
        propertyExplanation: 'Filer',
        bulkActions: 'Bulk actions',
        bulkActionsConfirm: 'Are you sure that you want to run the selected bulk action on the selected cases?',
        approveVerifyAllCases: 'Are you sure you want to verify all selected cases?',
        casesVerified: 'Selected cases are now getting verified',
        pauseCasesBulk: 'Selected cases is now getting paused. You will receive an email when the system is done.',
        continueCasesBulk: 'Your selected pause status will be continued on the selected cases. You will receive an email when the system is done.',
        runProcedureBulk: 'The selected shortcut will now get executed on the selected cases. You will receive an email when the system is done.',
        changeBillingModelBulk: 'The selected shortcut will now get executed on the selected cases. You will receive an email when the system is done.',
        changeBillingModelDesc: 'Move cases to selected billing model for cases that is not invoiced.',
        changeBillingModelPlaceholder: 'Billing model',
        changeWorkflowBulk: 'The selected shortcut will now get executed on the selected cases. You will receive an email when the system is done.',
        changeWorkflowDesc: 'Move cases to selected workflow.',
        changeWorkflowPlaceholder: 'Workflows',
    },
    aggregations: {
        aggregate: 'Aggregate cases',
    },
    aggregationTypes: {
        [aggregations_1.AggregationType.CountAll]: 'Quantity cases',
        [aggregations_1.AggregationType.ByCaseGroup]: 'Case group',
        [aggregations_1.AggregationType.ByBillingModel]: 'Billing model',
        [aggregations_1.AggregationType.ByBillingAppendixSetup]: 'Billing appendix setup',
        [aggregations_1.AggregationType.ByWorkflow]: 'Workflow',
        [aggregations_1.AggregationType.ByCaseStatus]: 'Case status',
        [aggregations_1.AggregationType.ByCreditor]: 'Creditor',
        [aggregations_1.AggregationType.ByMigratedWorkflowTaskId]: 'Migrated workflow task',
    },
    bulkActions: {
        runBulkAction: 'Run bulk action',
        bulkActionStarted: 'Bulk action started',
        bulkActions: 'Bulk action',
        bulkActionsConfirm: 'Are you sure you want to run this bulk action?',
        bulkActionBillingModelPlaceholder: 'Billing model',
        bulkActionWorkflowPlaceholder: 'Workflow',
        bulkActionMoveToTaskInWorkflowPlaceholder: 'Choose task in workflow',
        bulkActionChangeCaseGroup: 'Select case group',
        pleaseSelectAWorkflow: 'Please select a workflow in case filter',
    },
    bulkActionTypes: {
        [bulk_actions_1.BulkActionType.MoveCaseStatus]: 'Change case status',
        [bulk_actions_1.BulkActionType.PauseCases]: 'Pause selected cases',
        [bulk_actions_1.BulkActionType.ContinueCases]: 'Continue selected cases',
        [bulk_actions_1.BulkActionType.RunProcedure]: 'Run shortcut on selected cases',
        [bulk_actions_1.BulkActionType.ChangeBillingModel]: 'Change billing model',
        [bulk_actions_1.BulkActionType.ChangeBillingAppendixSetup]: 'Change billing appendix setup',
        [bulk_actions_1.BulkActionType.ChangeWorkflow]: 'Change workflow',
        [bulk_actions_1.BulkActionType.MoveCaseToWorkflowTask]: 'Move to workflow task',
        [bulk_actions_1.BulkActionType.RollbackOneTask]: 'Rollback latest workflow task',
        [bulk_actions_1.BulkActionType.RollbackAllTasks]: 'Rollback all workflow tasks',
        [bulk_actions_1.BulkActionType.RunBillingModel]: 'Run billing model',
        [bulk_actions_1.BulkActionType.ResubscribeCosmo]: 'Resubscribe Cosmo',
        [bulk_actions_1.BulkActionType.ChangeCaseGroup]: 'Change case group',
        [bulk_actions_1.BulkActionType.ResyncCosmo]: 'Resync cosmo',
    },
    bulkActionDescriptions: {
        [bulk_actions_1.BulkActionType.MoveCaseStatus]: 'Change case status to',
        [bulk_actions_1.BulkActionType.PauseCases]: 'Pause selected cases',
        [bulk_actions_1.BulkActionType.ContinueCases]: 'Continue selected cases',
        [bulk_actions_1.BulkActionType.RunProcedure]: 'Run shortcut on selected cases',
        [bulk_actions_1.BulkActionType.ChangeBillingModel]: 'Change billing model',
        [bulk_actions_1.BulkActionType.ChangeBillingAppendixSetup]: 'Change billing appendix setup',
        [bulk_actions_1.BulkActionType.ChangeWorkflow]: 'Change workflow',
        [bulk_actions_1.BulkActionType.MoveCaseToWorkflowTask]: 'Move to workflow task',
        [bulk_actions_1.BulkActionType.RollbackOneTask]: 'Rollback latest workflow task',
        [bulk_actions_1.BulkActionType.RollbackAllTasks]: 'Rollback all workflow tasks',
        [bulk_actions_1.BulkActionType.RunBillingModel]: 'Run billing model',
        [bulk_actions_1.BulkActionType.ResubscribeCosmo]: 'Resubscribe Cosmo',
        [bulk_actions_1.BulkActionType.ChangeCaseGroup]: 'Change case group',
        [bulk_actions_1.BulkActionType.ResyncCosmo]: 'Resync cosmo',
    },
    bulkActionsEmailConfirmationSubject: {
        [bulk_actions_1.BulkActionType.MoveCaseStatus]: 'Change case status',
        [bulk_actions_1.BulkActionType.PauseCases]: 'Pause selected cases',
        [bulk_actions_1.BulkActionType.ContinueCases]: 'Continue selected cases',
        [bulk_actions_1.BulkActionType.RunProcedure]: 'Run shortcut on selected cases',
        [bulk_actions_1.BulkActionType.ChangeBillingModel]: 'Change billing model',
        [bulk_actions_1.BulkActionType.ChangeBillingAppendixSetup]: 'Change billing appendix setup',
        [bulk_actions_1.BulkActionType.ChangeWorkflow]: 'Change workflow',
        [bulk_actions_1.BulkActionType.MoveCaseToWorkflowTask]: 'Move to workflow task',
        [bulk_actions_1.BulkActionType.RollbackOneTask]: 'Workflow tasks rolled back',
        [bulk_actions_1.BulkActionType.RollbackAllTasks]: 'Workflow tasks rolled back',
        [bulk_actions_1.BulkActionType.RunBillingModel]: 'Billing model has been run',
        [bulk_actions_1.BulkActionType.ResubscribeCosmo]: 'Resubscribe Cosmo has been run',
        [bulk_actions_1.BulkActionType.ChangeCaseGroup]: 'Case groups have been changed',
        [bulk_actions_1.BulkActionType.ResyncCosmo]: 'Cosmo resynced',
    },
    bulkActionsEmailConfirmationBody: {
        [bulk_actions_1.BulkActionType.MoveCaseStatus]: 'Changed case status on the selected cases.',
        [bulk_actions_1.BulkActionType.PauseCases]: 'Pausing selected cases done.',
        [bulk_actions_1.BulkActionType.ContinueCases]: 'Continued selected cases.',
        [bulk_actions_1.BulkActionType.RunProcedure]: 'Shortcut executed on selected cases.',
        [bulk_actions_1.BulkActionType.ChangeBillingModel]: 'Changed billing model on the selected cases.',
        [bulk_actions_1.BulkActionType.ChangeBillingAppendixSetup]: 'Changed billing appendix setup on the selected cases.',
        [bulk_actions_1.BulkActionType.ChangeWorkflow]: 'Changed workflow on the selected cases.',
        [bulk_actions_1.BulkActionType.MoveCaseToWorkflowTask]: 'Moved workflow task on the selected cases.',
        [bulk_actions_1.BulkActionType.RollbackOneTask]: 'Workflow tasks rolled back.',
        [bulk_actions_1.BulkActionType.RollbackAllTasks]: 'Workflow tasks rolled back.',
        [bulk_actions_1.BulkActionType.RunBillingModel]: 'Billing model has been run',
        [bulk_actions_1.BulkActionType.ResubscribeCosmo]: 'Resubscribe Cosmo has been run',
        [bulk_actions_1.BulkActionType.ChangeCaseGroup]: 'Case groups has been changed',
        [bulk_actions_1.BulkActionType.ResyncCosmo]: 'Cosmo has been resynced',
    },
    paymentPlansInsights: {
        paymentPlans: 'Payment plans',
        quantityEntries: 'Quantity of entries',
        amountEntries: 'Amount',
    },
    insights: {
        fromDate: 'From date',
        toDate: 'To date',
        getReport: 'Get report',
        powerbi: {
            downloadPbids: 'Download a PBIDS file to import into your Power BI setup',
        },
        connectToApi: 'Connect to your data via an API',
        downloadLimit: 'The limit for requesting a specific data source is one time per day',
        apiTypes: {
            ['cases']: 'Cases',
            ['users']: 'Users',
            ['satisfactions']: 'Satisfactions',
            ['case-vouchers']: 'Case vouchers',
            ['billing-vouchers']: 'Billing vouchers',
            ['creditors']: 'Creditors',
            ['updates']: 'Tasks',
            ['update-types']: 'Task types',
            ['workflows']: 'Workflows',
            ['workflow-tasks']: 'Workflow tasks',
            ['case-statuses']: 'Cases status log',
            ['interactions']: 'Interactions',
            ['documents']: 'Documents',
            ['payment-plans']: 'Payment plans',
            ['payment-plan-entries']: 'Payment plan entries',
            ['users-on-customers']: 'Users on customers',
            ['customers']: 'Customers',
            ['properties']: 'Properties',
        },
        connectGuide: {
            description: 'You can access your data through an API for external use',
            liIntroStep1: 'Go to Settings and choose Developers',
            liIntroStep2: 'Create a new API-Key',
            liIntroStep3: 'Name the key and choose the corresponding scope',
            liIntroStep4: 'The corresponding scope is',
            liIntroStep5: 'You can now use your new API-key to connect to',
            powerbiDescription: 'The walkthrough below shows how to connect to Power BI',
            liPowerbiStep1: "Connect to a new 'Web' data source inside Power BI",
            liPowerbiStep2: 'Fill out the configurations as the picture below where you replace',
            liPowerbiStep3: 'with the web address from above and',
            liPowerbiStep4: 'with your newly created API-key',
            liPowerbiStep5: 'Press OK and you are good to go',
            understood: 'Close',
        },
        connect: 'Connect',
        download: 'Download',
        orderReport: 'Order report',
        billingFile: 'Billing file',
        billingFileDesc: 'Billing file for debtor transactions per creditor per day.',
        caseOverview: 'Case Overview',
        caseOverviewDesc: 'Overview of all active and ended cases including status, financials and debtor information.',
        includeDocuments: 'Include documents',
        includeVouchers: 'Include vouchers',
        includeRki: 'Include RKI reports',
        documents: 'Documents',
        steps: 'Steps',
        vouchers: 'Vouchers',
        cases: 'Cases',
        collector: 'Collector',
        creditor: 'Creditor',
        rki: 'RKI',
        caseOverviewHeaderDocumentId: 'Doc Id',
        caseOverviewHeaderFileLink: 'Link to file',
        caseOverviewHeaderType: 'Type',
        caseOverviewHeaderSignedAt: 'Date of signature underskrift',
        caseOverviewHeaderCreatedAt: 'Date of creation',
        caseOverviewHeaderDate: 'Date',
        caseOverviewHeaderDueDate: 'Due date',
        caseOverviewHeaderCategory: 'Category',
        caseOverviewHeaderImposedBy: 'Imposed by',
        caseOverviewHeaderText: 'Text',
        caseOverviewHeaderInterest: 'Interest rate',
        caseOverviewHeaderInterestStartDate: 'Interest start date',
        caseOverviewHeaderInterestEndDate: 'Interest end date',
        caseOverviewHeaderAmount: 'Amount',
        caseOverviewHeaderExpirationDate: 'Expiration date',
        caseOverviewHeaderExpired: 'Expired',
        caseOverviewCompany: 'Company',
        caseOverviewPrivate: 'Person',
        caseOverviewHeaderCreditor: 'Creditor',
        caseOverviewHeaderCreditorSeqId: 'Creditornummer',
        caseOverviewHeaderCaseGroup: 'Case group',
        caseOverviewHeaderImportedAt: 'Import date',
        caseOverviewHeaderCaseSeqId: 'Case number',
        caseOverviewHeaderMigratedJournalNumber: 'Migrated j.no.',
        caseOverviewHeaderReferenceId: 'Reference',
        caseOverviewHeaderDebtorSeqId: 'Debtor number',
        caseOverviewHeaderDebtorName: 'Name',
        caseOverviewHeaderDebtorEmail: 'Email',
        caseOverviewHeaderDebtorPhone: 'Phone',
        caseOverviewHeaderDebtorSatisfaction: 'Satisfaction',
        caseOverviewHeaderDebtorSatisfactionComment: 'Satisfaction comment',
        caseOverviewHeaderDebtorRKICount: 'RKI registration count',
        caseOverviewHeaderDebtorCompanyStatus: 'Company status',
        caseOverviewHeaderDebtorCVR: 'CVR',
        caseOverviewHeaderDebtorBirthdate: 'Birthdate',
        caseOverviewHeaderDebtorAddressProtection: 'Address protected',
        caseOverviewHeaderDebtorCountry: 'Country',
        caseOverviewHeaderDebtorZipCode: 'Zipcode',
        caseOverviewHeaderDebtorCity: 'City',
        caseOverviewHeaderDebtorAddress: 'Address',
        caseOverviewHeaderDebtorCoAddress: 'Co address',
        caseOverviewHeaderDebtorType: 'Debtor type',
        caseOverviewHeaderDebtorCount: 'Debtor count',
        caseOverviewHeaderCreditScore: 'Credit Score',
        caseOverviewHeaderCurrency: 'Currency',
        caseOverviewHeaderPrincipal: 'Principal',
        caseOverviewHeaderPrincipalPaid: 'Paid of principal',
        caseOverviewHeaderPrincipalLeft: 'Remaining of principal',
        caseOverviewHeaderReminderFeeCreditor: 'Reminder fee from creditor',
        caseOverviewHeaderReminderFeeCreditorPaid: 'Paid of reminder fee from creditor',
        caseOverviewHeaderReminderFeeCreditorLeft: 'Remaining of reminder fee from creditor',
        caseOverviewHeaderReminderFeeCollector: 'Reminder fee from collector',
        caseOverviewHeaderReminderFeeCollectorPaid: 'Paid of reminder fee from collector',
        caseOverviewHeaderReminderFeeCollectorLeft: 'Remaining of reminder fee rom collector',
        caseOverviewHeaderCompensationCostCreditor: 'Compensation fee from creditor',
        caseOverviewHeaderCompensationCostCreditorPaid: 'Paid of compensation fee from creditor',
        caseOverviewHeaderCompensationCostCreditorLeft: 'Remaining of compensation fee from creditor',
        caseOverviewHeaderCompensationCostCollector: 'Compensation fee from collector',
        caseOverviewHeaderCompensationCostCollectorPaid: 'Paid of compensation fee from collector',
        caseOverviewHeaderCompensationCostCollectorLeft: 'Remaining of compensation fee from collector',
        caseOverviewHeaderCollectionCostCreditor: 'Collection cost from creditor',
        caseOverviewHeaderCollectionCostCreditorPaid: 'Paid of collection cost from creditor',
        caseOverviewHeaderCollectionCostCreditorLeft: 'Remaining of collection cost from creditor',
        caseOverviewHeaderCollectionCostCollector: 'Collection cost from collector',
        caseOverviewHeaderCollectionCostCollectorPaid: 'Paid of collection cost from collector',
        caseOverviewHeaderCollectionCostCollectorLeft: 'Remaining of collection cost from collector',
        caseOverviewHeaderCollectionFeeCreditor: 'Collection fee from creditor',
        caseOverviewHeaderCollectionFeeCreditorPaid: 'Paid of collection fee from creditor',
        caseOverviewHeaderCollectionFeeCreditorLeft: 'Remaining of collection fee from creditor',
        caseOverviewHeaderCollectionFeeCollector: 'Collection fee from collector',
        caseOverviewHeaderCollectionFeeCollectorPaid: 'Paid of collection fee from collector',
        caseOverviewHeaderCollectionFeeCollectorLeft: 'Remaining of collection fee from collector',
        caseOverviewHeaderCourtCostCreditor: 'Court costs from creditor',
        caseOverviewHeaderCourtCostCreditorPaid: 'Paid of court costs from creditor',
        caseOverviewHeaderCourtCostCreditorLeft: 'Remaining of court costs from creditor',
        caseOverviewHeaderCourtCostCollector: 'Court costs from collectors',
        caseOverviewHeaderCourtCostCollectorPaid: 'Paid of court costs from collectors',
        caseOverviewHeaderCourtCostCollectorLeft: 'Remaining of court costs from collectors',
        caseOverviewHeaderInterestCreditor: 'Interests from creditor',
        caseOverviewHeaderInterestCreditorPaid: 'Paid of interests from creditor',
        caseOverviewHeaderInterestCreditorLeft: 'Remaining of interests from creditor',
        caseOverviewHeaderInterestCollector: 'Interests from collector',
        caseOverviewHeaderInterestCollectorPaid: 'Paid of interests from collector',
        caseOverviewHeaderInterestCollectorLeft: 'Remaining of interests from collector',
        caseOverviewHeaderCreditorTotal: 'Total from creditor',
        caseOverviewHeaderCreditorTotalPaid: 'Paid of total from creditor',
        caseOverviewHeaderCreditorTotalLeft: 'Remaining of total from creditor',
        caseOverviewHeaderCreditorTotalDepositsToCreditor: 'Deposited to creditor in total',
        caseOverviewHeaderCollectorTotal: 'Total from collector',
        caseOverviewHeaderCollectorTotalPaid: 'Paid of total from collector',
        caseOverviewHeaderCollectorTotalLeft: 'Remaining of total from collector',
        caseOverviewHeaderTotal: 'Total',
        caseOverviewHeaderTotalPaid: 'Paid of total',
        caseOverviewHeaderTotalLeft: 'Remaining of total',
        caseOverviewHeaderLastDepositDate: 'Latest deposit date',
        caseOverviewHeaderCurrentWorkflow: 'Workflow',
        caseOverviewHeaderCurrentWorkflowTask: 'Current task',
        caseOverviewHeaderCurrentWorkflowTaskTime: 'Current task date',
        caseOverviewHeaderNextWorkflowTask: 'Next task',
        caseOverviewHeaderNextWorkflowTaskTime: 'Next task date',
        caseOverviewHeaderFoundation: 'Foundation',
        caseOverviewHeaderPaymentPlan: 'Payment plan',
        caseOverviewHeaderPaidPaymentPlanEntries: 'Paid entries',
        caseOverviewHeaderTotalPaymentPlanEntries: 'Total payment plan entries',
        caseOverviewHeaderCaseStatus: 'Case status',
        caseOverviewHeaderEndReason: 'End reason',
        caseOverviewHeaderExitDate: 'End date',
        caseOverviewHeaderStepTitle: 'Step title',
        caseOverviewHeaderStepCategory: 'Step category',
        caseOverviewHeaderNextStepTitle: 'Next step title',
        caseOverviewHeaderNextStepCategory: 'Next step category',
        caseOverviewHeaderSignedFoudations: 'Signed foundations',
        caseOverviewHeaderPaymentPlans: 'Payment plans created',
        caseOverviewHeaderFoundationDate: 'Foundation Date',
        caseOverviewHeaderFoundationCode: 'Foundation Code',
        caseOverviewHeaderFoundationType: 'Fundaments Type',
        caseOverviewHeaderRkiRegistry: 'Registry',
        caseOverviewHeaderState: 'State',
        caseOverviewHeaderReportedAt: 'Reported At',
        caseOverviewHeaderError: 'Error Meassage',
        caseOverviewHeaderRKIReference: 'RKI Reference Number',
        caseOverviewHeaderClientNumber: 'Creditor Number',
        caseOverviewHeaderSurveillance: 'Surveillance',
        caseOverviewHeaderSurveillanceDate: 'Surveillance Date',
        reportOrdered: 'Report ordered',
        reportOrderedText: 'You will soon receive an email with your report.',
        reportOrderedCloseButton: 'Close',
        interactionsReports: 'Interactions Report',
        interactionsReportsDesc: 'Report for all incoming and outgoing interactions',
        interactionsReportsCreatedAt: 'Created',
        interactionsReportsState: 'Status',
        interactionsReportsType: 'Type',
        interactionsReportsDirection: 'Direction',
        interactionsReportsCreditorSeqId: 'Creditor number',
        interactionsReportsCreditor: 'Creditor',
        interactionsReportsCaseSeqId: 'Case id',
        interactionsReportsAddress: 'Address',
        interactionsReportsZipcode: 'Zipcode',
        interactionsReportsCity: 'City',
        interactionsReportsCountry: 'Country',
        dailyDeposits: 'Daily Deposits',
        dailyDepositsDesc: 'Daily deposits pr. creditor',
        paymentPlanReport: 'Payment Plan Report',
        paymentPlanReportDesc: 'Report containing information about active, canceled and past payment plans.',
        dailyDepositsEconomic: 'Daily deposits pr. creditor (e-conomic)',
        dailyDepositsEconomicDesc: 'Daily deposits pr. creditor. per creditor to e-conomic uden Billwerk+',
        invoiceAppendix: 'Invoice Appendix',
        invoiceAppendixDesc: 'Sheet to show financial transactions for creditors in a period of time.',
        employeePerformance: 'Employee Performance',
        employeePerformanceDesc: 'Report showing the effectiveness of each employee.',
        phoneCalls: 'Phone Call Overview',
        phoneCallsDesc: 'Overview showing who called and amount of resulting deposits.',
        phoneCallsDays: 'Number of days after call the deposit has to be registered.',
        depositAmount: 'Deposited amount',
        depositCount: 'Deposit count',
        selectCreditor: 'Select creditor',
        quarter: 'Quarter',
        optional: 'optional',
    },
    tribunal: {
        couldNotCreateTribunalCase: 'Could not create Tribunal case',
        createTribunalCase: 'Create',
        noTribunalCases: 'No Tribunal cases yet',
        addTribunalCase: 'Add Tribunal case',
        fsNo: 'FS no.',
        editFsNo: 'Edit FS no.',
        FsNoUpdated: 'FS no. updated',
        document: 'Document',
        addDocument: 'Add document',
        closedObjection: 'Closed because of objection',
        insolvency: 'Insolvency',
        insolvencyDate: 'Insolvency date',
        phoneCourtMeeting: 'Court phone meeting',
        register: 'Register',
        date: 'Date',
        meetingLocation: 'Meeting location',
        meetingDate: 'Meeting date',
        courtCaseCosts: 'Court case costs',
        notRegistered: 'Not registered',
        createFogedrekvisition: "Create 'fogedrekvisition'",
        assignee: 'Assignee',
        selectDistraintType: 'Select distraint type',
        registerDistraint: 'Register distraint',
        distraintType: 'Distraint type',
        amount: 'Amount',
        comment: 'Comment',
        address: 'Address',
        licenseplate: 'Licenseplate',
        vin: 'VIN',
        distraintDate: 'Date of distraint',
        distraintReferenceId: 'Tinglysning registration number',
        distraintUpdated: 'Distraint updated',
        distraintCancelled: 'Distraint cancelled',
        distraintCancelledDate: 'Date of distraint cancellation',
        registerPolicePresentation: 'Register police presentation',
        register1Paategning: "Register '1.-påtegning'",
        foerstePaategningDate: "Date of '1.-påtegning'",
        register2Paategning: "Register '2.-påtegning'",
        andenPaategningDate: "Date of '2.-påtegning'",
        resendBPK: "Resend 'betalingspåkrav'",
        editBPK: "Edit 'betalingspåkrav'",
        debtorSentToPolicePresentation: 'Debtor sent to police presentation',
        resendStaevning: "Resend 'stævning'",
        editStaevning: "Edit 'stævning'",
        resendFogedbegaering: "Resend 'fogedbegæring'",
        editFogedbegaering: "Edit 'fogedbegæring'",
        courtMeetingType: 'Meeting type',
        bailiffInvoice: {
            bailiffInvoice: 'Bailiff invoice',
            client: 'Creditor',
            debt: 'Debt',
            paymentFee: 'Demand for payment fee',
            distress: 'Distress',
            yesStartDistress: 'Yes to initiation of distress',
            yesAutoCase: 'Yes to automatic case introduction in civil court',
            createInvoice: 'Create invoice',
        },
        noFoundation: 'No foundation found. Please add one to the case.',
        addFoundation: 'Add foundation',
        foundation: 'Foundation',
        economy: 'Economy',
        jurisdiction: 'Jurisdiction',
        requisition: 'Requisition',
        court: 'Court',
        responsible: 'Responsible',
        sendRequisition: 'Send requisition',
        debt: 'Debt',
        noCourt: 'No court found',
        typeOfRequisituion: 'Type of requisition',
        types: {
            [court_1.UdbetalingsRekvisitioner.Politifremstilling]: 'Police presentation',
            [court_1.UdbetalingsRekvisitioner.Betalingspåkrav]: 'Demand for payment',
            [court_1.UdbetalingsRekvisitioner.Fogedrekvisition]: 'Bailiff requisition',
        },
        claim: 'Claim',
        sendToCourt: 'Send to court',
        smallCase: 'Small Case',
        commonCivilCase: 'Common civil case',
        shortDescription: 'Short description',
        statementClaim: 'Case presentation and facts',
        addAppendix: 'Add appendix',
        additionalInformation: 'Additional information',
        caseCreation: 'Creating case',
        caseCreationDescription: `The case is now being created in the court system. It takes some time, but the case will be updated in Debbie once it has finished.`,
        keyCodeTitle: 'Type keycode for',
        keyCodeDescription: 'Use the NemID key card to find the key which corresponds to',
        sessionCreation: 'Creating session',
        sessionCreationFailure: 'Session creation failed',
        keySubmittedExplainer: 'The keycode is being used to log in.',
        sessionCreationExplainer: 'For a case to be sent to the court, there needs to be created a session in tribunal. To do that we need a keycode from your NemID key card.',
        keycode: 'NemID keycode',
        authKey: 'Key',
        missingKeyTitle: 'Missing tribunal key',
        missingKeyExplainer: 'To send cases to the court, you need a key for tribunal.',
    },
    courtMeetingState: {
        [types_3.CourtMeetingState.Accepted]: 'Meeting accepted',
        [types_3.CourtMeetingState.Concluded]: 'Done',
        [types_3.CourtMeetingState.NeedsApproval]: 'Awaiting approval',
        [types_3.CourtMeetingState.NeedsRevision]: 'Awaiting revision',
        [types_3.CourtMeetingState.NotesSent]: 'Notes received',
        [types_3.CourtMeetingState.ReadyForMeeting]: 'Awaiting meeting notes',
        [types_3.CourtMeetingState.Rejected]: 'Rejected by assignee',
        [types_3.CourtMeetingState.Canceled]: 'Canceled',
    },
    debtorWeb: {
        overpaymentHeader: 'An overpayment has been made',
        overpaymentPreAmount: 'You are due to get',
        overpaymentPostAmount: "back. Write your bank account number below, and we'll send them to you.",
        userInfoUpdateSuccess: 'Your request have been sent. Thank you.',
        userInfoUpdateNoDataChanged: 'No changes registered',
        congratsNoDebt: 'Congratulations. You have no more debt on this case.',
        congratsDeposit: 'Thank you for your deposit on this case.',
        congratsCaseEnd: 'The case has been closed.',
        satisfactionOne: 'We would like to hear about your experience. Please click',
        satisfactionTwo: 'here',
        satisfactionThree: 'to tell about it.',
        documentation: 'Documentation',
        goToPayment: 'Go to payment',
    },
    caseGroups: {
        caseGroups: 'Case Groups',
        createCaseGroup: 'Create case group',
        addCaseGroup: 'Add case group',
        editCaseGroup: 'Edit case group',
        selectCaseGroup: 'Select case group',
        confirmDelete: 'Are you sure you want to delete the case group? All cases will be removed from the group.',
        caseGroup: 'Case group',
        deleteCaseGroup: 'Delete',
        label: 'Name',
        categorisedDebtOverview: 'Add properties to categorized debt overview',
        showPropertyLabel: 'Name',
        addShowProperty: 'Add property',
    },
    createTenantContent: {
        defaultCaseGroupLabel: 'Cases for collection',
        defaultBankAccountName: 'Bank account',
    },
    tenants: {
        prices: 'Prices',
        identityCollector: 'Collector',
        invoicePipeFilter: 'Invoicing filter',
        defaultBillingModel: 'Default billing model',
        defaultBillingAppendixSetup: 'Default billing appendix setup',
        configurationOptions: 'Configurations',
        depositBankAccountForCreditors: 'Deposit account for creditors',
        depositBankAccountForCreditorsName: 'Bank name',
        billingCustomText: {
            title: 'Custom text for billing',
            underCreditorName: 'Under creditor name',
            endWhenReceivingPayment: 'Under payment information when creditor should pay something',
            endWhenSendingPayment: 'Under payment information when creditor should receive something',
        },
        collectionCommission: 'Collection commission',
        depositOrder: 'Deposit order',
        date: 'Date',
        voucherFrom: 'Voucher imposed by',
        voucherType: 'Voucher type',
        voucherCategory: 'Voucher category',
        newestFirst: 'Newest first',
        oldestFirst: 'Oldest first',
        caseCloseFee: 'Case close fee',
        clientCaseCreationFee: 'Creditor case creation fee',
        tenantCaseCreationFee: 'Tenant case creation fee',
        RKIRegistrationFee: 'RKI registration fee',
        paymentDemandFee: 'Payment demand fee',
        fogedrekvisitionFee: 'Fogedrekvisition fee',
        folkeregisteropslagsFee: 'Folkeregisteropslag',
        anmeldelseAfKravFee: 'Anmeldelse af krav',
        legalAdviceHourlyRate: 'Hourly rate for legal advice',
        afslysningAfUdlaeg: 'Aflysning af udlæg',
        autoRKI: 'Auto-RKI',
        experianConfig: 'Experian configurations',
        automaticDebtRegister: 'Automatically register in RKI',
        autoRKIOpen: 'Open RKI',
        autoRKIIgnoreUnresolvedOppositions: 'Ignore unresolved interactions (oppositions)',
        autoRKIDeleteOnCaseEnd: 'Delete RKI registration automatically on case end',
        autoDebtRegisterInfoTip: 'Click here for more info',
        areYouSureAutoDebtRegister: 'Are you sure?',
        autoDebtRegisterRKI: {
            headline: 'Automatic registration in RKI.',
            info: 'This function takes into account the following: ',
            exclude: 'It does NOT take into account the following: : ',
            endingInfo: 'Only enable this funciton if you know your cases comply with the above.',
            note: 'Note this function can also be enabled/disabled on creditor level.',
        },
        autoImposeCompensationCost: 'Automatically impose compensation costs when importing company cases',
        autoSendInteractionsAfterXVerifications: 'Automatically send interactions after x verifications',
        preventSendingLetters: 'Prevent sending physical letters (Webhooks can be used to send them in other ways)',
        selfCollection: 'Impose self collection debt collection costs',
        twoFactorRequired: 'Two factor authentication required for users',
        outboundCall: 'Outbound call',
        autoExpireVouchers: 'Automatic expiration of vouchers',
        AKSSettings: 'AKS settings',
        AKSKey: 'AKS key',
        AKSCode: 'AKS code',
        AKSUsername: 'AKS username',
        AKSPassword: 'AKS password',
    },
    intents: {
        intent: 'Intent',
        days: 'Days',
        discount: 'Discount',
        percentDiscount: 'Procent discount',
        type: 'Type',
        noDiscount: 'No discount',
    },
    intentDiscountTypes: {
        [intents_1.DiscountType.Amount]: 'Amount',
        [intents_1.DiscountType.Fraction]: 'Fraction',
    },
    intentTypes: {
        [intents_1.IntentType.Unknown]: 'Unknown',
        [intents_1.IntentType.Deposit]: 'Deposit',
    },
    errros: {
        notFound: 'The page you are looking for was not found.',
        pleaseCreateTicket: 'Please create a ticket if you think this is an error.',
        unknownError: 'An error occured.',
        authError: 'You do not have access.',
        meError: 'There was an error getting your user information. If this is unexpected, try again.',
    },
    letterTemplates: {
        journalNumber: 'Re:',
        caseReferenceId: 'Reference:',
        returnAddress: 'Return address:',
        w: 'W',
        e: 'E',
        t: 'P',
        centralRegisterId: 'CVR',
    },
    mentionContent: {
        reminderFeeRow: 'Reminder fee, cf. Interest Act section 9b, subsection 2',
        debtCollectionFeeRow: 'Collection fee cf. Interest Act section 9b, subsection 3',
        debtCollectionCostRow: 'Collection cost cf. Interest Act section 9a, subsection 1',
        compensationFeeRow: 'Compensation fee cf. Interest Act section 9a, subsection 3',
        fixedInterestRow: 'Previously accrued interest',
        processInterestRow: 'Accrued interests from the due date',
        yearlyInterestRow: 'Accrued interests',
        otherCosts: 'Other costs',
        sum: 'Total outstanding',
        paid: 'Already paid',
        invoice: 'Invoice',
        date: 'Date',
        dueDate: 'Due date',
        amount: 'Amount',
        email: 'Email',
        phone: 'Phone',
        signature: 'Signature',
        journalNumber: 'Re:',
        genericEmailSubjectPre: 'Regarding your outstanding to',
        genericEmailSubjectForAlternativeContactPre: 'Regarding',
        satisfactionsOrClick: 'or click',
        satisfactionsHere: 'here',
        principalReferenceIdsAnd: ', and ',
    },
    emailSignature: {
        privacyPolicyText: 'Data processing. We may process personal data about you. You can read our privacy policy here:',
        regards: 'Kind regards',
    },
    invoice: {
        deposit: 'Deposit',
        overpayment: 'Overpayment',
        deposits: 'Deposits',
        creditorSeqId: 'Id',
        period: 'Period',
        description: 'Description',
        amount: 'Amount',
        ofVoucher: 'Of voucher',
        subTotal: 'Subtotal',
        vat: 'Vat',
        total: 'Total',
        date: 'Date',
        number: 'Number',
        appendix: 'Appendix',
        voucher: 'Voucher',
        voucherReferenceId: 'Voucher reference',
        text: 'Text',
        disbursements: 'Disbursements',
        fees: 'Fees',
        collectionCommission: 'Collection commission',
        creditorName: 'Creditor',
        creditorReference: 'Creditor reference id',
        caseGroup: 'Case group',
        caseSeqId: 'Case id',
        caseReferenceId: 'Case reference id',
        depositId: 'Deposit id',
        paidToClient: 'Paid to creditor',
        economicMovement: 'Creditor movement',
        debtorName: 'Debtor name',
        creditorDeposit: 'Creditor Deposit',
        previous: 'Prev.',
        credited: 'Credited',
        currency: 'Currency',
    },
    standardProcedureTitles: {
        ['2bf2187e-259e-4176-a762-859e4688ba3b']: 'Overpayment',
        ['4b9cc5d8-c3af-441b-8eb1-a3afa882e59d']: 'Payment plan offer',
        ['61ddc972-b02d-44e0-b9bc-3c746e1c1be4']: 'Partial payment',
        ['77b8678a-a6dd-4005-b320-7a9cc963f751']: 'Case fully paid',
        ['e205691e-4197-4152-81a6-09de315cb70a']: 'Case updated',
        ['47d383b7-f239-4566-abb2-58cae4d9bd30']: 'Payment on case in court',
    },
    standardProcedureDescriptions: {
        ['2bf2187e-259e-4176-a762-859e4688ba3b']: 'More has been paid than has been charged.',
        ['4b9cc5d8-c3af-441b-8eb1-a3afa882e59d']: 'Send an offer for a payment plan.',
        ['61ddc972-b02d-44e0-b9bc-3c746e1c1be4']: 'Case partially paid. Let the contact person know.',
        ['77b8678a-a6dd-4005-b320-7a9cc963f751']: 'Close the case and let the contact person know.',
        ['e205691e-4197-4152-81a6-09de315cb70a']: 'The case has been updated.',
        ['47d383b7-f239-4566-abb2-58cae4d9bd30']: 'Payment has been made on a case in court. Let the court know',
    },
    properties: {
        properties: 'Properties',
        infoGuideMentions: 'To insert the data into a template please use this tag',
        infoGuideImport: 'To import data into the property you can make a column in your excel sheet with one of the following column headers',
        newProperty: 'New property type',
        newPropertyFor: 'Create a new property type for',
        label: 'Label',
        description: 'Description',
        handle: 'Handle',
        type: 'Type',
        ref: 'Reference',
        scope: 'Affiliation',
        required: 'Required',
        usage: 'Usage',
        historical: 'Historical data',
        create: 'Create',
        dropdownOptions: 'Dropdown options',
        cases: 'Cases',
        caseVouchers: 'Case vouchers',
        creditors: 'Creditors',
        delete: 'Delete',
        or: 'or',
        deleteAreYouSure: 'If this property is deleted, it will be removed from all cases and templates. Are you sure?',
    },
    entities: {
        [__1.Entity.Billing]: 'Billing',
        [__1.Entity.Case]: 'Case',
        [__1.Entity.Creditor]: 'Creditor',
        [__1.Entity.Customer]: 'Customer',
        [__1.Entity.TribunalCase]: 'Tribunal case',
        [__1.Entity.Debtor]: 'Debtor',
        [__1.Entity.Collector]: 'Collector',
        [__1.Entity.BillingVoucher]: 'Billing voucher',
        [__1.Entity.CaseVoucher]: 'Case voucher',
    },
    filterType: {
        [insights_1.FilterType.Exact]: 'Filter on exact match',
        [insights_1.FilterType.Containing]: 'Filter on containing match',
    },
    propertyTypeLabels: {
        ['Name']: 'Name',
        ['Address']: 'Address',
        ['Phone']: 'Phone',
        ['Email']: 'Email',
        ['Type']: 'Type',
        ['Company']: 'Company',
    },
    propertyTypeDescriptions: {
        ['Name of the alternative contact person.']: 'Name of the alternative contact person.',
        ['Address for the alternative contact person.']: 'Address for the alternative contact person.',
        ['Phone to the alternative contact person.']: 'Phone to the alternative contact person.',
        ['Email to the alternative contact person.']: 'Email to the alternative contact person.',
        ['Type of the alternative contact person.']: 'Type of the alternative contact person.',
        ['Company where the alternative contact person works.']: 'Company where the alternative contact person works.',
    },
    alternativeContactTypes: {
        [customers_1.AlternativeContactType.Lawyer]: 'Lawyer',
        [customers_1.AlternativeContactType.Proprietorship]: 'Residential administrator',
        [customers_1.AlternativeContactType.Owner]: 'Owner',
        [customers_1.AlternativeContactType.Guardian]: 'Guardian',
        [customers_1.AlternativeContactType.Curator]: 'Curator',
        [customers_1.AlternativeContactType.Landlord]: 'Landlord',
        [customers_1.AlternativeContactType.FinancialAdvisor]: 'Financial advisor',
        [customers_1.AlternativeContactType.TaxAuthority]: 'Tax authority',
        [customers_1.AlternativeContactType.PowerOfAttorney]: 'Power of attorney',
        [customers_1.AlternativeContactType.Administrator]: 'Administrator',
        [customers_1.AlternativeContactType.Police]: 'Police',
        [customers_1.AlternativeContactType.Guarantor]: 'Guarantor',
        [customers_1.AlternativeContactType.Other]: 'Other',
    },
    creditScore: {
        estimated: 'Estimated',
        estimate: 'collection probability on remaining debt',
        estimateZero: 'collection probability',
        paid: 'Debt has been paid',
    },
    voucherApplications: {
        header: 'Voucher applications',
        createError: 'Could not create voucher application, check that you are not creating circular references',
        creditorCustomApplicationList: 'Creditors with their own applications',
        noCustomApplications: 'No creditors have custom applications',
        textSelector1: 'When a new ',
        textSelector2: ' is created, where the type of the case is ',
        textSelector3: ', the following voucher will be created',
        forCreditor: 'When creditor is',
        addCreditor: 'Choose creditor',
    },
    voucherApplicationTypeLabels: {
        [voucher_applications_1.VoucherApplicationType.Case]: 'case',
        [voucher_applications_1.VoucherApplicationType.VoucherCategory]: 'voucher with the category',
        [voucher_applications_1.VoucherApplicationType.VoucherType]: 'voucher with the type',
    },
    voucherApplicationTargetLabels: {
        [voucher_applications_1.VoucherApplicationTarget.Both]: 'private/company',
        [voucher_applications_1.VoucherApplicationTarget.Person]: 'private',
        [voucher_applications_1.VoucherApplicationTarget.Company]: 'company',
    },
    customerCare: {
        serviceRequestsHeader: 'Service Request',
        serviceRequestsDescription: 'Har du brug for hjælp til Debbie? Det kan være ting som ændring af indstillinger, oprettelse af workflows eller hvordan man journaliserer en e-mail. Vi er her for at guide dig gennem processen og sikre, at du får mest muligt ud af vores løsning.',
        serviceRequestsButton: 'Få hjælp',
        serviceRequestsSupportUsersDescription: 'Med jeres support-pakke har I muligheden for, at vælge {maxUsers} kontaktperson(er), som er ansvarlig(e) for dialogen med Debbie. Hvis I har brug for flere kontaktpersoner, kan I opgradere jeres support-pakke.',
        serviceRequestsSupportUsersSelect: 'Vælg venligst jeres faste kontaktpersoner:',
        serviceRequestsSupportUsersSelected: 'valgt',
        serviceRequestsSupportUsersSave: 'Gem',
        knowledgeBase: 'Knowledgebase',
        knowledgeBaseDesc: 'Få hjælp, vejledning og gode råd ved at læse Debbies artikler.',
        ticket: 'Ticket',
        ticketDesc: 'Opret et ticket og få hjælp af Debbies support.',
        ticketUpgradeToGetAccess: 'Opgrader jeres support-pakke for at flere kan få adgang til Debbies ticket-support',
        contactPerson: 'Kontaktperson',
        contactPersonDesc: 'Tag fat på en af jeres kontaktpersoner, hvis du har brug for hjælp',
        contactPersonEmailSubject: 'Hjælp til Debbie',
        contactPersonEmailBody: `Hej,
Jeg har brug for hjælp til ...`,
        incidentsHeader: 'Incidents',
        incidentsDescription: 'Hvis du støder på et problem, uanset størrelse, må du meget gerne indrapportere det. Det kan være fejl, nedetid, eller uønskede hændelser. Vi er her for at hjælpe dig med at få det løst, så du kan komme tilbage til at nyde en problemfri oplevelse.',
        incidentsButton: 'Rapporter et problem',
        featureRequestsHeader: 'Feature Requests',
        featureRequestsDescription: 'Hvis du har en idé til en ny funktion eller forbedring af en eksisterende funktion, vil vi meget gerne høre det! Del dine tanker med os, og vi vil tage dem med i betragtning, mens vi arbejder på at gøre vores løsning endnu bedre.',
        featureRequestsButton: 'Anmod om en ny funktion',
        requestForConsultancyHeader: 'Konsulentarbejde',
        requestForConsultancyDescription: 'Har du brug for hjælp til noget ud over det sædvanlige? Vi tilbyder konsulentarbejde, hvor vi kan hjælpe dig med at udvikle integrationer, rapporteringer og meget mere.',
        requestForConsultancyButton: 'Indhent tilbud',
        requestForConsultancyEmailSubject: 'Konsulentarbejde',
        requestForConsultancyEmailBody: `Hej Debbie,
Vi kunne godt tænke os ...`,
    },
    interestFromLabels: {
        [voucher_applications_1.InterestFrom.Date]: 'from creation date',
        [voucher_applications_1.InterestFrom.DueDate]: 'from due date',
    },
    todoQueue: {
        sorting: 'Sorting',
        oldest: 'Oldest',
        creditScore: 'Credit score',
    },
    languages: {
        aa: 'Afar',
        ab: 'Abkhazian',
        ae: 'Avestan',
        af: 'Afrikaans',
        ak: 'Akan',
        am: 'Amharic',
        an: 'Aragonese',
        ar: 'Arabic',
        as: 'Assamese',
        av: 'Avaric',
        ay: 'Aymara',
        az: 'Azerbaijani',
        ba: 'Bashkir',
        be: 'Belarusian',
        bg: 'Bulgarian',
        bh: 'Bihari languages',
        bi: 'Bislama',
        bm: 'Bambara',
        bn: 'Bengali',
        bo: 'Tibetan',
        br: 'Breton',
        bs: 'Bosnian',
        ca: 'Catalan',
        ce: 'Chechen',
        ch: 'Chamorro',
        co: 'Corsican',
        cr: 'Cree',
        cs: 'Czech',
        cu: 'Church Slavic',
        cv: 'Chuvash',
        cy: 'Welsh',
        da: 'Danish',
        de: 'German',
        dv: 'Maldivian',
        dz: 'Dzongkha',
        ee: 'Ewe',
        el: 'Greek (modern)',
        en: 'English',
        eo: 'Esperanto',
        es: 'Spanish',
        et: 'Estonian',
        eu: 'Basque',
        fa: 'Persian',
        ff: 'Fulah',
        fi: 'Finnish',
        fj: 'Fijian',
        fo: 'Faroese',
        fr: 'French',
        fy: 'Western Frisian',
        ga: 'Irish',
        gd: 'Gaelic',
        gl: 'Galician',
        gn: 'Guaraní',
        gu: 'Gujarati',
        gv: 'Manx',
        ha: 'Hausa',
        he: 'Hebrew (modern)',
        hi: 'Hindi',
        ho: 'Hiri Motu',
        hr: 'Croatian',
        ht: 'Haitian Creole',
        hu: 'Hungarian',
        hy: 'Armenian',
        hz: 'Herero',
        ia: 'Interlingua',
        id: 'Indonesian',
        ie: 'Interlingue',
        ig: 'Igbo',
        ii: 'Nuosu',
        ik: 'Inupiaq',
        io: 'Ido',
        is: 'Icelandic',
        it: 'Italian',
        iu: 'Inuktitut',
        ja: 'Japanese',
        jv: 'Javanese',
        ka: 'Georgian',
        kg: 'Kongo',
        ki: 'Kikuyu',
        kj: 'Kwanyama',
        kk: 'Kazakh',
        kl: 'Greenlandic',
        km: 'Central Khmer',
        kn: 'Kannada',
        ko: 'Korean',
        kr: 'Kanuri',
        ks: 'Kashmiri',
        ku: 'Kurdish',
        kv: 'Komi',
        kw: 'Cornish',
        ky: 'Kyrgyz',
        la: 'Latin',
        lb: 'Luxembourgish',
        lg: 'Ganda',
        li: 'Limburgish',
        ln: 'Lingala',
        lo: 'Lao',
        lt: 'Lithuanian',
        lu: 'Luba-Katanga',
        lv: 'Latvian',
        mg: 'Malagasy',
        mh: 'Marshallese',
        mi: 'Maori',
        mk: 'Macedonian',
        ml: 'Malayalam',
        mn: 'Mongolian',
        mr: 'Marathi',
        ms: 'Malay',
        mt: 'Maltese',
        my: 'Burmese',
        na: 'Nauru',
        nb: 'Bokmål',
        nd: 'North Ndebele',
        ne: 'Nepali',
        ng: 'Ndonga',
        nl: 'Dutch',
        nn: 'Norwegian Nynorsk',
        no: 'Norwegian',
        nr: 'South Ndebele',
        nv: 'Navajo',
        ny: 'Nyanja',
        oc: 'Occitan',
        oj: 'Ojibwa',
        om: 'Oromo',
        or: 'Oriya',
        os: 'Ossetian',
        pa: 'Punjabi',
        pi: 'Pali',
        pl: 'Polish',
        ps: 'Pashto',
        pt: 'Portuguese',
        qu: 'Quechua',
        rm: 'Romansh',
        rn: 'Rundi',
        ro: 'Romanian',
        ru: 'Russian',
        rw: 'Kinyarwanda',
        sa: 'Sanskrit',
        sc: 'Sardinian',
        sd: 'Sindhi',
        se: 'Northern Sami',
        sg: 'Sango',
        si: 'Sinhalese',
        sk: 'Slovak',
        sl: 'Slovenian',
        sm: 'Samoan',
        sn: 'Shona',
        so: 'Somali',
        sq: 'Albanian',
        sr: 'Serbian',
        ss: 'Swati',
        st: 'Southern Sotho',
        su: 'Sundanese',
        sv: 'Swedish',
        sw: 'Swahili',
        ta: 'Tamil',
        te: 'Telugu',
        tg: 'Tajik',
        th: 'Thai',
        ti: 'Tigrinya',
        tk: 'Turkmen',
        tl: 'Tagalog',
        tn: 'Tswana',
        to: 'Tonga',
        tr: 'Turkish',
        ts: 'Tsonga',
        tt: 'Tatar',
        tw: 'Twi',
        ty: 'Tahitian',
        ug: 'Uyghur',
        uk: 'Ukrainian',
        ur: 'Urdu',
        uz: 'Uzbek',
        ve: 'Venda',
        vi: 'Vietnamese',
        vo: 'Volapük',
        wa: 'Walloon',
        wo: 'Wolof',
        xh: 'Xhosa',
        yi: 'Yiddish',
        yo: 'Yoruba',
        za: 'Zhuang',
        zh: 'Chinese',
        zu: 'Zulu',
    },
    weekdays: {
        0: 'Monday',
        1: 'Tuesday',
        2: 'Wednesday',
        3: 'Thursday',
        4: 'Friday',
        5: 'Saturday',
        6: 'Sunday',
    },
};
//# sourceMappingURL=en.js.map